var _style, _rect, _text, _rect2, _defs, _g, _defs2, _g2, _defs3, _g3, _g4, _path, _path2, _g5, _g6, _g7, _g8, _g9, _path3, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _defs4, _path4, _g18, _defs5, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g38, _defs6, _g39, _defs7, _g40, _defs8, _g41, _defs9, _g42, _g43, _g44, _g45, _defs0, _g46, _defs1, _g47, _g48, _path18, _g49, _g50, _defs10, _g51, _g52, _g53, _g54, _g55, _defs11, _g56, _defs12, _g57, _rect3, _rect4, _rect5, _rect6, _g58;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarteAgrobachelor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 1785",
    style: {
      enableBackground: "new 0 0 750 1785"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#F6C459;}\n\t.st1{fill:#213D33;}\n\t.st2{font-family:'ArialMT';}\n\t.st3{font-size:20px;}\n\t.st4{fill:#26A863;}\n\t.st5{clip-path:url(#SVGID_2_);}\n\t.st6{fill:#A3EA8C;}\n\t.st7{fill:#5DC12F;}\n\t.st8{clip-path:url(#SVGID_4_);}\n\t.st9{fill:#8ED679;}\n\t.st10{fill:#55961D;}\n\t.st11{clip-path:url(#SVGID_6_);}\n\t.st12{fill:#4AD381;}\n\t.st13{fill:#249451;}\n\t.st14{fill:none;stroke:#6BC5F7;stroke-width:20;stroke-miterlimit:10;}\n\t.st15{fill:#7FA195;}\n\t.st16{fill:#7F5A41;}\n\t.st17{fill:none;stroke:#213D33;stroke-width:2;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#213D33;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:12.8884,8.5922;}\n\t.st19{clip-path:url(#SVGID_8_);}\n\t.st20{fill:#062265;}\n\t.st21{fill:#FFFFFF;}\n\t.st22{clip-path:url(#SVGID_10_);}\n\t.st23{fill:#B82B35;}\n\t.st24{fill:#A43138;}\n\t.st25{fill:#3B3C6B;}\n\t.st26{fill:#E7B7B7;}\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#DD6F31;}\n\t.st28{fill:none;stroke:#213D33;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st29{fill:#F6C459;}\n\t.st30{clip-path:url(#SVGID_12_);}\n\t.st31{clip-path:url(#SVGID_14_);}\n\t.st32{clip-path:url(#SVGID_16_);}\n\t.st33{clip-path:url(#SVGID_18_);}\n\t.st34{clip-path:url(#SVGID_20_);}\n\t.st35{clip-path:url(#SVGID_22_);}\n\t.st36{fill:#FBC13D;}\n\t.st37{display:none;fill:#F6C459;}\n\t.st38{fill:none;stroke:#213D33;stroke-width:0.75;}\n\t.st39{fill-rule:evenodd;clip-rule:evenodd;fill:#26A863;}\n\t.st40{fill:#190B02;}\n\t.st41{clip-path:url(#SVGID_24_);}\n\t.st42{fill:#F59692;}\n\t.st43{fill:#DD706B;}\n\t.st44{clip-path:url(#SVGID_26_);}\n\t.st45{clip-path:url(#SVGID_28_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 522.2,
    y: 285,
    className: "st0",
    width: 108.1,
    height: 40.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 542.7723 312.0281)",
    className: "st1 st2 st3"
  }, "DD TBS")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.6,
    className: "st4",
    width: 749.8,
    height: 1784.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "203.8,743.7 0.2,746 0.2,421.6 203.8,420.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 519.6,
    className: "st6",
    width: 146.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 514.7,
    className: "st7",
    width: 146.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 503.8,
    className: "st6",
    width: 146.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 499,
    className: "st7",
    width: 146.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 487.7,
    className: "st6",
    width: 146.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 482.8,
    className: "st7",
    width: 146.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 472,
    className: "st6",
    width: 146.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 467.1,
    className: "st7",
    width: 146.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 455.9,
    className: "st6",
    width: 146.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 451,
    className: "st7",
    width: 146.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 440.1,
    className: "st6",
    width: 146.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 424,
    className: "st6",
    width: 146.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 435.2,
    className: "st7",
    width: 146.6,
    height: 4.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_3_",
    points: "203.8,743.7 0.2,746 0.2,421.6 203.8,420.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 539.2,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 550.4,
    className: "st10",
    width: 148.1,
    height: 4.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 555.3,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 566.5,
    className: "st10",
    width: 148.1,
    height: 4.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 571.3,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 582.5,
    className: "st10",
    width: 148.1,
    height: 4.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 587.4,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 598.6,
    className: "st10",
    width: 148.1,
    height: 4.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 603.5,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 614.7,
    className: "st10",
    width: 148.1,
    height: 4.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 619.7,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 630.8,
    className: "st10",
    width: 148.1,
    height: 4.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 635.7,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 646.9,
    className: "st10",
    width: 148.1,
    height: 4.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 651.8,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 663,
    className: "st10",
    width: 148.1,
    height: 4.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 667.8,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 679.1,
    className: "st10",
    width: 148.1,
    height: 4.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 683.9,
    className: "st9",
    width: 148.1,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -40.3,
    y: 695.2,
    className: "st10",
    width: 148.1,
    height: 4.9
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_5_",
    points: "203.8,743.7 0.2,746 0.2,421.6 203.8,420.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M127.8,571.8v128.8h-11.2V561.3C119.8,565.4,123.6,569,127.8,571.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M132.7,574.6v126h-4.9V571.8C129.4,572.8,131,573.8,132.7,574.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143.9,578.5v122.1h-11.2v-126C136.2,576.4,140,577.7,143.9,578.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M148.8,579.2v121.4h-4.9V578.5C145.5,578.8,147.2,579.1,148.8,579.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M160,579.5v121.2h-11.2V579.2c1.5,0.1,2.9,0.2,4.4,0.2L160,579.5L160,579.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 579.5,
    className: "st13",
    width: 4.9,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.9,
    y: 579.5,
    className: "st12",
    width: 11.2,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 579.5,
    className: "st12",
    width: 11.2,
    height: 121.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.1,
    y: 579.5,
    className: "st13",
    width: 4.9,
    height: 121.2
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 653.6,
    y: 961.5,
    className: "st6",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.7,
    y: 961.4,
    className: "st7",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.6,
    y: 961.4,
    className: "st6",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680.8,
    y: 961.5,
    className: "st7",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M632.6,961.5v27.8c-3.3-2.8-7.1-5.1-11.2-6.8v-21H632.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M637.5,961.5V994c-1.5-1.7-3.1-3.3-4.9-4.8v-27.8L637.5,961.5L637.5,961.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M648.7,961.5v62.1c0-11.3-4.2-21.7-11.2-29.5v-32.6H648.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.6,
    y: 961.4,
    className: "st7",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.7,
    y: 961.4,
    className: "st6",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.8,
    y: 961.4,
    className: "st7",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.8,
    y: 961.5,
    className: "st6",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.9,
    y: 961.4,
    className: "st7",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 717.8,
    y: 961.4,
    className: "st6",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 729,
    y: 961.5,
    className: "st7",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.9,
    y: 961.4,
    className: "st6",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.1,
    y: 961.4,
    className: "st7",
    width: 4.9,
    height: 130.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 961.4,
    className: "st12",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.4,
    y: 961.4,
    className: "st13",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 515.1,
    y: 961.5,
    className: "st12",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526.2,
    y: 961.4,
    className: "st13",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.1,
    y: 961.4,
    className: "st12",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.3,
    y: 961.5,
    className: "st13",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 546.9,
    y: 961.4,
    className: "st12",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 961.4,
    className: "st13",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563,
    y: 961.5,
    className: "st12",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 574.1,
    y: 961.4,
    className: "st13",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 578.7,
    y: 961.4,
    className: "st12",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.8,
    y: 961.4,
    className: "st12",
    width: 11.2,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589.9,
    y: 961.5,
    className: "st13",
    width: 4.9,
    height: 130.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.9,
    y: 961.4,
    className: "st13",
    width: 4.9,
    height: 130.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 878.9,
    className: "st9",
    width: 250.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 890.1,
    className: "st10",
    width: 250.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 894.6,
    className: "st9",
    width: 250.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 905.8,
    className: "st10",
    width: 250.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 910.7,
    className: "st9",
    width: 250.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 921.9,
    className: "st10",
    width: 250.7,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 926.5,
    className: "st9",
    width: 250.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 942.6,
    className: "st9",
    width: 250.7,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.3,
    y: 937.7,
    className: "st10",
    width: 250.7,
    height: 4.9
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M0,68.6h305c16.6,0,30-13.4,30-30v-38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M0,1323.5h82c16.6,0,30,17.6,30,39.3v57.6v110.9c0,16.6,13.4,30,30,30h519.9c16.6,0,30,13.4,30,30v193.5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399,
    y: 24.2,
    className: "st9",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.1,
    y: 24.1,
    className: "st10",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.8,
    y: 24.1,
    className: "st9",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.9,
    y: 24.2,
    className: "st10",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.8,
    y: 24.1,
    className: "st9",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 24.2,
    className: "st10",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 24.2,
    className: "st9",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.7,
    y: 24.2,
    className: "st9",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.7,
    y: 24.1,
    className: "st10",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.8,
    y: 24.2,
    className: "st10",
    width: 4.9,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.7,
    y: 24.1,
    className: "st9",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.8,
    y: 24.2,
    className: "st9",
    width: 11.2,
    height: 138.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.9,
    y: 24.2,
    className: "st10",
    width: 4.9,
    height: 138.7
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 151.7,
    className: "st12",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 146.9,
    className: "st13",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 136,
    className: "st12",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 131.1,
    className: "st13",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 120,
    className: "st12",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 115,
    className: "st13",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 104.1,
    className: "st12",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 99.3,
    className: "st13",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 88.1,
    className: "st12",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 83.2,
    className: "st13",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 72.4,
    className: "st12",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 56.2,
    className: "st12",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 67.5,
    className: "st13",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 51.3,
    className: "st13",
    width: 223.6,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 40.2,
    className: "st12",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 24.1,
    className: "st12",
    width: 223.6,
    height: 11.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 526,
    y: 35.3,
    className: "st13",
    width: 223.6,
    height: 4.9
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 59.4,
    cy: 41.5,
    r: 13.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 62.8,
    cy: 52.6,
    r: 13.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 71,
    cy: 31.8,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 78.8,
    cy: 36,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 76.6,
    cy: 57.5,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 73.9,
    cy: 45.1,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 85.3,
    cy: 46,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 46.3,
    cy: 46.2,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 48.2,
    cy: 55.6,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 84.6,
    cy: 56.8,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M47.8,47.3c6.7,4.6,16.6,9.2,17.9,18c0.3,10.1,1.2,21.5-3.4,30.6c-0.1,0.1,0,0.3,0.2,0.3h13.3 c0.1,0,0.2-0.1,0.2-0.3c-3-6.3-2.8-12.8-3.9-19.7l0,0c-1.2-6-1.6-10.5,3.5-14.9c2-2,4.1-4.1,6-6.2c2-1.5,3.3-2.6,4.3-5.3 c0.4-1,0.4-1.9,0.3-1.6c-1.1,4.8-6.4,7.3-10.1,10.2c1.5-3.5,2.5-8.5,2.7-12c-1.2,4.1-1.4,9.4-4.3,12.9c-1.7,1.1-3.8,2-4.9,3.9 c-4.8-6.3-0.7-14.8-2.9-21.7c-0.8-2.6,0.5,3,0,4.4c0,3.5-1,6.9-1.5,10.3c-4.6-2.3-8.1-4.6-9.1-9.9l0,0c-1.1-1.8-1.3-4.1-2.1-5.7 c0.9,4.1,1.8,8.1,4.1,11.8c-2.4-1-5.5-3.1-7.6-4C49.9,48.4,42.7,43.6,47.8,47.3z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 232,
    cy: 1538,
    r: 12.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 235.3,
    cy: 1548.8,
    r: 12.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 243.3,
    cy: 1528.5,
    r: 5.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3162 -0.9487 0.9487 0.3162 -1282.5333 1285.7996)",
    className: "st15",
    cx: 250.7,
    cy: 1532.6,
    rx: 7.5,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3162 -0.9487 0.9487 0.3162 -1303.7283 1298.1932)",
    className: "st15",
    cx: 248.7,
    cy: 1553.5,
    rx: 7.5,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 246,
    cy: 1541.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 257.1,
    cy: 1542.4,
    r: 11.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 219.3,
    cy: 1542.5,
    r: 6.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 221.1,
    cy: 1551.7,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 256.4,
    cy: 1552.8,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M220.8,1543.6c6.5,4.5,16.1,8.9,17.4,17.5c0.3,9.8,1.2,20.8-3.3,29.7c-0.1,0.1,0,0.3,0.2,0.3H248 c0.1,0,0.2-0.1,0.2-0.3c-2.9-6.1-2.7-12.4-3.8-19.1l0,0c-1.2-5.8-1.5-10.2,3.4-14.5c2-2,4-4,5.9-6c2-1.4,3.2-2.5,4.2-5.1 c0.4-1,0.4-1.8,0.3-1.5c-1.1,4.7-6.2,7-9.8,9.9c1.5-3.4,2.4-8.3,2.6-11.6c-1.2,4-1.4,9.1-4.2,12.5c-1.7,1.1-3.7,1.9-4.7,3.8 c-4.7-6.1-0.7-14.4-2.9-21c-0.7-2.5,0.5,2.9,0,4.2c0,3.4-1,6.7-1.5,10c-4.5-2.2-7.8-4.5-8.9-9.6l0,0c-1-1.7-1.2-4-2-5.5 c0.9,4,1.8,7.9,4,11.4c-2.4-0.9-5.3-3-7.3-3.9C222.7,1544.7,215.8,1540,220.8,1543.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.652058e-02 -0.9978 0.9978 6.652058e-02 -330.8587 450.956)",
    className: "st15",
    cx: 75.6,
    cy: 402.3,
    rx: 12.2,
    ry: 12.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 78.8,
    cy: 412.7,
    r: 12.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 86.5,
    cy: 393.3,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 93.7,
    cy: 397.2,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 91.7,
    cy: 417.3,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 89.1,
    cy: 405.7,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 99.9,
    cy: 406.6,
    r: 10.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 63.4,
    cy: 406.7,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 65.2,
    cy: 415.5,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 99.2,
    cy: 416.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M64.8,407.7c6.2,4.3,15.5,8.5,16.7,16.9c0.3,9.4,1.1,20-3.2,28.5c-0.1,0.1,0,0.3,0.2,0.3H91 c0.1,0,0.2-0.1,0.2-0.3c-2.8-5.9-2.6-12-3.6-18.4l0,0c-1.1-5.6-1.5-9.8,3.3-13.9c1.9-1.9,3.8-3.8,5.6-5.8c1.9-1.4,3.1-2.4,4-4.9 c0.4-0.9,0.4-1.8,0.3-1.4c-1.1,4.5-6,6.8-9.4,9.6c1.4-3.3,2.3-8,2.5-11.2c-1.2,3.9-1.3,8.8-4,12c-1.6,1.1-3.6,1.8-4.6,3.6 c-4.5-5.9-0.7-13.9-2.7-20.2c-0.7-2.4,0.4,2.8,0,4.1c0,3.2-0.9,6.5-1.4,9.7c-4.3-2.1-7.5-4.3-8.5-9.2l0,0c-1-1.6-1.2-3.8-2-5.3 c0.8,3.8,1.7,7.6,3.8,11c-2.3-0.9-5.1-2.9-7.1-3.8C66.7,408.8,60,404.3,64.8,407.7z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M750,467.6H621.4c-16.6,0-30,13.4-30,30v183.2c0,16.6,13.4,30,30,30H750"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 674.6,
    cy: 483.9,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 678.9,
    cy: 498.2,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 689.5,
    cy: 471.4,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 699.5,
    cy: 476.8,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 696.7,
    cy: 504.5,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 693.2,
    cy: 488.5,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 707.9,
    cy: 489.7,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 657.8,
    cy: 489.9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 660.2,
    cy: 502,
    r: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 707,
    cy: 503.6,
    r: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M659.7,491.3c8.6,6,21.4,11.8,23.1,23.2c0.4,13,1.6,27.6-4.4,39.3c-0.1,0.2,0,0.3,0.2,0.3h17.2 c0.2,0,0.3-0.2,0.2-0.3c-3.9-8.1-3.6-16.5-5-25.3l0,0c-1.5-7.7-2-13.5,4.5-19.2c2.6-2.6,5.3-5.2,7.8-7.9c2.6-1.9,4.3-3.3,5.5-6.8 c0.5-1.3,0.5-2.4,0.4-2c-1.5,6.2-8.3,9.3-13,13.2c2-4.5,3.2-11,3.4-15.4c-1.6,5.3-1.9,12.1-5.5,16.5c-2.2,1.5-4.9,2.5-6.3,5 c-6.2-8.1-0.9-19.1-3.8-27.9c-1-3.4,0.6,3.9,0,5.6c0,4.5-1.3,8.9-2,13.3c-5.9-2.9-10.4-5.9-11.7-12.7l0,0c-1.4-2.3-1.6-5.3-2.7-7.3 c1.1,5.3,2.4,10.4,5.3,15.2c-3.1-1.3-7.1-4-9.7-5.2C662.3,492.8,653.1,486.5,659.7,491.3z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.652065e-02 -0.9978 0.9978 6.652065e-02 -827.0657 1242.3822)",
    className: "st1",
    cx: 250.5,
    cy: 1063.2,
    rx: 16.8,
    ry: 16.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.652065e-02 -0.9978 0.9978 6.652065e-02 -837.2276 1260.1207)",
    className: "st1",
    cx: 254.9,
    cy: 1077.5,
    rx: 16.8,
    ry: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 265.5,
    cy: 1050.7,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 275.4,
    cy: 1056.1,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 272.6,
    cy: 1083.8,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 269.1,
    cy: 1067.8,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.9,
    cy: 1069,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 233.7,
    cy: 1069.2,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 236.1,
    cy: 1081.4,
    r: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283,
    cy: 1082.9,
    r: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M235.6,1070.6c8.6,6,21.4,11.8,23.1,23.2c0.4,13,1.6,27.6-4.4,39.3c-0.1,0.2,0,0.3,0.2,0.3h17.2 c0.2,0,0.3-0.2,0.2-0.3c-3.9-8.1-3.6-16.5-5-25.3l0,0c-1.5-7.7-2-13.5,4.5-19.2c2.6-2.6,5.3-5.2,7.8-7.9c2.6-1.9,4.3-3.3,5.5-6.8 c0.5-1.3,0.5-2.4,0.4-2c-1.5,6.2-8.3,9.3-13,13.2c2-4.5,3.2-11,3.4-15.4c-1.6,5.3-1.9,12.1-5.5,16.5c-2.2,1.5-4.9,2.5-6.3,5 c-6.2-8.1-0.9-19.1-3.8-27.9c-1-3.4,0.6,3.9,0,5.6c0,4.5-1.3,8.9-2,13.3c-5.9-2.9-10.4-5.9-11.7-12.7l0,0c-1.4-2.3-1.6-5.3-2.7-7.3 c1.1,5.3,2.4,10.4,5.3,15.2c-3.1-1.3-7.1-4-9.7-5.2C238.3,1072.1,229,1065.9,235.6,1070.6z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 475.8,
    cy: 571.8,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 480.1,
    cy: 586.1,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 490.8,
    cy: 559.2,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 500.7,
    cy: 564.6,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.9,
    cy: 592.3,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 494.4,
    cy: 576.4,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 509.2,
    cy: 577.6,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 459,
    cy: 577.8,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 461.4,
    cy: 589.9,
    r: 6.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -269.3311 532.5842)",
    className: "st1",
    cx: 508.2,
    cy: 591.4,
    rx: 5.4,
    ry: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M460.9,579.2c8.6,6,21.4,11.8,23.1,23.2c0.4,13,1.6,27.6-4.4,39.3c-0.1,0.2,0,0.3,0.2,0.3H497 c0.2,0,0.3-0.2,0.2-0.3c-3.9-8.1-3.6-16.5-5-25.3l0,0c-1.5-7.7-2-13.5,4.5-19.2c2.6-2.6,5.3-5.2,7.8-7.9c2.6-1.9,4.3-3.3,5.5-6.8 c0.5-1.3,0.5-2.4,0.4-2c-1.5,6.2-8.3,9.3-13,13.2c2-4.5,3.2-11,3.4-15.4c-1.6,5.3-1.9,12.1-5.5,16.5c-2.2,1.5-4.9,2.5-6.3,5 c-6.2-8.1-0.9-19.1-3.8-27.9c-1-3.4,0.6,3.9,0,5.6c0,4.5-1.3,8.9-2,13.3c-5.9-2.9-10.4-5.9-11.7-12.7l0,0c-1.4-2.3-1.6-5.3-2.7-7.3 c1.1,5.3,2.4,10.4,5.3,15.2c-3.1-1.3-7.1-4-9.7-5.2C463.5,580.7,454.3,574.4,460.9,579.2z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 175.2,
    cy: 1579.4,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 179.6,
    cy: 1593.7,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 190.2,
    cy: 1566.9,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 200.1,
    cy: 1572.2,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 197.3,
    cy: 1600,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 193.8,
    cy: 1584,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 208.6,
    cy: 1585.2,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 158.4,
    cy: 1585.4,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 160.8,
    cy: 1597.5,
    r: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 207.7,
    cy: 1599,
    r: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M160.3,1586.8c8.6,6,21.4,11.8,23.1,23.2c0.4,13,1.6,27.6-4.4,39.3c-0.1,0.2,0,0.3,0.2,0.3h17.2 c0.2,0,0.3-0.2,0.2-0.3c-3.9-8.1-3.6-16.5-5-25.3l0,0c-1.5-7.7-2-13.5,4.5-19.2c2.6-2.6,5.3-5.2,7.8-7.9c2.6-1.9,4.3-3.3,5.5-6.8 c0.5-1.3,0.5-2.4,0.4-2c-1.5,6.2-8.3,9.3-13,13.2c2-4.5,3.2-11,3.4-15.4c-1.6,5.3-1.9,12.1-5.5,16.5c-2.2,1.5-4.9,2.5-6.3,5 c-6.2-8.1-0.9-19.1-3.8-27.9c-1-3.4,0.6,3.9,0,5.6c0,4.5-1.3,8.9-2,13.3c-5.9-2.9-10.4-5.9-11.7-12.7l0,0c-1.4-2.3-1.6-5.3-2.7-7.3 c1.1,5.3,2.4,10.4,5.3,15.2c-3.1-1.3-7.1-4-9.7-5.2C163,1588.3,153.7,1582,160.3,1586.8z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 581.1,
    cy: 828.5,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 583.2,
    cy: 835.4,
    r: 8.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 588.4,
    cy: 822.4,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 593.2,
    cy: 825,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 591.8,
    cy: 838.5,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 590.1,
    cy: 830.7,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 597.3,
    cy: 831.3,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 573,
    cy: 831.4,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 574.1,
    cy: 837.3,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 596.8,
    cy: 838,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M573.9,832.1c4.2,2.9,10.4,5.7,11.2,11.3c0.2,6.3,0.8,13.4-2.2,19.1c0,0.1,0,0.2,0.1,0.2h8.3 c0.1,0,0.1-0.1,0.1-0.2c-1.9-3.9-1.8-8-2.4-12.3l0,0c-0.7-3.7-1-6.6,2.2-9.3c1.3-1.3,2.6-2.5,3.8-3.8c1.3-0.9,2.1-1.6,2.7-3.3 c0.2-0.6,0.2-1.2,0.2-1c-0.7,3-4,4.5-6.3,6.4c1-2.2,1.5-5.3,1.7-7.5c-0.8,2.6-0.9,5.9-2.7,8c-1.1,0.7-2.4,1.2-3.1,2.4 c-3-3.9-0.5-9.2-1.8-13.5c-0.5-1.6,0.3,1.9,0,2.7c0,2.2-0.6,4.3-1,6.5c-2.9-1.4-5-2.9-5.7-6.2l0,0c-0.7-1.1-0.8-2.6-1.3-3.6 c0.6,2.6,1.1,5,2.6,7.4c-1.5-0.6-3.4-1.9-4.7-2.5C575.2,832.8,570.7,829.8,573.9,832.1z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 537.3,
    cy: 1134.6,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 540.6,
    cy: 1145.7,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 548.8,
    cy: 1125,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 556.5,
    cy: 1129.1,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 554.3,
    cy: 1150.5,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 551.6,
    cy: 1138.2,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 563,
    cy: 1139.1,
    r: 11.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 524.3,
    cy: 1139.3,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 526.1,
    cy: 1148.7,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 562.3,
    cy: 1149.8,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M525.8,1140.4c6.6,4.6,16.5,9.1,17.8,17.9c0.3,10,1.2,21.3-3.4,30.4c-0.1,0.1,0,0.3,0.2,0.3h13.3 c0.1,0,0.2-0.1,0.2-0.3c-3-6.3-2.8-12.7-3.8-19.6l0,0c-1.2-6-1.6-10.5,3.5-14.8c2-2,4.1-4,6-6.1c2-1.5,3.3-2.5,4.3-5.2 c0.4-1,0.4-1.9,0.3-1.5c-1.1,4.8-6.4,7.2-10,10.2c1.5-3.5,2.4-8.5,2.7-11.9c-1.2,4.1-1.4,9.4-4.3,12.8c-1.7,1.1-3.8,1.9-4.9,3.9 c-4.8-6.3-0.7-14.7-2.9-21.5c-0.8-2.6,0.5,3,0,4.3c0,3.4-1,6.9-1.5,10.3c-4.6-2.3-8-4.6-9.1-9.8l0,0c-1-1.7-1.2-4.1-2.1-5.7 c0.9,4.1,1.8,8,4.1,11.7c-2.4-1-5.5-3.1-7.5-4C527.8,1141.5,520.7,1136.7,525.8,1140.4z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 508.7,
    cy: 600.6,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 512,
    cy: 611.6,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 520.2,
    cy: 590.9,
    r: 5.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 527.9,
    cy: 595.1,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 525.8,
    cy: 616.5,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 523,
    cy: 604.1,
    r: 7.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 534.5,
    cy: 605.1,
    r: 11.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 495.7,
    cy: 605.2,
    r: 6.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 497.5,
    cy: 614.6,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 533.7,
    cy: 615.8,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M497.2,606.3c6.6,4.6,16.5,9.1,17.8,17.9c0.3,10,1.2,21.3-3.4,30.4c-0.1,0.1,0,0.3,0.2,0.3H525 c0.1,0,0.2-0.1,0.2-0.3c-3-6.3-2.8-12.7-3.8-19.6l0,0c-1.2-6-1.6-10.5,3.5-14.8c2-2,4.1-4,6-6.1c2-1.5,3.3-2.5,4.3-5.2 c0.4-1,0.4-1.9,0.3-1.5c-1.1,4.8-6.4,7.2-10,10.2c1.5-3.5,2.4-8.5,2.7-11.9c-1.2,4.1-1.4,9.4-4.3,12.8c-1.7,1.1-3.8,1.9-4.9,3.9 c-4.8-6.3-0.7-14.7-2.9-21.5c-0.8-2.6,0.5,3,0,4.3c0,3.4-1,6.9-1.5,10.3c-4.6-2.3-8-4.6-9.1-9.8l0,0c-1-1.7-1.2-4.1-2.1-5.7 c0.9,4.1,1.8,8,4.1,11.7c-2.4-1-5.5-3.1-7.5-4C499.2,607.4,492.1,602.6,497.2,606.3z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 17.8,
    cy: 498.4,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20.1,
    cy: 506,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 25.8,
    cy: 491.7,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 31,
    cy: 494.6,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.6,
    cy: 509.3,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.7,
    cy: 500.8,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 35.5,
    cy: 501.5,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 8.9,
    cy: 501.5,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 10.2,
    cy: 508,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 35,
    cy: 508.8,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M9.9,502.3c4.6,3.2,11.3,6.2,12.2,12.3c0.2,6.9,0.8,14.6-2.4,20.8c0,0.1,0,0.2,0.1,0.2H29 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.3-1.9-8.7-2.6-13.4l0,0c-0.8-4.1-1.1-7.2,2.4-10.2c1.4-1.4,2.8-2.8,4.1-4.2c1.4-1,2.3-1.7,2.9-3.6 c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.3-4.4,4.9-6.9,7c1-2.4,1.7-5.8,1.8-8.2c-0.8,2.8-1,6.4-2.9,8.8c-1.2,0.8-2.6,1.3-3.3,2.6 c-3.3-4.3-0.5-10.1-2-14.8c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.7-1.1,7.1c-3.1-1.6-5.5-3.2-6.2-6.7l0,0c-0.7-1.2-0.9-2.8-1.4-3.9 c0.6,2.8,1.3,5.5,2.8,8c-1.7-0.7-3.8-2.1-5.2-2.7C11.3,503.1,6.4,499.8,9.9,502.3z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 486.1,
    cy: 48.2,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 489.3,
    cy: 58.8,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 497.2,
    cy: 38.9,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 504.6,
    cy: 42.9,
    r: 7.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 502.6,
    cy: 63.5,
    r: 7.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 499.9,
    cy: 51.6,
    r: 7.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 511,
    cy: 52.5,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 473.6,
    cy: 52.7,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 475.3,
    cy: 61.7,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 510.3,
    cy: 62.8,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M475,53.7c6.4,4.5,15.9,8.8,17.2,17.3c0.3,9.7,1.2,20.6-3.3,29.3c-0.1,0.1,0,0.3,0.2,0.3h12.8 c0.1,0,0.2-0.1,0.2-0.3c-2.9-6-2.7-12.3-3.7-18.9l0,0c-1.1-5.8-1.5-10.1,3.3-14.3c2-1.9,3.9-3.9,5.8-5.9c2-1.4,3.2-2.4,4.1-5 c0.4-1,0.4-1.8,0.3-1.5c-1.1,4.6-6.2,7-9.7,9.8c1.5-3.4,2.4-8.2,2.6-11.5c-1.2,4-1.4,9-4.1,12.3c-1.6,1.1-3.7,1.9-4.7,3.7 c-4.6-6.1-0.7-14.2-2.8-20.8c-0.7-2.5,0.4,2.9,0,4.2c0,3.3-1,6.7-1.5,9.9c-4.4-2.2-7.7-4.4-8.8-9.5l0,0c-1-1.7-1.2-3.9-2-5.5 c0.8,3.9,1.8,7.8,3.9,11.3c-2.3-0.9-5.3-3-7.2-3.9C476.9,54.8,470.1,50.2,475,53.7z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M195,539.4c0-2,0.1-4,0.3-6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M196.7,525c6.5-26.7,30.6-46.5,59.3-46.5c7.5,0,14.8,1.4,21.4,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M281.4,484c1.8,0.8,3.6,1.8,5.3,2.8"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 231.7,
    y: 609.2,
    transform: "matrix(0.9889 -0.1485 0.1485 0.9889 -90.0059 46.3142)",
    width: 66.9,
    height: 33.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M229.6,614.4l5,33.1l66.2-9.9l-5-33.1L229.6,614.4z"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M229.6,614.4l71.1,23.1 M295.8,604.4l-61.2,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "299.7,640.7 265.7,629.6 236.5,650.2 232.7,644.7 257.8,627.1 228.6,617.6 230.7,611.2  264.6,622.2 293.9,601.7 297.7,607.2 272.6,624.8 301.8,634.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_9_",
    points: "265.2,625.9 298.3,621 300.8,637.5 267.7,642.5 234.6,647.4 232.1,630.9 229.6,614.4  262.7,609.4 295.8,604.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.6,614.4l71.1,23.1 M295.8,604.4l-61.2,43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "300.1,639.6 265.6,628.4 235.9,649.3 233.3,645.6 260.3,626.7 228.9,616.5 230.3,612.3  264.8,623.5 294.5,602.6 297.1,606.3 270.1,625.2 301.4,635.4  "
  })))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M262.7,609.4l5,33.1 M232.1,630.9l66.2-9.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "273.2,641.7 262.2,643.3 260.5,632.3 232.9,636.4 231.3,625.4 258.9,621.3 257.2,610.2  268.2,608.6 269.9,619.6 297.4,615.5 299.1,626.5 271.5,630.6  "
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M262.7,609.4l5,33.1 M232.1,630.9l66.2-9.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st23",
    points: "271,642 264.4,643 262.4,629.7 232.6,634.2 231.6,627.6 261.4,623.1 259.4,609.9 266,608.9  268,622.1 297.8,617.7 298.8,624.3 269,628.8  "
  }))))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 568.5,
    transform: "matrix(0.2756 -0.9613 0.9613 0.2756 -360.162 725.951)",
    className: "st24",
    width: 35.2,
    height: 66.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273.1,579.7l64.3,18.4 M335.9,603.3l-64.3-18.4 M270.1,590.1l64.3,18.4 M332.9,613.7l-64.3-18.4 M267.1,600.5l64.3,18.4  M330,624.1l-64.3-18.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M329.6,625.5L265.3,607l0.7-2.6l64.3,18.4L329.6,625.5z M331.1,620.2l-64.3-18.4l0.7-2.6l64.3,18.4 L331.1,620.2z M332.6,615l-64.3-18.4l0.7-2.6l64.3,18.4L332.6,615z M334.1,609.8l-64.3-18.4l0.7-2.6l64.3,18.4L334.1,609.8z  M335.5,604.6l-64.3-18.4l0.7-2.6l64.3,18.4L335.5,604.6z M337,599.4L272.7,581l0.7-2.6l64.3,18.4L337,599.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 275.1,
    y: 575.2,
    transform: "matrix(0.2756 -0.9613 0.9613 0.2756 -359.6761 699.932)",
    className: "st25",
    width: 19,
    height: 26.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s18_00000096061133536025629950000011801859237841540998_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000025411097723473980620000002923169162244424380_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000089532378683698761620000000585476068375061925_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000065780592236690380040000017344224437595616957_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000077285543462403118390000004489399938009343162_",
    className: "st21",
    d: "M276.1,577.2l0.1,2.1l-1.3-1.6l2,0.6 L275,579L276.1,577.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000134959364043795016880000010840958841371096456_",
    className: "st21",
    d: "M275.1,580.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L275.1,580.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000060714103805698762930000007290901361609345170_",
    className: "st21",
    d: "M274.1,584.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L274.1,584.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000057841139335715022100000004002057731745021325_",
    className: "st21",
    d: "M273,588.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L273,588.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000048491132852062157870000012007040420074247604_",
    className: "st21",
    d: "M272,591.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L272,591.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000085954392133049971450000011893377401091959951_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000122687997244255198330000000164864827741722042_",
    className: "st21",
    d: "M277.8,579.6l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L277.8,579.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000117673958197021870910000018277907197738278300_",
    className: "st21",
    d: "M276.7,583.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L276.7,583.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000086653609190212820810000000930947457427874947_",
    className: "st21",
    d: "M275.7,586.9l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L275.7,586.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000046300602702560630230000010783465466292414380_",
    className: "st21",
    d: "M274.6,590.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L274.6,590.5z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000053521747824913426740000014984077549041622176_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000181069030455754368000000010030149770406180791_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000176025695190362396550000011036028106145161130_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000168837993378621908240000017639388587330109355_",
    className: "st21",
    d: "M280.4,578.4l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L280.4,578.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000137108830047663814990000003660160207390741399_",
    className: "st21",
    d: "M279.4,582l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L279.4,582z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000075148955655557918910000001824207079583558042_",
    className: "st21",
    d: "M278.3,585.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L278.3,585.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000121266987963752056790000008905823381651508394_",
    className: "st21",
    d: "M277.3,589.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L277.3,589.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000039843099277803658260000007142170726592514701_",
    className: "st21",
    d: "M276.3,593l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L276.3,593z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000083794182636881221120000002932783463413998254_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000086693990988852676590000018412190457423520396_",
    className: "st21",
    d: "M282.1,580.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L282.1,580.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000067225419095163826000000017265272643182905228_",
    className: "st21",
    d: "M281,584.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L281,584.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000032619921335263641540000010242755007831953312_",
    className: "st21",
    d: "M280,588.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L280,588.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000159442590337544167150000004930022503112367787_",
    className: "st21",
    d: "M278.9,591.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L278.9,591.8z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s18_00000137107398902986007230000005550007924042383025_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000060724265289810755600000009045408225445238450_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000048478583762223400930000017953418861133208249_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000130618294939708855740000014057931212503953590_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000176755271828337927010000005316535042457818007_",
    className: "st21",
    d: "M284.7,579.6l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L284.7,579.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000091715214028535704680000011670491457218439842_",
    className: "st21",
    d: "M283.7,583.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L283.7,583.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000172441667310549146440000012526826714803368349_",
    className: "st21",
    d: "M282.6,586.9l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L282.6,586.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000106132969993703847120000008353219932477802121_",
    className: "st21",
    d: "M281.6,590.6l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L281.6,590.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000037663877453477988200000004734006026013047196_",
    className: "st21",
    d: "M280.5,594.2l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L280.5,594.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000165916331986672823360000010985385526400691587_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000183239120667243642010000013272426775113484955_",
    className: "st21",
    d: "M286.3,582.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L286.3,582.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000094614258245816019530000007307766280193677242_",
    className: "st21",
    d: "M285.3,585.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L285.3,585.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000096049408291363057390000011704031536703607698_",
    className: "st21",
    d: "M284.3,589.4l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L284.3,589.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000095334766493273613390000012802315878602114466_",
    className: "st21",
    d: "M283.2,593l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L283.2,593z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000143578903993689202090000017189962849412633738_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000123402146820662167320000017106567973086872988_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000037693529400733318520000006552062186870273682_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000113330681181800360340000007114882936469312162_",
    className: "st21",
    d: "M289,580.9l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L289,580.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000183220134897644385590000017559059116556102557_",
    className: "st21",
    d: "M288,584.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L288,584.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000124143232718405085250000005678594487936807089_",
    className: "st21",
    d: "M286.9,588.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L286.9,588.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000053531941690112836980000011958296629437008828_",
    className: "st21",
    d: "M285.9,591.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L285.9,591.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000085231166220048798200000003587280566158928014_",
    className: "st21",
    d: "M284.8,595.4l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L284.8,595.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000116914972517625121880000015165299568719411095_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000143583157348004697190000003535143286027247786_",
    className: "st21",
    d: "M290.6,583.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L290.6,583.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000145762170986645812670000013071606950942777264_",
    className: "st21",
    d: "M289.6,586.9l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L289.6,586.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000051349300842823789710000009776551141596210362_",
    className: "st21",
    d: "M288.5,590.6l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L288.5,590.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000101815835925446370620000012680788285807637912_",
    className: "st21",
    d: "M287.5,594.2l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L287.5,594.2z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s9_00000005228595152780283100000007459257664067904658_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000050643104460442149740000001881182876151416491_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000029724549758747528050000016176250163611402924_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000093896110908870315100000017691303684872813223_",
    className: "st21",
    d: "M293.3,582.1l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L293.3,582.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000041980372248574060360000001153844444526251174_",
    className: "st21",
    d: "M292.3,585.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L292.3,585.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000034063165086315910740000015837626165475818881_",
    className: "st21",
    d: "M291.2,589.4l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L291.2,589.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000160149264865744478380000004536846405812012695_",
    className: "st21",
    d: "M290.2,593l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L290.2,593z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000151541737359488532570000015811638290813953418_",
    className: "st21",
    d: "M289.1,596.7l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L289.1,596.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000057134764874908757450000002179896561564676496_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000085935161594722333680000003208527591231599792_",
    className: "st21",
    d: "M294.9,584.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L294.9,584.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000086669018436359937570000002856909415820803515_",
    className: "st21",
    d: "M293.9,588.2l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L293.9,588.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000039849485689909280000000007519559016119251635_",
    className: "st21",
    d: "M292.8,591.8l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L292.8,591.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000165945988237812276660000014263715437227767228_",
    className: "st21",
    d: "M291.8,595.5l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L291.8,595.5z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "s5_00000155855206943360355860000000507744307170977935_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s4_00000001637165867765096970000001429070365481227939_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "s_00000085234606822544190500000012836555832495030939_",
    className: "st21",
    d: "M297.6,583.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L297.6,583.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000155835529606625609570000011222501096953805235_",
    className: "st21",
    d: "M296.5,587l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L296.5,587z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000063618793710205052700000006203036053799755145_",
    className: "st21",
    d: "M295.5,590.6l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L295.5,590.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000026879770704805293570000016144397713698321289_",
    className: "st21",
    d: "M294.4,594.3l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L294.4,594.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "s_00000072248979139687320490000000613565091882058376_",
    className: "st21",
    d: "M293.4,597.9l0.1,2.1l-1.3-1.6l2,0.6 l-1.9,0.7L293.4,597.9z"
  }))))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M344.4,185.6c0.3,0.3,1.5,1.3,2.5,5.9c0,0,0.6,2.9,1.3,3.8c0.6,0.9,2,2.2,2.1,3.3s0.2,1.7,0.2,1.7 s3.4,0.4,4.7,0.2c1.3-0.2,2.1-0.4,2.1-0.4s0.1-0.3-0.3-0.8c-0.4-0.4-1.8-1.7-2.3-2c-0.5-0.4-1.9-1.7-2.9-4c-0.9-2.3-1.1-5.4-1-7.4 s1.3-7.1,1.3-7.1l-1.4-2.8L344.4,185.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M350.2,177.9c0.5,0.1,1.5,1.1,1.5,2.7c0,1.6,0.2,2.2,0.8,2.2s0.9-0.8,1-2.2s1.4-1.4,1.7-1.2 c0.3,0.2,0.6,0.4,0.4,1.9c-0.1,1.5,0.3,1.7,0.6,1.7c0.3,0,0.9,0,1-1.7c0.1-1.6,0.5-2.1,1-2.1c0.6,0,0.8,0.4,0.8,1.2 s-0.5,2.4,0.6,2.5s1-1.2,1.1-2.1c0.1-0.9,0-1.8,1.1-2.3s3.7-1,4.9-2.2l-3.2-2.6l-6.5-0.8l-4.2,0.1L350.2,177.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M374.3,177.7c0.2,0.9,1,4.6,1.3,10.1s-0.3,4.8-0.2,7.1c0.2,2.4,0.9,6.7,1.5,7s4,0.3,4.5,0 c0,0,0.3-0.3,0.1-0.6c-0.2-0.3-1.1-1-1.4-1.7c-0.2-0.6-0.5-2-0.6-2.8s-0.1-2.2,0.2-2.8s1-2.2,1.1-3.2s0.6-5.7,1-7s-1.1-6.3-1.1-6.3 L374.3,177.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M406.3,138.6c0,0,1.5-1.5,1.7-3.1c0,0,1.5,1,1.3,3.7c0,0,2.4,1.8,4.3,4.3c2,2.5,3.2,3.7,4.5,4.3s4,2,3.6,3.6 c-0.4,1.5-0.8,3.4-2.1,3.9s-3.6,0.3-5.7,0.4c-2.2,0.1-3.7,0.4-4.1,0.5s-4.8,1.4-5.4,1.7s-1,0.6-1.3,1.1s-2.2,3.7-3.2,5.9 c-1.1,2.3-2.5,5.9-4.3,7.9c-1.7,2-3.3,3.7-5.3,5.4c0,0-0.5,0.6-0.8,3.6c-0.4,3-1.2,12.4-0.7,14.1s1.1,4.4,3.7,7.3 c0,0-3,0.9-4.2,0.4c-1.3-0.5-2.2-2.5-2.5-3.1s-2.5-4.3-2.7-5.6c-0.1-1.3-0.1-3.9-0.2-4.8c-0.1-0.9-0.9-5.4-1.9-7.9s-2.1-3.6-4-3.7 c-1.9-0.1-6.8-0.5-11.2-2.3c-4.4-1.8-11.2-1.9-12.4-1.4s-1,0.6-1.2,1s-1.6,4.1-6,9c0,0-1.6,1.7-1.7,2.2c-0.1,0.4-0.3,1.8-0.4,3.5 c0,1.7,0.1,5.1,1.6,7.2s3.8,5.7,3.8,5.7s-4.6,0.4-5.3,0.2c-0.7-0.2-1.7-1.6-2.4-3.1c-0.8-1.4-2.1-3.9-2.3-4.3s-0.3-1.9-0.4-2.5 c0-0.6-0.2-4.1-0.4-5s-0.5-2.6-0.1-4.1s1.1-3.5,1.2-4.7s0.5-2.4-0.1-3.1c-0.6-0.7-2.9-2.8-3.5-5.5s-0.7-4.9-0.7-4.9s0,3.9-0.8,5.9 c-0.7,2.1-1.1,2.7-1.1,2.7s-0.1,3.8-1.6,5.4c-1.4,1.7-2.8,2.3-4,1.9c0,0,1.5-0.6,2.2-2.3s1.6-4.1,2.4-5c0,0,1-1.7,1.2-3.9 c0.2-2.3,0.4-6.1,0.4-8.9c0.1-2.8,0.3-10.7,5.4-14.3s14.2-2.5,16.3-2.5c2.2,0,12.4,0.7,15,0.6c2.7-0.1,4.2-0.1,5.3-0.5 s5.1-2.4,8.3-3c3.2-0.5,7.3,0,9.6-0.2c2.3-0.2,4-1.1,4.7-1.5S403.8,138.8,406.3,138.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.3,166.6c0.4-1.2,0.9-3,1.5-4.3c0.5-1.1,1.7-2.4,1.8-3.6c0.3-2.9-0.3-6.8-1.3-9.4 c-0.4-1.1-1.6-2.6-1.6-2.6c-1.1,0.4-2.1,0.9-3,1.5c-5.1,3.6-4.6,10-4.7,12.9c0,1.5,0.5,5.6,0.5,5.6s0.1,1.3,0.4,3.2 c0,0,2.5-0.2,3.8-0.9C340.9,168.3,341.7,168.3,342.3,166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M365.7,152.9c0.1,0.7,2,2.6,2.9,3.6c1.2,1.2,2.4,2.6,4.1,3.3c0.7,0.3,2.6-0.2,3.5-0.3c1.7-0.3,3.9-1,5.5-1.8 c0.8-0.4,2.3-1,2.8-1.6c0.8-0.9,0.6-2.9,0.5-4.8c-0.1-1.8,0.2-3.4,0.2-5.2c0-1.3-0.1-3.4-0.1-3.4c-0.1,0-0.3,0-0.4,0.1 c-3.2,0.5-7.2,2.5-8.3,3c-1.1,0.4-2.7,0.4-5.3,0.5c-0.8,0-2.4,0-4.2-0.1C366.5,146.1,365.4,150.5,365.7,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M386.3,201.7c0.5,0.7,1.1,1.6,1.9,1.9c1.3,0.5,4.2-0.4,4.2-0.4c-0.6-0.6-1-1.3-1.4-1.9L386.3,201.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.5,201.9c0.6,0.9,1.2,1.6,1.7,1.8c0.7,0.2,5.3-0.2,5.3-0.2s-0.7-1-1.5-2.3 C346.8,201.4,344.7,201.6,342.5,201.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.5,200.3c-1.4,0.5-2.8,0.5-4.2,0.5c0.2,0.7,0.4,1.1,0.6,1.2c0.6,0.3,4,0.3,4.5,0c0,0,0.3-0.3,0.1-0.6 C381.4,201.1,380.9,200.7,380.5,200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.6,136.6c0,0-0.4,3.3-1.4,4.9c0,0,2.1,2.5,2.8,3.6s1.7,1.7,1.4,2.7c-0.2,0.9-1.1,3.4-2.7,4.1 c-1.5,0.6-6.2-0.3-7-0.6s-1.4-0.5-1.7-1.5c-0.3-0.9-0.8-1.9-1.6-2.9s-1.3-1.6-0.8-3.1s1.7-2.5,3.1-2.8c1.3-0.3,2.5-0.8,2.5-0.8 L412.6,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M394.1,144.2c-0.5-0.3-1.1-0.3-1.5-0.1c-0.5,0.2-0.8,0.7-1.3,1c-0.7,0.5-1.6,0.7-2.3,1.2 c-0.7,0.5-1.2,1.4-1.4,2.3c-0.2,0.9-0.2,1.8-0.3,2.7c0,0.4,0,0.8,0.1,1.2s0.4,0.7,0.7,0.9c0.4,0.1,0.8,0,1.2-0.2 c0.4-0.2,0.7-0.5,1-0.7c0.5-0.3,1.2-0.5,1.8-0.6c0.6-0.1,1.3-0.2,1.9-0.4s1.1-0.7,1.4-1.3c0.2-0.6,0.1-1.3-0.1-2 c-0.2-0.8-0.4-1.5-0.5-2.3C394.8,145.1,394.6,144.6,394.1,144.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M390.4,155.7c-0.9,0.6-1.7,1.4-2.5,2.3c-1.1,1.2-2.2,2.3-3.3,3.5c-0.6,0.6-1.2,1.3-1.4,2.1 c-0.2,0.7,0,1.5,0.2,2.2c0.3,1,0.5,2.1,0.8,3.1c0.2,0.6,0.3,1.2,0.6,1.8c0.3,0.5,0.8,1,1.3,1.2c0.7,0.3,1.5,0.1,2.2-0.1 c1.5-0.3,2.9-0.7,4.4-1c0.7-0.2,1.4-0.3,2-0.7c0.8-0.5,1.3-1.4,1.7-2.3c0.9-2.1,1.6-4.2,2-6.5c0.2-1.1,0.3-2.3,0.1-3.4 c-0.2-1.1-1-2.4-2.1-2.9c-1.3-0.5-2.7-0.5-4-0.2C391.7,155,391,155.3,390.4,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.4,160.8c-1-0.6-2.2-1.1-3.3-1.2c-1.2-0.1-2.5,0.2-3.3,1.1c-0.7,0.6-1.1,1.5-1.4,2.4 c-0.4,0.9-0.6,1.8-0.9,2.8c-0.1,0.6-0.2,1.1,0,1.7c0.3,0.7,1,1.1,1.7,1.5c1.7,0.8,3.5,1.4,5.3,1.8c1.4,0.3,3,0.5,4.3-0.1 c1.4-0.6,2.3-2.1,2.4-3.6c0-1.1-0.3-2.1-0.9-3c-0.3-0.4-1.8-1.7-2.2-2C369.5,161.6,368.9,161.2,368.4,160.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.8,150.7c-1.4,0.1-2.8,0.9-3.7,2.1c-1.3,1.8-1.4,4.2-2.9,5.8c-0.3,0.3-0.7,0.6-0.7,1c0,0.6,0.5,1,1,1.2 c1,0.5,2.2,0.6,3.4,0.5c1.1-0.1,2.3-0.4,3.4-0.7c0.8-0.2,1.6-0.5,2.3-0.9c1.2-0.8,2-2.1,2.1-3.5c0.1-1.2-0.2-2.4-0.7-3.4 c-0.5-0.9-1.4-1.6-2.4-1.9C358,150.7,357.4,150.7,356.8,150.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M350.3,199c0.1,0.8,0.2,1.3,0.2,1.3s3.4,0.4,4.7,0.2s2.1-0.4,2.1-0.4s0.1-0.3-0.3-0.8 c-0.2-0.2-0.7-0.7-1.3-1.2C354.4,198.6,352.5,198.9,350.3,199z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M654.9,94.4c-0.2,0.2-1.2,1-2,4.7c0,0-0.5,2.3-1,3s-1.6,1.7-1.7,2.6c-0.1,0.8-0.2,1.3-0.2,1.3 s-2.7,0.3-3.7,0.2c-1-0.1-1.6-0.3-1.6-0.3s-0.1-0.3,0.2-0.6c0.3-0.3,1.4-1.3,1.8-1.6s1.5-1.4,2.3-3.2c0.7-1.8,0.9-4.3,0.8-5.9 c-0.1-1.6-1.1-5.7-1.1-5.7l1.1-2.2L654.9,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M650.3,88.3c-0.4,0.1-1.2,0.9-1.2,2.1s-0.1,1.8-0.7,1.8s-0.7-0.6-0.8-1.8c0-1.1-1.1-1.1-1.3-1 s-0.5,0.3-0.3,1.5c0.1,1.2-0.2,1.3-0.5,1.4c-0.2,0-0.7,0-0.8-1.3s-0.4-1.7-0.8-1.7c-0.4,0-0.6,0.3-0.6,1s0.4,1.9-0.5,2 s-0.8-1-0.8-1.7c-0.1-0.7,0-1.4-0.9-1.9c-0.9-0.4-2.9-0.8-3.9-1.8l2.6-2.1l5.2-0.6l3.3,0.1L650.3,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M631.1,88c-0.2,0.7-0.8,3.7-1,8.1s0.3,3.8,0.1,5.7s-0.7,5.4-1.2,5.6s-3.2,0.2-3.6,0c0,0-0.2-0.2-0.1-0.5 s0.9-0.8,1.1-1.3c0.2-0.5,0.4-1.6,0.4-2.2s0.1-1.8-0.1-2.3c-0.2-0.5-0.8-1.7-0.9-2.5S625.4,94,625,93c-0.3-1,0.9-5,0.9-5H631.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M605.5,56.9c0,0-1.2-1.2-1.4-2.5c0,0-1.2,0.8-1,2.9c0,0-1.9,1.4-3.5,3.4s-2.6,2.9-3.6,3.4 c-1,0.4-3.2,1.6-2.9,2.8c0.3,1.2,0.6,2.7,1.7,3.1c1.1,0.4,2.9,0.2,4.6,0.3s2.9,0.3,3.2,0.4s3.8,1.1,4.3,1.3s0.8,0.5,1,0.9 s1.7,2.9,2.6,4.7c0.8,1.8,2,4.7,3.4,6.3s2.6,3,4.3,4.3c0,0,0.4,0.5,0.7,2.9s1,9.9,0.6,11.2c-0.4,1.3-0.9,3.5-2.9,5.8 c0,0,2.4,0.7,3.4,0.3s1.8-2,2-2.4s2-3.4,2.1-4.5s0.1-3.1,0.1-3.8s0.7-4.3,1.5-6.3s1.6-2.9,3.2-3c1.5-0.1,5.4-0.4,8.9-1.8 c3.5-1.5,8.9-1.5,9.8-1.1c0.9,0.4,0.8,0.5,0.9,0.8c0.1,0.3,1.2,3.3,4.8,7.2c0,0,1.3,1.4,1.3,1.7c0.1,0.3,0.3,1.4,0.3,2.8 s-0.1,4.1-1.2,5.7s-3,4.5-3,4.5s3.7,0.3,4.2,0.2s1.3-1.3,1.9-2.4c0.6-1.1,1.6-3.1,1.8-3.4c0.1-0.3,0.2-1.5,0.3-2 c0-0.5,0.1-3.3,0.3-4s0.4-2.1,0.1-3.3c-0.3-1.2-0.9-2.8-1-3.7c-0.1-0.9-0.4-1.9,0.1-2.4s2.3-2.3,2.8-4.4s0.6-3.9,0.6-3.9 s0,3.1,0.6,4.7s0.8,2.1,0.8,2.1s0.1,3,1.2,4.3s2.3,1.8,3.2,1.5c0,0-1.2-0.5-1.7-1.8s-1.3-3.3-1.9-4c0,0-0.8-1.3-0.9-3.1 c-0.2-1.8-0.3-4.9-0.3-7.1s-0.2-8.5-4.3-11.4s-11.3-2-13-2s-9.8,0.6-11.9,0.5s-3.4-0.1-4.3-0.4c-0.9-0.3-4.1-1.9-6.6-2.4 s-5.8,0-7.7-0.2c-1.8-0.2-3.2-0.9-3.8-1.2S607.5,57.1,605.5,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M656.6,79.2c-0.3-1-0.7-2.4-1.2-3.5c-0.4-0.9-1.3-1.9-1.4-2.8c-0.2-2.3,0.2-5.4,1-7.5c0.3-0.9,1.3-2.1,1.3-2.1 c0.9,0.3,1.7,0.7,2.4,1.2c4.1,2.9,3.7,8,3.7,10.3c0,1.2-0.4,4.5-0.4,4.5s-0.1,1.1-0.3,2.5c0,0-2-0.2-3-0.7 C657.7,80.6,657,80.6,656.6,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M637.9,68.3c-0.1,0.5-1.6,2.1-2.3,2.8c-1,1-1.9,2.1-3.3,2.6c-0.6,0.2-2.1-0.2-2.8-0.3 c-1.4-0.2-3.1-0.8-4.4-1.4c-0.6-0.3-1.8-0.8-2.3-1.3c-0.6-0.7-0.5-2.3-0.4-3.8s-0.2-2.7-0.1-4.1c0-1.1,0.1-2.7,0.1-2.7 c0.1,0,0.2,0,0.3,0c2.5,0.4,5.7,2,6.6,2.4c0.9,0.3,2.1,0.3,4.3,0.4c0.7,0,1.9,0,3.3-0.1C637.3,62.9,638.2,66.4,637.9,68.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M621.5,107.2c-0.4,0.6-0.9,1.3-1.5,1.5c-1,0.4-3.4-0.3-3.4-0.3c0.5-0.5,0.8-1,1.1-1.5L621.5,107.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M656.4,107.3c-0.5,0.7-1,1.3-1.3,1.4c-0.5,0.1-4.2-0.2-4.2-0.2s0.5-0.8,1.2-1.8 C652.9,106.9,654.6,107.1,656.4,107.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M626.1,106c1.1,0.4,2.2,0.4,3.4,0.4c-0.2,0.5-0.3,0.9-0.5,0.9c-0.5,0.2-3.2,0.2-3.6,0c0,0-0.2-0.2-0.1-0.5 C625.4,106.7,625.8,106.4,626.1,106z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M600.6,55.4c0,0,0.3,2.6,1.1,3.9c0,0-1.7,2-2.2,2.9c-0.6,0.9-1.3,1.4-1.1,2.1s0.9,2.7,2.1,3.2 c1.2,0.5,4.9-0.2,5.6-0.5c0.6-0.3,1.1-0.4,1.4-1.2c0.2-0.7,0.6-1.5,1.2-2.3c0.6-0.8,1.1-1.3,0.7-2.5c-0.4-1.2-1.4-2-2.4-2.2 s-2-0.6-2-0.6L600.6,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M615.3,61.4c0.4-0.2,0.8-0.3,1.2-0.1s0.7,0.5,1,0.8c0.5,0.4,1.2,0.5,1.8,0.9s1,1.1,1.1,1.8 c0.2,0.7,0.2,1.4,0.2,2.2c0,0.3,0,0.6-0.1,0.9s-0.3,0.6-0.6,0.7s-0.7,0-1-0.2s-0.5-0.4-0.8-0.6c-0.4-0.3-0.9-0.4-1.5-0.5 s-1-0.2-1.5-0.3s-0.9-0.5-1.1-1c-0.2-0.5-0.1-1.1,0.1-1.6c0.1-0.6,0.3-1.2,0.4-1.8C614.8,62.1,614.9,61.7,615.3,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M618.3,70.6c0.7,0.5,1.4,1.1,2,1.8c0.9,0.9,1.7,1.8,2.6,2.8c0.5,0.5,1,1,1.1,1.7c0.1,0.6,0,1.2-0.2,1.7 c-0.2,0.8-0.4,1.6-0.7,2.5c-0.1,0.5-0.3,1-0.5,1.4s-0.6,0.8-1.1,1c-0.6,0.2-1.2,0.1-1.7-0.1c-1.2-0.3-2.3-0.5-3.5-0.8 c-0.6-0.1-1.1-0.3-1.6-0.6c-0.6-0.4-1-1.1-1.3-1.8c-0.7-1.6-1.3-3.4-1.6-5.1c-0.2-0.9-0.3-1.8-0.1-2.7c0.2-0.9,0.8-1.9,1.7-2.3 c1-0.4,2.2-0.4,3.2-0.2C617.2,70,617.8,70.2,618.3,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M635.8,74.6c0.8-0.5,1.7-0.9,2.7-1s2,0.2,2.7,0.8c0.5,0.5,0.9,1.2,1.1,1.9c0.3,0.7,0.5,1.5,0.7,2.2 c0.1,0.4,0.2,0.9,0,1.3c-0.2,0.6-0.8,0.9-1.4,1.2c-1.4,0.6-2.8,1.1-4.2,1.5c-1.1,0.3-2.4,0.4-3.4-0.1c-1.1-0.5-1.8-1.7-1.9-2.9 c0-0.8,0.2-1.7,0.7-2.4c0.2-0.3,1.5-1.3,1.8-1.6C634.9,75.3,635.3,74.9,635.8,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M645,66.6c1.1,0.1,2.2,0.7,2.9,1.7c1,1.4,1.1,3.4,2.3,4.6c0.2,0.2,0.5,0.5,0.6,0.8c0,0.4-0.4,0.8-0.8,0.9 c-0.8,0.4-1.8,0.5-2.7,0.4s-1.8-0.3-2.7-0.5c-0.6-0.2-1.3-0.4-1.8-0.7c-0.9-0.6-1.6-1.7-1.7-2.8c-0.1-0.9,0.1-1.9,0.6-2.7 c0.4-0.7,1.1-1.2,1.9-1.5C644,66.6,644.5,66.5,645,66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M650.1,105c-0.1,0.6-0.1,1-0.1,1s-2.7,0.3-3.7,0.2c-1-0.1-1.6-0.3-1.6-0.3s-0.1-0.3,0.2-0.6 c0.2-0.2,0.6-0.6,1-0.9C646.9,104.7,648.4,104.9,650.1,105z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M563.5,99c0.1,0.1,0.7,0.6,1.2,2.8c0,0,0.3,1.4,0.6,1.8s0.9,1.1,1,1.6s0.1,0.8,0.1,0.8s1.6,0.2,2.2,0.1 c0.6-0.1,1-0.2,1-0.2s0.1-0.2-0.1-0.4c-0.2-0.2-0.9-0.8-1.1-1c-0.2-0.2-0.9-0.8-1.4-1.9s-0.6-2.6-0.5-3.6s0.6-3.4,0.6-3.4l-0.7-1.3 L563.5,99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M577.8,95.2c0.1,0.4,0.5,2.2,0.6,4.9c0.1,2.6-0.2,2.3-0.1,3.4s0.4,3.2,0.7,3.4c0.3,0.1,1.9,0.1,2.2,0 c0,0,0.1-0.1,0.1-0.3c-0.1-0.1-0.5-0.5-0.7-0.8c-0.1-0.3-0.2-1-0.3-1.3s-0.1-1.1,0.1-1.4c0.1-0.3,0.5-1,0.5-1.5 c0.1-0.5,0.3-2.8,0.5-3.3s-0.6-3-0.6-3L577.8,95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M593.2,76.5c0,0,0.7-0.7,0.8-1.5c0,0,0.7,0.5,0.6,1.8c0,0,1.1,0.9,2.1,2.1c0.9,1.2,1.5,1.8,2.2,2 c0.6,0.3,1.9,1,1.7,1.7s-0.4,1.6-1,1.9c-0.6,0.2-1.7,0.1-2.8,0.2c-1,0-1.8,0.2-2,0.2s-2.3,0.7-2.6,0.8c-0.3,0.1-0.5,0.3-0.6,0.5 s-1,1.8-1.5,2.8c-0.5,1.1-1.2,2.8-2.1,3.8c-0.8,1-1.6,1.8-2.6,2.6c0,0-0.2,0.3-0.4,1.7c-0.2,1.4-0.6,6-0.4,6.8s0.5,2.1,1.8,3.5 c0,0-1.4,0.4-2,0.2c-0.6-0.2-1.1-1.2-1.2-1.5s-1.2-2.1-1.3-2.7s-0.1-1.9-0.1-2.3s-0.4-2.6-0.9-3.8c-0.5-1.2-1-1.7-1.9-1.8 c-0.9-0.1-3.2-0.2-5.4-1.1c-2.1-0.9-5.4-0.9-5.9-0.7c-0.6,0.3-0.5,0.3-0.6,0.5s-0.8,2-2.9,4.3c0,0-0.8,0.8-0.8,1s-0.2,0.9-0.2,1.7 c0,0.8,0.1,2.5,0.8,3.5s1.8,2.7,1.8,2.7s-2.2,0.2-2.5,0.1s-0.8-0.8-1.2-1.5s-1-1.9-1.1-2.1s-0.2-0.9-0.2-1.2c0-0.3-0.1-2-0.2-2.4 c-0.1-0.4-0.2-1.3-0.1-2c0.2-0.7,0.5-1.7,0.6-2.2c0.1-0.6,0.3-1.1-0.1-1.5s-1.4-1.4-1.7-2.7s-0.3-2.3-0.3-2.3s0,1.9-0.4,2.8 c-0.4,1-0.5,1.3-0.5,1.3s-0.1,1.8-0.8,2.6s-1.4,1.1-1.9,0.9c0,0,0.7-0.3,1.1-1.1c0.3-0.8,0.8-2,1.1-2.4c0,0,0.5-0.8,0.6-1.9 s0.2-2.9,0.2-4.3s0.1-5.1,2.6-6.9s6.8-1.2,7.8-1.2s5.9,0.3,7.2,0.3c1.3-0.1,2,0,2.6-0.3s2.5-1.2,4-1.4c1.5-0.3,3.5,0,4.6-0.1 s1.9-0.5,2.3-0.7C590.1,77.4,592,76.6,593.2,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.5,89.9c0.2-0.6,0.4-1.5,0.7-2.1c0.2-0.5,0.8-1.1,0.8-1.7c0.1-1.4-0.1-3.3-0.6-4.5 c-0.2-0.5-0.8-1.3-0.8-1.3c-0.5,0.2-1,0.4-1.4,0.7c-2.5,1.7-2.2,4.8-2.2,6.2c0,0.7,0.2,2.7,0.2,2.7s0,0.6,0.2,1.5 c0,0,1.2-0.1,1.8-0.4C561.8,90.7,562.2,90.7,562.5,89.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M573.7,83.3c0,0.3,1,1.2,1.4,1.7c0.6,0.6,1.1,1.3,2,1.6c0.4,0.1,1.3-0.1,1.7-0.2c0.8-0.1,1.9-0.5,2.6-0.8 c0.4-0.2,1.1-0.5,1.4-0.8c0.4-0.4,0.3-1.4,0.2-2.3s0.1-1.6,0.1-2.5c0-0.6,0-1.6-0.1-1.6s-0.1,0-0.2,0c-1.5,0.3-3.4,1.2-4,1.4 s-1.3,0.2-2.6,0.3c-0.4,0-1.1,0-2,0C574.1,80.1,573.6,82.2,573.7,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M583.6,106.8c0.2,0.4,0.5,0.8,0.9,0.9c0.6,0.2,2-0.2,2-0.2c-0.3-0.3-0.5-0.6-0.7-0.9L583.6,106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.6,106.8c0.3,0.4,0.6,0.8,0.8,0.8c0.3,0.1,2.5-0.1,2.5-0.1s-0.3-0.5-0.7-1.1 C564.7,106.6,563.7,106.7,562.6,106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M580.9,106.1c-0.7,0.2-1.3,0.2-2,0.2c0.1,0.3,0.2,0.5,0.3,0.6c0.3,0.1,1.9,0.1,2.2,0c0,0,0.1-0.1,0.1-0.3 C581.3,106.5,581,106.3,580.9,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M596.2,75.5c0,0-0.2,1.6-0.7,2.3c0,0,1,1.2,1.3,1.7s0.8,0.8,0.7,1.3s-0.6,1.6-1.3,1.9s-3-0.2-3.3-0.3 s-0.7-0.3-0.8-0.7s-0.4-0.9-0.8-1.4c-0.4-0.5-0.6-0.8-0.4-1.5c0.2-0.7,0.8-1.2,1.5-1.3c0.6-0.1,1.2-0.4,1.2-0.4L596.2,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M585.6,84.7c-0.5,0.3-0.8,0.7-1.2,1.1c-0.5,0.6-1,1.1-1.6,1.7c-0.3,0.3-0.6,0.6-0.7,1c-0.1,0.3,0,0.7,0.1,1 c0.1,0.5,0.3,1,0.4,1.5c0.1,0.3,0.2,0.6,0.3,0.8c0.1,0.3,0.4,0.5,0.6,0.6c0.3,0.1,0.7,0,1.1,0c0.7-0.2,1.4-0.3,2.1-0.5 c0.3-0.1,0.7-0.2,1-0.3c0.4-0.3,0.6-0.7,0.8-1.1c0.4-1,0.8-2,1-3.1c0.1-0.5,0.2-1.1,0.1-1.7c-0.1-0.5-0.5-1.2-1-1.4 c-0.6-0.2-1.3-0.2-1.9-0.1C586.2,84.3,585.9,84.5,585.6,84.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M571,86.2c-0.5-0.3-1-0.5-1.6-0.6c-0.6,0-1.2,0.1-1.6,0.5c-0.3,0.3-0.5,0.7-0.7,1.1s-0.3,0.9-0.4,1.3 c-0.1,0.3-0.1,0.6,0,0.8c0.1,0.3,0.5,0.5,0.8,0.7c0.8,0.4,1.7,0.7,2.6,0.9c0.7,0.2,1.4,0.2,2.1-0.1c0.7-0.3,1.1-1,1.1-1.8 c0-0.5-0.1-1-0.4-1.4c-0.1-0.2-0.9-0.8-1.1-1C571.5,86.5,571.2,86.3,571,86.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M566.4,105.5c0.1,0.4,0.1,0.6,0.1,0.6s1.6,0.2,2.2,0.1c0.6-0.1,1-0.2,1-0.2s0.1-0.2-0.1-0.4 c-0.1-0.1-0.4-0.4-0.6-0.6C568.3,105.3,567.4,105.4,566.4,105.5z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.1,493.4l1.7,1.7l-1.7,1.7l-0.8-0.7l-1,3.6l1.6,1.6l-1.7,1.7l-0.7-0.7l-1.3,4.7l5.3,5.2 c2.3,2.4,1.7,4,1.6,4.5l0,0l-0.1,0.1l-0.1,0.1l0,0c-0.4,0.3-2.1,0.8-4.5-1.5l-5.3-5.2l-4.7,1.4l0.7,0.7l-1.6,1.7l-1.6-1.6l-3.7,1.1 l0.8,0.8l-1.6,1.7l-1.8-1.7l-5.2,1.6l-1.5-1.5l10.6-5.5l4-4.1c-0.6-0.6-1-1-1-1l-6.8-8.1l-7.3,1.2l-1.2-1.3l6.2-3.2l-2.4-2.3 l0.4-0.4l2.4,2.3l3.2-6.3l1.2,1.2l-0.9,7.2l8.2,6.7c0,0,0.4,0.4,1.1,1.1l4-4.1l5.2-10.8l1.5,1.5L315.1,493.4z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 265.5,
    cy: 90.2,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 268.3,
    cy: 99.5,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 275.2,
    cy: 82,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 281.7,
    cy: 85.6,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 279.9,
    cy: 103.6,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 277.6,
    cy: 93.2,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 287.2,
    cy: 94,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 254.5,
    cy: 94.1,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 256.1,
    cy: 102,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 286.6,
    cy: 103,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M255.8,95c5.6,3.9,13.9,7.7,15,15.1c0.2,8.5,1,18-2.9,25.6c-0.1,0.1,0,0.2,0.1,0.2h11.2 c0.1,0,0.2-0.1,0.1-0.2c-2.5-5.3-2.4-10.7-3.2-16.5l0,0c-1-5-1.3-8.8,2.9-12.5c1.7-1.7,3.4-3.4,5.1-5.2c1.7-1.2,2.8-2.1,3.6-4.4 c0.3-0.8,0.3-1.6,0.3-1.3c-1,4.1-5.4,6.1-8.5,8.6c1.3-3,2.1-7.2,2.2-10.1c-1,3.5-1.2,7.9-3.6,10.8c-1.4,1-3.2,1.6-4.1,3.3 c-4.1-5.3-0.6-12.4-2.5-18.2c-0.6-2.2,0.4,2.5,0,3.7c0,2.9-0.8,5.8-1.3,8.7c-3.9-1.9-6.8-3.9-7.7-8.3l0,0c-0.9-1.5-1.1-3.4-1.8-4.8 c0.7,3.4,1.5,6.8,3.4,9.9c-2-0.8-4.6-2.6-6.3-3.4C257.5,96,251.5,91.9,255.8,95z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 234.5,
    cy: 107.4,
    r: 13.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 238,
    cy: 118.8,
    r: 13.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 246.4,
    cy: 97.4,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 254.3,
    cy: 101.7,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 252.1,
    cy: 123.8,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 249.3,
    cy: 111,
    r: 7.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3162 -0.9487 0.9487 0.3162 72.2142 324.1908)",
    className: "st15",
    cx: 261,
    cy: 112,
    rx: 11.7,
    ry: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 221.1,
    cy: 112.2,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 223,
    cy: 121.8,
    r: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3162 -0.9487 0.9487 0.3162 61.2999 331.0482)",
    className: "st15",
    cx: 260.3,
    cy: 123,
    rx: 4.3,
    ry: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M222.7,113.3c6.8,4.8,17,9.4,18.3,18.5c0.3,10.3,1.2,21.9-3.5,31.3c-0.1,0.1,0,0.3,0.2,0.3h13.7 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.4-2.9-13.1-4-20.1l0,0c-1.2-6.1-1.6-10.8,3.6-15.2c2.1-2.1,4.2-4.2,6.2-6.3c2.1-1.5,3.4-2.6,4.4-5.4 c0.4-1,0.4-1.9,0.3-1.6c-1.2,5-6.6,7.4-10.3,10.5c1.6-3.6,2.5-8.7,2.7-12.3c-1.3,4.2-1.5,9.6-4.4,13.2c-1.8,1.2-3.9,2-5,4 c-5-6.5-0.7-15.2-3-22.2c-0.8-2.7,0.5,3.1,0,4.5c0,3.5-1,7.1-1.6,10.6c-4.7-2.3-8.3-4.7-9.3-10.1l0,0c-1.1-1.8-1.3-4.2-2.2-5.8 c0.9,4.2,1.9,8.3,4.2,12.1c-2.5-1-5.6-3.1-7.7-4.1C224.7,114.5,217.4,109.5,222.7,113.3z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 697,
    cy: 147.9,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 700.9,
    cy: 160.6,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 710.4,
    cy: 136.7,
    r: 6.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 719.2,
    cy: 141.5,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 716.7,
    cy: 166.2,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 713.6,
    cy: 152,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 726.7,
    cy: 153.1,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 682.1,
    cy: 153.2,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 684.2,
    cy: 164,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 725.9,
    cy: 165.4,
    r: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M683.8,154.5c7.7,5.3,19,10.5,20.5,20.7c0.3,11.6,1.4,24.6-3.9,35c-0.1,0.1,0,0.3,0.2,0.3h15.3 c0.2,0,0.3-0.2,0.2-0.3c-3.5-7.2-3.2-14.7-4.4-22.5l0,0c-1.4-6.9-1.8-12,4-17.1c2.3-2.3,4.7-4.7,6.9-7.1c2.3-1.7,3.8-2.9,4.9-6 c0.4-1.2,0.5-2.2,0.4-1.8c-1.3,5.5-7.4,8.3-11.6,11.7c1.7-4,2.8-9.8,3.1-13.7c-1.4,4.7-1.7,10.8-4.9,14.7c-2,1.3-4.4,2.2-5.6,4.4 c-5.5-7.2-0.8-17-3.4-24.8c-0.9-3,0.5,3.5,0,5c0,4-1.2,7.9-1.8,11.9c-5.3-2.6-9.2-5.3-10.5-11.3l0,0c-1.2-2-1.4-4.7-2.4-6.5 c1,4.7,2.1,9.3,4.7,13.5c-2.8-1.1-6.3-3.5-8.7-4.6C686.1,155.8,677.9,150.3,683.8,154.5z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 456.3,
    cy: 78.4,
    r: 9.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 458.7,
    cy: 86.2,
    r: 9.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 464.4,
    cy: 71.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 469.8,
    cy: 74.5,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 468.3,
    cy: 89.6,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 466.4,
    cy: 80.9,
    r: 5.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 474.4,
    cy: 81.5,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 447.2,
    cy: 81.6,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 448.5,
    cy: 88.2,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 473.9,
    cy: 89.1,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M448.2,82.4c4.7,3.3,11.6,6.4,12.5,12.6c0.2,7.1,0.8,15-2.4,21.4c0,0.1,0,0.2,0.1,0.2h9.3 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.4-2-9-2.7-13.8l0,0c-0.8-4.2-1.1-7.4,2.4-10.4c1.4-1.4,2.9-2.8,4.2-4.3c1.4-1,2.3-1.8,3-3.7 c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.4-4.5,5.1-7.1,7.2c1.1-2.5,1.7-6,1.9-8.4c-0.9,2.9-1,6.6-3,9c-1.2,0.8-2.7,1.4-3.4,2.7 c-3.4-4.4-0.5-10.4-2.1-15.2c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.8-1.1,7.2c-3.2-1.6-5.6-3.2-6.4-6.9l0,0c-0.7-1.2-0.9-2.9-1.5-4 c0.6,2.9,1.3,5.7,2.9,8.2c-1.7-0.7-3.8-2.2-5.3-2.8C449.6,83.2,444.6,79.8,448.2,82.4z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.817841e-02 -0.9998 0.9998 1.817841e-02 -1570.3085 1622.2782)",
    className: "st15",
    cx: 40.9,
    cy: 1610.7,
    rx: 9.6,
    ry: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 43.3,
    cy: 1618.9,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 49.4,
    cy: 1603.5,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 55.1,
    cy: 1606.6,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 53.5,
    cy: 1622.5,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 51.5,
    cy: 1613.3,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 60,
    cy: 1614,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 31.2,
    cy: 1614.1,
    r: 5.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9998 -2.040435e-02 2.040435e-02 0.9998 -33.0691 1.0026)",
    className: "st15",
    cx: 32.6,
    cy: 1621,
    rx: 3.6,
    ry: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 59.5,
    cy: 1622,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M32.3,1615c4.9,3.4,12.2,6.8,13.2,13.3c0.2,7.4,0.9,15.8-2.5,22.5c0,0.1,0,0.2,0.1,0.2H53 c0.1,0,0.2-0.1,0.1-0.2c-2.2-4.6-2.1-9.5-2.9-14.5l0,0c-0.9-4.4-1.2-7.8,2.6-11c1.5-1.5,3-3,4.5-4.5c1.5-1.1,2.5-1.9,3.2-3.9 c0.3-0.7,0.3-1.4,0.2-1.1c-0.8,3.6-4.7,5.4-7.4,7.6c1.1-2.6,1.8-6.3,2-8.8c-0.9,3-1.1,6.9-3.2,9.5c-1.3,0.8-2.8,1.4-3.6,2.9 c-3.6-4.7-0.5-10.9-2.2-16c-0.6-1.9,0.3,2.2,0,3.2c0,2.6-0.7,5.1-1.1,7.6c-3.4-1.7-6-3.4-6.7-7.3l0,0c-0.8-1.3-0.9-3-1.6-4.2 c0.7,3,1.4,6,3,8.7c-1.8-0.7-4.1-2.3-5.6-3C33.8,1615.8,28.5,1612.2,32.3,1615z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 132.3,
    cy: 1343.4,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 135.7,
    cy: 1354.6,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 144,
    cy: 1333.6,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 151.8,
    cy: 1337.9,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 149.6,
    cy: 1359.6,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 146.9,
    cy: 1347,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 158.5,
    cy: 1348,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 119.2,
    cy: 1348.1,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 121,
    cy: 1357.7,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 157.7,
    cy: 1358.8,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M120.7,1349.3c6.7,4.7,16.7,9.2,18.1,18.2c0.3,10.2,1.2,21.6-3.5,30.8c-0.1,0.1,0,0.3,0.2,0.3h13.4 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.3-2.9-12.9-3.9-19.8l0,0c-1.2-6-1.6-10.6,3.5-15c2.1-2,4.1-4.1,6.1-6.2c2.1-1.5,3.3-2.6,4.3-5.3 c0.4-1,0.4-1.9,0.3-1.6c-1.1,4.9-6.5,7.3-10.2,10.3c1.5-3.6,2.5-8.6,2.7-12.1c-1.3,4.2-1.5,9.5-4.3,13c-1.7,1.2-3.9,2-4.9,3.9 c-4.9-6.4-0.7-14.9-3-21.8c-0.8-2.6,0.5,3.1,0,4.4c0,3.5-1,7-1.6,10.4c-4.6-2.3-8.1-4.7-9.2-9.9l0,0c-1.1-1.8-1.3-4.1-2.1-5.7 c0.9,4.1,1.8,8.2,4.1,11.9c-2.4-1-5.5-3.1-7.6-4C122.7,1350.4,115.5,1345.5,120.7,1349.3z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 602.2,
    cy: 1660,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 605.6,
    cy: 1671.2,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 613.9,
    cy: 1650.2,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 621.6,
    cy: 1654.4,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 619.5,
    cy: 1676.1,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 616.7,
    cy: 1663.6,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 628.3,
    cy: 1664.6,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 589,
    cy: 1664.7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 590.8,
    cy: 1674.2,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 627.6,
    cy: 1675.4,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M590.5,1665.8c6.7,4.7,16.7,9.2,18.1,18.2c0.3,10.2,1.2,21.6-3.5,30.8c-0.1,0.1,0,0.3,0.2,0.3h13.4 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.3-2.9-12.9-3.9-19.8l0,0c-1.2-6-1.6-10.6,3.5-15c2.1-2,4.1-4.1,6.1-6.2c2.1-1.5,3.3-2.6,4.3-5.3 c0.4-1,0.4-1.9,0.3-1.6c-1.1,4.9-6.5,7.3-10.2,10.3c1.5-3.6,2.5-8.6,2.7-12.1c-1.3,4.2-1.5,9.5-4.3,13c-1.7,1.2-3.9,2-4.9,3.9 c-4.9-6.4-0.7-14.9-3-21.8c-0.8-2.6,0.5,3.1,0,4.4c0,3.5-1,7-1.6,10.4c-4.6-2.3-8.1-4.7-9.2-9.9l0,0c-1.1-1.8-1.3-4.1-2.1-5.7 c0.9,4.1,1.8,8.2,4.1,11.9c-2.4-1-5.5-3.1-7.6-4C592.5,1667,585.3,1662.1,590.5,1665.8z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M144.3,87.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8V49.9c0-0.4,0.3-0.8,0.8-0.8h4.2c0.4,0,0.8,0.3,0.8,0.8V87 C145.1,87.5,144.7,87.8,144.3,87.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M118.5,87.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8V49.9c0-0.4,0.3-0.8,0.8-0.8h4.2c0.4,0,0.8,0.3,0.8,0.8V87 C119.3,87.5,119,87.8,118.5,87.8z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M52.2,1342.8H48c-0.4,0-0.8-0.3-0.8-0.8v-37.1c0-0.4,0.3-0.8,0.8-0.8h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1 C53,1342.5,52.6,1342.8,52.2,1342.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M26.4,1342.8h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1c0-0.4,0.3-0.8,0.8-0.8h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1 C27.2,1342.5,26.8,1342.8,26.4,1342.8z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M420.8,1580.3h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1c0-0.4,0.3-0.8,0.8-0.8h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1 C421.6,1580,421.2,1580.3,420.8,1580.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M395,1580.3h-4.2c-0.4,0-0.8-0.3-0.8-0.8v-37.1c0-0.4,0.3-0.8,0.8-0.8h4.2c0.4,0,0.8,0.3,0.8,0.8v37.1 C395.8,1580,395.4,1580.3,395,1580.3z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M92.9,1483.3v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8H93.6 C93.2,1484.1,92.9,1483.7,92.9,1483.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M92.9,1457.5v-4.2c0-0.4,0.3-0.8,0.8-0.8h37.1c0.4,0,0.8,0.3,0.8,0.8v4.2c0,0.4-0.3,0.8-0.8,0.8H93.6 C93.2,1458.3,92.9,1457.9,92.9,1457.5z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M358.6,81h51.5c2.3-1.5,3.8-4.1,3.8-7c0-4.2-3.1-7.7-7.2-8.4c0-3-2.5-5.5-5.6-5.5c-1,0-1.9,0.3-2.7,0.7 c-2.5-5.9-8.3-10-15-10c-8.3,0-15.1,6.2-16.1,14.1c-0.8-0.2-1.6-0.3-2.5-0.3c-5.2,0-9.4,4.2-9.4,9.4C355.4,76.8,356.6,79.3,358.6,81 z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M83.3,1065.1h51.5c2.3-1.5,3.8-4.1,3.8-7c0-4.2-3.1-7.7-7.2-8.4c0-3-2.5-5.5-5.6-5.5c-1,0-1.9,0.3-2.7,0.7 c-2.5-5.9-8.3-10-15-10c-8.3,0-15.1,6.2-16.1,14.1c-0.8-0.2-1.6-0.3-2.5-0.3c-5.2,0-9.4,4.2-9.4,9.4 C80.1,1060.8,81.4,1063.4,83.3,1065.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M563.7,684.4h43.5c1.9-1.3,3.2-3.5,3.2-5.9c0-3.6-2.6-6.5-6.1-7c0-2.6-2.1-4.6-4.7-4.6c-0.8,0-1.6,0.2-2.3,0.6 c-2.1-5-7-8.5-12.7-8.5c-7,0-12.7,5.2-13.6,11.9c-0.7-0.2-1.4-0.3-2.1-0.3c-4.4,0-7.9,3.5-7.9,7.9C561,680.8,562.1,683,563.7,684.4z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M676.6,249.9h38.5c1.7-1.1,2.8-3.1,2.8-5.3c0-3.2-2.3-5.8-5.4-6.2c0-2.3-1.9-4.1-4.2-4.1c-0.7,0-1.4,0.2-2,0.5 c-1.8-4.4-6.2-7.5-11.2-7.5c-6.2,0-11.3,4.6-12,10.6c-0.6-0.2-1.2-0.3-1.9-0.3c-3.9,0-7,3.1-7,7 C674.3,246.8,675.2,248.6,676.6,249.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M101.8,235.3H69.1c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C103.9,232.6,103.1,234.2,101.8,235.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M43.4,362.6H85c1.8-1.2,3.1-3.3,3.1-5.7c0-3.4-2.5-6.2-5.8-6.7c0-2.5-2-4.4-4.5-4.4c-0.8,0-1.6,0.2-2.2,0.6 c-2-4.8-6.7-8.1-12.1-8.1c-6.7,0-12.2,5-13,11.4c-0.6-0.2-1.3-0.3-2-0.3c-4.2,0-7.6,3.4-7.6,7.6C40.8,359.2,41.8,361.2,43.4,362.6z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M580.1,1285.1h-32.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C582.1,1282.4,581.4,1284,580.1,1285.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M603.6,1610.6h-32.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C605.6,1607.9,604.8,1609.5,603.6,1610.6z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M75.4,1569.3H42.7c-1.4-1-2.4-2.6-2.4-4.5c0-2.7,2-4.9,4.6-5.3c0-1.9,1.6-3.5,3.5-3.5c0.6,0,1.2,0.2,1.7,0.5 c1.6-3.7,5.2-6.4,9.5-6.4c5.2,0,9.6,3.9,10.2,9c0.5-0.1,1-0.2,1.6-0.2c3.3,0,6,2.7,6,6C77.4,1566.6,76.7,1568.2,75.4,1569.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M632.5,1522.2h41.6c1.8-1.2,3.1-3.3,3.1-5.7c0-3.4-2.5-6.2-5.8-6.7c0-2.5-2-4.4-4.5-4.4 c-0.8,0-1.6,0.2-2.2,0.6c-2-4.8-6.7-8.1-12.1-8.1c-6.7,0-12.2,5-13,11.4c-0.6-0.2-1.3-0.3-2-0.3c-4.2,0-7.6,3.4-7.6,7.6 C629.9,1518.7,631,1520.8,632.5,1522.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M452.8,49.7h-37.2c-1.6-1.1-2.7-3-2.7-5.1c0-3.1,2.2-5.6,5.2-6c0-2.2,1.8-4,4-4c0.7,0,1.4,0.2,2,0.5 c1.8-4.2,6-7.2,10.8-7.2c6,0,10.9,4.4,11.6,10.2c0.6-0.2,1.2-0.2,1.8-0.2c3.7,0,6.8,3,6.8,6.8C455.1,46.7,454.2,48.5,452.8,49.7z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M666.1,427.6h29.6c1.3-0.9,2.2-2.4,2.2-4.1c0-2.4-1.8-4.4-4.1-4.8c0-1.8-1.5-3.2-3.2-3.2 c-0.6,0-1.1,0.1-1.6,0.4c-1.4-3.4-4.7-5.8-8.6-5.8c-4.8,0-8.7,3.5-9.3,8.1c-0.5-0.1-0.9-0.2-1.4-0.2c-3,0-5.4,2.4-5.4,5.4 C664.2,425.2,664.9,426.6,666.1,427.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M177.9,656.8h29.6c1.3-0.9,2.2-2.4,2.2-4.1c0-2.4-1.8-4.4-4.1-4.8c0-1.8-1.5-3.2-3.2-3.2 c-0.6,0-1.1,0.1-1.6,0.4c-1.4-3.4-4.7-5.8-8.6-5.8c-4.8,0-8.7,3.5-9.3,8.1c-0.5-0.1-0.9-0.2-1.4-0.2c-3,0-5.4,2.4-5.4,5.4 C176.1,654.3,176.8,655.8,177.9,656.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M475.5,911.4h41.8c1.8-1.2,3.1-3.3,3.1-5.7c0-3.4-2.5-6.3-5.8-6.8c0-2.5-2-4.5-4.5-4.5c-0.8,0-1.6,0.2-2.2,0.6 c-2-4.8-6.7-8.1-12.2-8.1c-6.7,0-12.2,5-13.1,11.5c-0.6-0.2-1.3-0.3-2-0.3c-4.2,0-7.6,3.4-7.6,7.6C472.9,908,473.9,910,475.5,911.4z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M713.6,1136.3c-0.1-0.1-0.3-0.2-0.4-0.2l-35.7-1.5l-1.1-4.1c-0.3-1.1-1-1.9-2-2.4l-1.7-0.8l0,0l-2.6-1.2 c-0.1-0.4-0.5-0.8-1-0.8s-1,0.4-1,1c0,0.5,0.4,1,1,1c0.1,0,0.3,0,0.4-0.1l4.4,2c0.7,0.3,1.2,0.9,1.4,1.6l1.2,4.5l0,0l0,0l5,18.4l0,0 c-0.1,0-0.2,0.1-0.3,0.2l-2.2,3.1c-0.1,0.1-0.1,0.2-0.1,0.4v3.1c0,0.1,0,0.2,0.1,0.3l-1.2,0.1c0,0,0,0.3,0,0.7 c-1.2,0.3-2.1,1.3-2.1,2.6c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7c0-1-0.6-1.9-1.4-2.3c0-0.2,0.1-0.3,0.1-0.3h1.6v-0.4h23 c0,0.1,0,0.3,0,0.4c-1.2,0.3-2.1,1.3-2.1,2.6c0,1.5,1.2,2.7,2.7,2.7s2.7-1.2,2.7-2.7c0-1-0.6-1.9-1.4-2.3c0-0.2,0.1-0.3,0.1-0.3h1.6 v-0.4h2c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-30v-2.3l2-2.6l13.8-0.4c0.3,0,0.6-0.3,0.6-0.6c0-0.2-0.1-0.3-0.2-0.5 l15.5-0.9c0.3,0,0.5-0.2,0.6-0.5l1.6-15.2C713.8,1136.6,713.7,1136.5,713.6,1136.3z M712.1,1141.4l-3-0.1l0.2-4.1l3.2,0.1 L712.1,1141.4z M711.5,1146.6l-2.8,0.1l0.3-4.6l3,0.1L711.5,1146.6z M684.7,1141.2l4.1,0.1l1.1,5.7l-3.8,0.1L684.7,1141.2z  M685.4,1147.1l-4.5,0.1l-1.7-6.2l4.7,0.2L685.4,1147.1z M703.5,1141.1l-4.2-0.1l-0.3-4.2l4.4,0.2L703.5,1141.1z M704.1,1137 l4.4,0.2l-0.2,4.1l-4.1-0.1L704.1,1137z M691.8,1152.4l-0.9-4.7l3.7-0.1l0.6,4.6L691.8,1152.4z M690.7,1147l-1.1-5.6l4.2,0.1 l0.7,5.4L690.7,1147z M694.6,1141.6l4.1,0.1l0.4,5.2l-3.8,0.1L694.6,1141.6z M699.4,1141.7l4.1,0.1l0.1,4.9l-3.8,0.1L699.4,1141.7z  M698.6,1140.9l-4.1-0.1l-0.5-4.3l4.3,0.2L698.6,1140.9z M693.7,1140.8l-4.2-0.1l-0.8-4.3l4.5,0.2L693.7,1140.8z M688.7,1140.6 l-4.2-0.1l-1.1-4.4l4.4,0.2L688.7,1140.6z M690.1,1147.8l0.9,4.7l-3.5,0.2l-1.2-4.8L690.1,1147.8z M695.9,1152.2l-0.6-4.5l3.8-0.1 l0.3,4.4L695.9,1152.2z M699.8,1147.6l3.7-0.1l0.1,4.3l-3.5,0.2L699.8,1147.6z M704.3,1147.5l3.6-0.1l-0.2,4.1l-3.3,0.2 L704.3,1147.5z M704.3,1146.7l-0.1-4.9l4,0.1l-0.3,4.7L704.3,1146.7z M682.7,1136.1l1.1,4.4l-4.7-0.2l-1.2-4.4L682.7,1136.1z  M681.2,1147.9l4.4-0.1l1.2,4.8l-4.3,0.2L681.2,1147.9z M708.4,1151.5l0.2-4.1l2.8-0.1l-0.4,4L708.4,1151.5z"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 35.4,
    y1: 278.8,
    x2: 35.4,
    y2: 300.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M35.4,300.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C43.5,305.8,39.9,300.2,35.4,300.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,261.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,261,33.8,261.8,35.1,261.3 C35,261.4,35.1,261.4,35.1,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,261.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,261,36.9,261.8,35.6,261.3 C35.6,261.4,35.6,261.4,35.6,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.3,259.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C36.6,257.9,36.6,259.1,35.3,259.7 C35.4,259.7,35.3,259.7,35.3,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,263.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,263.5,33.8,264.3,35.1,263.8 C35,263.9,35.1,263.8,35.1,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,263.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,263.5,36.9,264.3,35.6,263.8 C35.6,263.9,35.6,263.8,35.6,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,266.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,266,33.8,266.8,35.1,266.3 C35,266.4,35.1,266.3,35.1,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,266.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,266,36.9,266.8,35.6,266.3 C35.6,266.4,35.6,266.3,35.6,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,268.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,268.5,33.8,269.3,35.1,268.8 C35,268.9,35.1,268.8,35.1,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,268.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,268.5,36.9,269.3,35.6,268.8 C35.6,268.9,35.6,268.8,35.6,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,271.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,271,33.8,271.8,35.1,271.3 C35,271.4,35.1,271.3,35.1,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,271.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,271,36.9,271.8,35.6,271.3 C35.6,271.4,35.6,271.3,35.6,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,273.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,273.5,33.8,274.3,35.1,273.8 C35,273.9,35.1,273.8,35.1,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,273.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,273.5,36.9,274.3,35.6,273.8 C35.6,273.9,35.6,273.8,35.6,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,276.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,276,33.8,276.8,35.1,276.3 C35,276.4,35.1,276.3,35.1,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,276.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,276,36.9,276.8,35.6,276.3 C35.6,276.4,35.6,276.3,35.6,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.1,278.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C32.9,278.5,33.8,279.3,35.1,278.8 C35,278.8,35.1,278.8,35.1,278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M35.6,278.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C37.8,278.5,36.9,279.3,35.6,278.8L35.6,278.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.3,285.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S36.1,285.7,35.3,285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.5,281c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1c-0.5-0.4-0.9-0.9-1.3-1.4C30.1,282.2,29.7,281.7,29.5,281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.3,290.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C36.7,290.2,36.1,290.4,35.3,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.5,285.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1c-0.5-0.4-0.9-0.9-1.3-1.4C30.1,287,29.7,286.5,29.5,285.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 48.8,
    y1: 278.8,
    x2: 48.8,
    y2: 300.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M48.9,300.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H60c0.4,0,0.6-0.5,0.2-0.7 C56.9,305.8,53.3,300.2,48.9,300.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,261.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,261,47.2,261.8,48.5,261.3 C48.5,261.4,48.5,261.4,48.5,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,261.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,261,50.3,261.8,49,261.3 C49.1,261.4,49,261.4,49,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.7,259.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C50,257.9,50,259.1,48.7,259.7 C48.8,259.7,48.8,259.7,48.7,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,263.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,263.5,47.2,264.3,48.5,263.8 C48.5,263.9,48.5,263.8,48.5,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,263.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,263.5,50.3,264.3,49,263.8 C49.1,263.9,49,263.8,49,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,266.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,266,47.2,266.8,48.5,266.3 C48.5,266.4,48.5,266.3,48.5,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,266.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,266,50.3,266.8,49,266.3 C49.1,266.4,49,266.3,49,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,268.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,268.5,47.2,269.3,48.5,268.8 C48.5,268.9,48.5,268.8,48.5,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,268.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,268.5,50.3,269.3,49,268.8 C49.1,268.9,49,268.8,49,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,271.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,271,47.2,271.8,48.5,271.3 C48.5,271.4,48.5,271.3,48.5,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,271.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,271,50.3,271.8,49,271.3 C49.1,271.4,49,271.3,49,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,273.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,273.5,47.2,274.3,48.5,273.8 C48.5,273.9,48.5,273.8,48.5,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,273.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,273.5,50.3,274.3,49,273.8 C49.1,273.9,49,273.8,49,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,276.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,276,47.2,276.8,48.5,276.3 C48.5,276.4,48.5,276.3,48.5,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,276.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,276,50.3,276.8,49,276.3 C49.1,276.4,49,276.3,49,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M48.5,278.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C46.3,278.5,47.2,279.3,48.5,278.8L48.5,278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M49,278.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C51.2,278.5,50.3,279.3,49,278.8 C49.1,278.8,49,278.8,49,278.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,285.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C50.1,285.4,49.5,285.7,48.8,285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.9,281c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C43.5,282.2,43.1,281.7,42.9,281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,290.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C50.1,290.2,49.5,290.4,48.8,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.9,285.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C43.5,287,43.1,286.5,42.9,285.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 62.2,
    y1: 278.8,
    x2: 62.2,
    y2: 300.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M62.3,300.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C70.3,305.8,66.8,300.2,62.3,300.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,261.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,261,60.6,261.8,61.9,261.3 C61.9,261.4,61.9,261.4,61.9,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.4,261.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,261,63.7,261.8,62.4,261.3 C62.5,261.4,62.5,261.4,62.4,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.1,259.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C63.4,257.9,63.4,259.1,62.1,259.7 C62.2,259.7,62.2,259.7,62.1,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,263.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,263.5,60.6,264.3,61.9,263.8 C61.9,263.9,61.9,263.8,61.9,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.4,263.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,263.5,63.7,264.3,62.4,263.8 C62.5,263.9,62.5,263.8,62.4,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,266.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,266,60.6,266.8,61.9,266.3 C61.9,266.4,61.9,266.3,61.9,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.4,266.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,266,63.7,266.8,62.4,266.3 C62.5,266.4,62.5,266.3,62.4,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,268.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,268.5,60.6,269.3,61.9,268.8 C61.9,268.9,61.9,268.8,61.9,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.4,268.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,268.5,63.7,269.3,62.4,268.8 C62.5,268.9,62.5,268.8,62.4,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,271.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,271,60.6,271.8,61.9,271.3 C61.9,271.4,61.9,271.3,61.9,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.5,271.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,271,63.7,271.8,62.5,271.3 C62.5,271.4,62.5,271.3,62.5,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,273.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,273.5,60.6,274.3,61.9,273.8 C61.9,273.9,61.9,273.8,61.9,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.5,273.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,273.5,63.7,274.3,62.5,273.8 C62.5,273.9,62.5,273.8,62.5,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,276.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,276,60.6,276.8,61.9,276.3 C61.9,276.4,61.9,276.3,61.9,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.5,276.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,276,63.7,276.8,62.5,276.3 C62.5,276.4,62.5,276.3,62.5,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M61.9,278.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C59.8,278.5,60.6,279.3,61.9,278.8L61.9,278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M62.5,278.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C64.6,278.5,63.7,279.3,62.5,278.8L62.5,278.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.2,285.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S62.9,285.7,62.2,285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.3,281c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C56.9,282.2,56.6,281.7,56.3,281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.2,290.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C63.6,290.2,62.9,290.4,62.2,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.3,285.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S56.6,286.5,56.3,285.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 75.6,
    y1: 278.8,
    x2: 75.6,
    y2: 300.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M75.7,300.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C83.7,305.8,80.2,300.2,75.7,300.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,261.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,261,74,261.8,75.3,261.3 C75.3,261.4,75.3,261.4,75.3,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,261.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,261,77.2,261.8,75.9,261.3 C75.9,261.4,75.9,261.4,75.9,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.6,259.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C76.9,257.9,76.8,259.1,75.6,259.7L75.6,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,263.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,263.5,74,264.3,75.3,263.8 C75.3,263.9,75.3,263.8,75.3,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,263.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,263.5,77.2,264.3,75.9,263.8 C75.9,263.9,75.9,263.8,75.9,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,266.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,266,74,266.8,75.3,266.3 C75.3,266.4,75.3,266.3,75.3,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,266.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,266,77.2,266.8,75.9,266.3 C75.9,266.4,75.9,266.3,75.9,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,268.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,268.5,74.1,269.3,75.3,268.8 C75.3,268.9,75.3,268.8,75.3,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,268.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,268.5,77.2,269.3,75.9,268.8 C75.9,268.9,75.9,268.8,75.9,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,271.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,271,74.1,271.8,75.3,271.3 C75.3,271.4,75.3,271.3,75.3,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,271.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,271,77.2,271.8,75.9,271.3 C75.9,271.4,75.9,271.3,75.9,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,273.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,273.5,74.1,274.3,75.3,273.8 C75.3,273.9,75.3,273.8,75.3,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,273.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,273.5,77.2,274.3,75.9,273.8 C75.9,273.9,75.9,273.8,75.9,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,276.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,276,74.1,276.8,75.3,276.3 C75.3,276.4,75.3,276.3,75.3,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,276.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,276,77.2,276.8,75.9,276.3 C75.9,276.4,75.9,276.3,75.9,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.3,278.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C73.2,278.5,74.1,279.3,75.3,278.8L75.3,278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M75.9,278.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C78,278.5,77.2,279.3,75.9,278.8L75.9,278.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.6,285.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S76.4,285.7,75.6,285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.8,281c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C70.4,282.2,70,281.7,69.8,281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.6,290.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C77,290.2,76.4,290.4,75.6,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.8,285.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S70,286.5,69.8,285.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 89.1,
    y1: 278.8,
    x2: 89.1,
    y2: 300.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M89.1,300.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C97.2,305.8,93.6,300.2,89.1,300.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,261.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,261,87.5,261.8,88.8,261.3 C88.7,261.4,88.8,261.4,88.8,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,261.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,261,90.6,261.8,89.3,261.3 C89.3,261.4,89.3,261.4,89.3,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89,259.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C90.3,257.9,90.3,259.1,89,259.7 C89.1,259.7,89,259.7,89,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,263.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,263.5,87.5,264.3,88.8,263.8 C88.7,263.9,88.8,263.8,88.8,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,263.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,263.5,90.6,264.3,89.3,263.8 C89.3,263.9,89.3,263.8,89.3,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,266.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,266,87.5,266.8,88.8,266.3 C88.7,266.4,88.8,266.3,88.8,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,266.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,266,90.6,266.8,89.3,266.3 C89.3,266.4,89.3,266.3,89.3,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,268.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,268.5,87.5,269.3,88.8,268.8 C88.7,268.9,88.8,268.8,88.8,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,268.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,268.5,90.6,269.3,89.3,268.8 C89.3,268.9,89.3,268.8,89.3,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,271.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,271,87.5,271.8,88.8,271.3 C88.7,271.4,88.8,271.3,88.8,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,271.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,271,90.6,271.8,89.3,271.3 C89.3,271.4,89.3,271.3,89.3,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,273.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,273.5,87.5,274.3,88.8,273.8 C88.7,273.9,88.8,273.8,88.8,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,273.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,273.5,90.6,274.3,89.3,273.8 C89.3,273.9,89.3,273.8,89.3,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,276.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,276,87.5,276.8,88.8,276.3 C88.7,276.4,88.8,276.3,88.8,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,276.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,276,90.6,276.8,89.3,276.3 C89.3,276.4,89.3,276.3,89.3,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M88.8,278.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C86.6,278.5,87.5,279.3,88.8,278.8 C88.7,278.8,88.8,278.8,88.8,278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,278.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C91.5,278.5,90.6,279.3,89.3,278.8L89.3,278.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89,285.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S89.8,285.7,89,285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.2,281c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C83.8,282.2,83.4,281.7,83.2,281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89,290.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C90.4,290.2,89.8,290.4,89,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.2,285.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C83.8,287,83.4,286.5,83.2,285.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 102.5,
    y1: 278.8,
    x2: 102.5,
    y2: 300.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M102.6,300.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C110.6,305.8,107,300.2,102.6,300.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,261.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,261,100.9,261.8,102.2,261.3 C102.2,261.4,102.2,261.4,102.2,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,261.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,261,104,261.8,102.7,261.3 C102.8,261.4,102.7,261.4,102.7,261.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.4,259.7c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C103.7,257.9,103.7,259.1,102.4,259.7 C102.5,259.7,102.4,259.7,102.4,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,263.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,263.5,100.9,264.3,102.2,263.8 C102.2,263.9,102.2,263.8,102.2,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,263.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,263.5,104,264.3,102.7,263.8 C102.8,263.9,102.7,263.8,102.7,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,266.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,266,100.9,266.8,102.2,266.3 C102.2,266.4,102.2,266.3,102.2,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,266.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,266,104,266.8,102.7,266.3 C102.8,266.4,102.7,266.3,102.7,266.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,268.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,268.5,100.9,269.3,102.2,268.8 C102.2,268.9,102.2,268.8,102.2,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,268.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,268.5,104,269.3,102.7,268.8 C102.8,268.9,102.7,268.8,102.7,268.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,271.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,271,100.9,271.8,102.2,271.3 C102.2,271.4,102.2,271.3,102.2,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,271.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,271,104,271.8,102.7,271.3 C102.8,271.4,102.7,271.3,102.7,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,273.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,273.5,100.9,274.3,102.2,273.8 C102.2,273.9,102.2,273.8,102.2,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,273.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,273.5,104,274.3,102.7,273.8 C102.8,273.9,102.7,273.8,102.7,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,276.3c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,276,100.9,276.8,102.2,276.3 C102.2,276.4,102.2,276.3,102.2,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,276.3c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,276,104,276.8,102.7,276.3 C102.8,276.4,102.7,276.3,102.7,276.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.2,278.8c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C100,278.5,100.9,279.3,102.2,278.8 L102.2,278.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M102.7,278.8c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C104.9,278.5,104,279.3,102.7,278.8 C102.8,278.8,102.7,278.8,102.7,278.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.5,285.7c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C103.8,285.4,103.2,285.7,102.5,285.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.6,281c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C97.2,282.2,96.8,281.7,96.6,281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.5,290.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C103.8,290.2,103.2,290.4,102.5,290.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.6,285.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S96.8,286.5,96.6,285.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 42.1,
    y1: 287.7,
    x2: 42.1,
    y2: 309.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M42.2,309.1c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C50.2,314.7,46.7,309.1,42.2,309.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,270.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,269.9,40.5,270.7,41.8,270.2 C41.8,270.3,41.8,270.2,41.8,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,270.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,269.9,43.7,270.7,42.4,270.2 C42.4,270.3,42.4,270.2,42.4,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.1,268.6c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C43.4,266.8,43.3,268,42.1,268.6L42.1,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,272.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,272.4,40.5,273.2,41.8,272.7 C41.8,272.8,41.8,272.7,41.8,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,272.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,272.4,43.7,273.2,42.4,272.7 C42.4,272.8,42.4,272.7,42.4,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,275.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,274.9,40.5,275.7,41.8,275.2L41.8,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,275.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,274.9,43.7,275.7,42.4,275.2L42.4,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,277.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,277.4,40.5,278.2,41.8,277.7L41.8,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,277.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,277.4,43.7,278.2,42.4,277.7L42.4,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,280.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,279.8,40.5,280.7,41.8,280.2L41.8,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,280.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,279.8,43.7,280.7,42.4,280.2L42.4,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,282.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,282.3,40.6,283.2,41.8,282.7L41.8,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,282.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,282.3,43.7,283.2,42.4,282.7L42.4,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,285.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,284.8,40.6,285.7,41.8,285.2L41.8,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,285.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,284.8,43.7,285.7,42.4,285.2L42.4,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M41.8,287.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C39.7,287.3,40.6,288.2,41.8,287.7L41.8,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M42.4,287.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C44.5,287.3,43.7,288.2,42.4,287.7L42.4,287.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.1,294.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S42.9,294.5,42.1,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.3,289.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C36.9,291.1,36.5,290.6,36.3,289.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.1,299.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C43.5,299.1,42.9,299.3,42.1,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.3,294.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S36.5,295.3,36.3,294.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 55.6,
    y1: 287.7,
    x2: 55.6,
    y2: 309.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M55.6,309.1c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C63.7,314.7,60.1,309.1,55.6,309.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,270.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,269.9,54,270.7,55.3,270.2 C55.2,270.3,55.3,270.2,55.3,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,270.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,269.9,57.1,270.7,55.8,270.2 C55.8,270.3,55.8,270.2,55.8,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.5,268.6c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C56.8,266.8,56.8,268,55.5,268.6 C55.6,268.6,55.5,268.6,55.5,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,272.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,272.4,54,273.2,55.3,272.7 C55.2,272.8,55.3,272.7,55.3,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,272.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,272.4,57.1,273.2,55.8,272.7 C55.8,272.8,55.8,272.7,55.8,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,275.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,274.9,54,275.7,55.3,275.2 C55.2,275.2,55.3,275.2,55.3,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,275.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,274.9,57.1,275.7,55.8,275.2L55.8,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,277.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,277.4,54,278.2,55.3,277.7 C55.2,277.7,55.3,277.7,55.3,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,277.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,277.4,57.1,278.2,55.8,277.7L55.8,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,280.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,279.8,54,280.7,55.3,280.2 C55.2,280.2,55.3,280.2,55.3,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,280.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,279.8,57.1,280.7,55.8,280.2L55.8,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,282.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,282.3,54,283.2,55.3,282.7 C55.2,282.7,55.3,282.7,55.3,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,282.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,282.3,57.1,283.2,55.8,282.7L55.8,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,285.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,284.8,54,285.7,55.3,285.2 C55.2,285.2,55.3,285.2,55.3,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,285.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,284.8,57.1,285.7,55.8,285.2L55.8,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.3,287.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C53.1,287.3,54,288.2,55.3,287.7 C55.2,287.7,55.3,287.7,55.3,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M55.8,287.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C58,287.3,57.1,288.2,55.8,287.7L55.8,287.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.5,294.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S56.3,294.5,55.5,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.7,289.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C50.3,291.1,49.9,290.6,49.7,289.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.5,299.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C56.9,299.1,56.3,299.3,55.5,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.7,294.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C50.3,295.9,49.9,295.3,49.7,294.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 69,
    y1: 287.7,
    x2: 69,
    y2: 309.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M69.1,309.1c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C77.1,314.7,73.5,309.1,69.1,309.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,270.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,269.9,67.4,270.7,68.7,270.2 C68.7,270.3,68.7,270.2,68.7,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,270.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,269.9,70.5,270.7,69.2,270.2 C69.3,270.3,69.2,270.2,69.2,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.9,268.6c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C70.2,266.8,70.2,268,68.9,268.6 C69,268.6,68.9,268.6,68.9,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,272.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,272.4,67.4,273.2,68.7,272.7 C68.7,272.8,68.7,272.7,68.7,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,272.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,272.4,70.5,273.2,69.2,272.7 C69.3,272.8,69.2,272.7,69.2,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,275.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,274.9,67.4,275.7,68.7,275.2L68.7,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,275.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,274.9,70.5,275.7,69.2,275.2 C69.3,275.2,69.2,275.2,69.2,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,277.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,277.4,67.4,278.2,68.7,277.7L68.7,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,277.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,277.4,70.5,278.2,69.2,277.7 C69.3,277.7,69.2,277.7,69.2,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,280.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,279.8,67.4,280.7,68.7,280.2L68.7,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,280.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,279.8,70.5,280.7,69.2,280.2 C69.3,280.2,69.2,280.2,69.2,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,282.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,282.3,67.4,283.2,68.7,282.7L68.7,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,282.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,282.3,70.5,283.2,69.2,282.7 C69.3,282.7,69.2,282.7,69.2,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,285.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,284.8,67.4,285.7,68.7,285.2L68.7,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,285.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,284.8,70.5,285.7,69.2,285.2 C69.3,285.2,69.2,285.2,69.2,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M68.7,287.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C66.5,287.3,67.4,288.2,68.7,287.7L68.7,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M69.2,287.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C71.4,287.3,70.5,288.2,69.2,287.7 C69.3,287.7,69.2,287.7,69.2,287.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69,294.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C70.3,294.3,69.7,294.5,69,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,289.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C63.7,291.1,63.3,290.6,63.1,289.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69,299.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C70.3,299.1,69.7,299.3,69,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,294.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C63.7,295.9,63.3,295.3,63.1,294.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 82.4,
    y1: 287.7,
    x2: 82.4,
    y2: 309.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M82.5,309.1c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C90.5,314.7,87,309.1,82.5,309.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,270.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,269.9,80.8,270.7,82.1,270.2 C82.1,270.3,82.1,270.2,82.1,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,270.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,269.9,83.9,270.7,82.6,270.2 C82.7,270.3,82.7,270.2,82.6,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.3,268.6c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C83.6,266.8,83.6,268,82.3,268.6 C82.4,268.6,82.4,268.6,82.3,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,272.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,272.4,80.8,273.2,82.1,272.7 C82.1,272.8,82.1,272.7,82.1,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,272.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,272.4,83.9,273.2,82.6,272.7 C82.7,272.8,82.7,272.7,82.6,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,275.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,274.9,80.8,275.7,82.1,275.2L82.1,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,275.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,274.9,83.9,275.7,82.6,275.2 C82.7,275.2,82.7,275.2,82.6,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,277.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,277.4,80.8,278.2,82.1,277.7L82.1,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,277.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,277.4,83.9,278.2,82.6,277.7 C82.7,277.7,82.7,277.7,82.6,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,280.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,279.8,80.8,280.7,82.1,280.2L82.1,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,280.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,279.8,83.9,280.7,82.6,280.2 C82.7,280.2,82.7,280.2,82.6,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,282.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C79.9,282.3,80.8,283.2,82.1,282.7L82.1,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,282.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,282.3,83.9,283.2,82.6,282.7 C82.7,282.7,82.7,282.7,82.6,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,285.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C80,284.8,80.8,285.7,82.1,285.2L82.1,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,285.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,284.8,83.9,285.7,82.6,285.2 C82.7,285.2,82.7,285.2,82.6,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.1,287.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C80,287.3,80.8,288.2,82.1,287.7L82.1,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M82.6,287.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C84.8,287.3,83.9,288.2,82.6,287.7 C82.7,287.7,82.7,287.7,82.6,287.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.4,294.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S83.1,294.5,82.4,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,289.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C77.1,291.1,76.8,290.6,76.5,289.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.4,299.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C83.8,299.1,83.1,299.3,82.4,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.5,294.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S76.8,295.3,76.5,294.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 95.8,
    y1: 287.7,
    x2: 95.8,
    y2: 309.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M95.9,309.1c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H107c0.4,0,0.6-0.5,0.2-0.7 C103.9,314.7,100.4,309.1,95.9,309.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,270.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,269.9,94.2,270.7,95.5,270.2 C95.5,270.3,95.5,270.2,95.5,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,270.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,269.9,97.4,270.7,96.1,270.2 C96.1,270.3,96.1,270.2,96.1,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.8,268.6c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C97.1,266.8,97,268,95.8,268.6L95.8,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,272.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,272.4,94.2,273.2,95.5,272.7 C95.5,272.8,95.5,272.7,95.5,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,272.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,272.4,97.4,273.2,96.1,272.7 C96.1,272.8,96.1,272.7,96.1,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,275.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,274.9,94.2,275.7,95.5,275.2L95.5,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,275.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,274.9,97.4,275.7,96.1,275.2L96.1,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,277.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,277.4,94.2,278.2,95.5,277.7L95.5,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,277.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,277.4,97.4,278.2,96.1,277.7L96.1,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,280.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,279.8,94.2,280.7,95.5,280.2L95.5,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,280.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,279.8,97.4,280.7,96.1,280.2L96.1,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,282.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,282.3,94.2,283.2,95.5,282.7L95.5,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,282.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,282.3,97.4,283.2,96.1,282.7L96.1,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,285.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,284.8,94.2,285.7,95.5,285.2L95.5,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,285.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,284.8,97.4,285.7,96.1,285.2L96.1,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M95.5,287.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C93.4,287.3,94.2,288.2,95.5,287.7L95.5,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M96.1,287.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C98.2,287.3,97.4,288.2,96.1,287.7L96.1,287.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.8,294.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C97.2,294.3,96.6,294.5,95.8,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,289.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C90.5,291.1,90.2,290.6,90,289.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.8,299.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C97.2,299.1,96.6,299.3,95.8,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,294.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C90.5,295.9,90.2,295.3,90,294.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 109.3,
    y1: 287.7,
    x2: 109.3,
    y2: 309.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M109.3,309.1c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C117.3,314.7,113.8,309.1,109.3,309.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,270.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,269.9,107.7,270.7,109,270.2 C108.9,270.3,109,270.2,109,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,270.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,269.9,110.8,270.7,109.5,270.2 C109.5,270.3,109.5,270.2,109.5,270.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.2,268.6c-1.2-0.6-1.2-1.8,0-3.6c0-0.1,0.1-0.1,0.2,0C110.5,266.8,110.5,268,109.2,268.6 C109.3,268.6,109.2,268.6,109.2,268.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,272.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,272.4,107.7,273.2,109,272.7 C108.9,272.8,109,272.7,109,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,272.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,272.4,110.8,273.2,109.5,272.7 C109.5,272.8,109.5,272.7,109.5,272.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,275.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,274.9,107.7,275.7,109,275.2 C108.9,275.2,109,275.2,109,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,275.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,274.9,110.8,275.7,109.5,275.2 L109.5,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,277.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,277.4,107.7,278.2,109,277.7 C108.9,277.7,109,277.7,109,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,277.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,277.4,110.8,278.2,109.5,277.7 L109.5,277.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,280.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,279.8,107.7,280.7,109,280.2 C108.9,280.2,109,280.2,109,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,280.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,279.8,110.8,280.7,109.5,280.2 L109.5,280.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,282.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,282.3,107.7,283.2,109,282.7 C108.9,282.7,109,282.7,109,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,282.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,282.3,110.8,283.2,109.5,282.7 L109.5,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,285.2c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,284.8,107.7,285.7,109,285.2 C108.9,285.2,109,285.2,109,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,285.2c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,284.8,110.8,285.7,109.5,285.2 L109.5,285.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109,287.7c0.4-1.2-0.4-2.1-2.5-2.6c-0.1,0-0.1,0-0.1,0.1C106.8,287.3,107.7,288.2,109,287.7 C108.9,287.7,109,287.7,109,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M109.5,287.7c-0.4-1.2,0.4-2.1,2.5-2.6c0.1,0,0.1,0,0.1,0.1C111.7,287.3,110.8,288.2,109.5,287.7 L109.5,287.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.2,294.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S110,294.5,109.2,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.4,289.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C104,291.1,103.6,290.6,103.4,289.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.2,299.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C110.6,299.1,110,299.3,109.2,299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.4,294.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S103.6,295.3,103.4,294.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 712.1,
    y: 49.8,
    width: 37.9,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    className: "st30"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 741.8,
    cy: 80.7,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 744.1,
    cy: 88.3,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 749.7,
    cy: 74.1,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 755,
    cy: 76.9,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 753.5,
    cy: 91.6,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 751.7,
    cy: 83.1,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 759.5,
    cy: 83.8,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 732.9,
    cy: 83.9,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 734.1,
    cy: 90.3,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 759,
    cy: 91.1,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M733.9,84.6c4.6,3.2,11.3,6.2,12.2,12.3c0.2,6.9,0.8,14.6-2.4,20.8c0,0.1,0,0.2,0.1,0.2h9.1 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.3-1.9-8.7-2.6-13.4l0,0c-0.8-4.1-1.1-7.2,2.4-10.2c1.4-1.4,2.8-2.8,4.1-4.2 c1.4-1,2.3-1.7,2.9-3.6c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.3-4.4,4.9-6.9,7c1-2.4,1.7-5.8,1.8-8.2c-0.8,2.8-1,6.4-2.9,8.8 c-1.2,0.8-2.6,1.3-3.3,2.6c-3.3-4.3-0.5-10.1-2-14.8c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.7-1.1,7.1c-3.1-1.6-5.5-3.2-6.2-6.7l0,0 c-0.7-1.2-0.9-2.8-1.4-3.9c0.6,2.8,1.3,5.5,2.8,8c-1.7-0.7-3.8-2.1-5.2-2.7C735.3,85.4,730.4,82.1,733.9,84.6z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 712.1,
    y: 331.5,
    width: 37.9,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 741.8,
    cy: 362.4,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 744.1,
    cy: 370,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 749.7,
    cy: 355.8,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 755,
    cy: 358.6,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 753.5,
    cy: 373.3,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 751.7,
    cy: 364.8,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 759.5,
    cy: 365.5,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 732.9,
    cy: 365.6,
    r: 4.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 734.1,
    cy: 372,
    r: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 759,
    cy: 372.8,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M733.9,366.3c4.6,3.2,11.3,6.2,12.2,12.3c0.2,6.9,0.8,14.6-2.4,20.8c0,0.1,0,0.2,0.1,0.2h9.1 c0.1,0,0.2-0.1,0.1-0.2c-2.1-4.3-1.9-8.7-2.6-13.4l0,0c-0.8-4.1-1.1-7.2,2.4-10.2c1.4-1.4,2.8-2.8,4.1-4.2 c1.4-1,2.3-1.7,2.9-3.6c0.3-0.7,0.3-1.3,0.2-1.1c-0.8,3.3-4.4,4.9-6.9,7c1-2.4,1.7-5.8,1.8-8.2c-0.8,2.8-1,6.4-2.9,8.8 c-1.2,0.8-2.6,1.3-3.3,2.6c-3.3-4.3-0.5-10.1-2-14.8c-0.5-1.8,0.3,2.1,0,3c0,2.4-0.7,4.7-1.1,7.1c-3.1-1.6-5.5-3.2-6.2-6.7l0,0 c-0.7-1.2-0.9-2.8-1.4-3.9c0.6,2.8,1.3,5.5,2.8,8c-1.7-0.7-3.8-2.1-5.2-2.7C735.3,367.1,730.4,363.8,733.9,366.3z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    y: 319.3,
    width: 37.9,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    className: "st32"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 8.2,
    cy: 350.1,
    r: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 5.9,
    cy: 357.7,
    r: 8.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -2.456983e-03 2.456983e-03 1 -0.844 1.773883e-03)",
    className: "st1",
    cx: 0.3,
    cy: 343.5,
    rx: 3.8,
    ry: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -5,
    cy: 346.3,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -3.5,
    cy: 361,
    r: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.830856e-03 -1 1 4.830856e-03 -354.1867 349.0982)",
    className: "st1",
    cx: -1.7,
    cy: 352.5,
    rx: 5.3,
    ry: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.960363e-02 -0.9998 0.9998 1.960363e-02 -362.4297 336.7952)",
    className: "st1",
    cx: -9.5,
    cy: 353.2,
    rx: 7.8,
    ry: 7.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1.817843e-02 -0.9998 0.9998 1.817843e-02 -336.4374 363.9887)",
    className: "st1",
    cx: 17.1,
    cy: 353.3,
    rx: 4.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9998 -2.040438e-02 2.040438e-02 0.9998 -7.3358 0.3993)",
    className: "st1",
    cx: 15.9,
    cy: 359.7,
    rx: 3.3,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -9,
    cy: 360.5,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M16.1,354c-4.6,3.2-11.3,6.2-12.2,12.3C3.7,373.2,3,381,6.2,387.2c0,0.1,0,0.2-0.1,0.2H-3 c-0.1,0-0.2-0.1-0.1-0.2c2.1-4.3,1.9-8.7,2.6-13.4l0,0c0.8-4.1,1.1-7.2-2.4-10.2c-1.4-1.4-2.8-2.8-4.1-4.2 c-1.4-1-2.3-1.7-2.9-3.6c-0.3-0.7-0.3-1.3-0.2-1.1c0.8,3.3,4.4,4.9,6.9,7c-1-2.4-1.7-5.8-1.8-8.2c0.8,2.8,1,6.4,2.9,8.8 c1.2,0.8,2.6,1.3,3.3,2.6c3.3-4.3,0.5-10.1,2-14.8c0.5-1.8-0.3,2.1,0,3c0,2.4,0.7,4.7,1.1,7.1c3.1-1.6,5.5-3.2,6.2-6.7l0,0 c0.7-1.2,0.9-2.8,1.4-3.9c-0.6,2.8-1.3,5.5-2.8,8c1.7-0.7,3.8-2.1,5.2-2.7C14.7,354.8,19.6,351.5,16.1,354z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    y: 1470.1,
    width: 37.9,
    height: 79.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(9.345360e-03 -1 1 9.345360e-03 -1492.7948 1495.1886)",
    className: "st1",
    cx: 8.2,
    cy: 1501,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.739285e-03 -1 1 4.739285e-03 -1502.7067 1507.3544)",
    className: "st1",
    cx: 5.9,
    cy: 1508.6,
    rx: 8.9,
    ry: 8.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 0.3,
    cy: 1494.3,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -5,
    cy: 1497.2,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -3.5,
    cy: 1511.9,
    r: 5.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -1.7,
    cy: 1503.4,
    r: 5.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -4.877989e-03 4.877989e-03 1 -7.3371 -2.844580e-02)",
    className: "st1",
    cx: -9.5,
    cy: 1504.1,
    rx: 7.8,
    ry: 7.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -4.975088e-03 4.975088e-03 1 -7.4833 0.1037)",
    className: "st1",
    cx: 17.1,
    cy: 1504.2,
    rx: 4.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(4.830887e-03 -1 1 4.830887e-03 -1494.7548 1519.2067)",
    className: "st1",
    cx: 15.9,
    cy: 1510.6,
    rx: 3.3,
    ry: 3.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -9,
    cy: 1511.4,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M16.1,1504.9c-4.6,3.2-11.3,6.2-12.2,12.3c-0.2,6.9-0.8,14.6,2.4,20.8c0,0.1,0,0.2-0.1,0.2H-3 c-0.1,0-0.2-0.1-0.1-0.2c2.1-4.3,1.9-8.7,2.6-13.4l0,0c0.8-4.1,1.1-7.2-2.4-10.2c-1.4-1.4-2.8-2.8-4.1-4.2 c-1.4-1-2.3-1.7-2.9-3.6c-0.3-0.7-0.3-1.3-0.2-1.1c0.8,3.3,4.4,4.9,6.9,7c-1-2.4-1.7-5.8-1.8-8.2c0.8,2.8,1,6.4,2.9,8.8 c1.2,0.8,2.6,1.3,3.3,2.6c3.3-4.3,0.5-10.1,2-14.8c0.5-1.8-0.3,2.1,0,3c0,2.4,0.7,4.7,1.1,7.1c3.1-1.6,5.5-3.2,6.2-6.7l0,0 c0.7-1.2,0.9-2.8,1.4-3.9c-0.6,2.8-1.3,5.5-2.8,8c1.7-0.7,3.8-2.1,5.2-2.7C14.7,1505.7,19.6,1502.4,16.1,1504.9z"
  })))))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 678.4,
    cy: 1317.1,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 681.3,
    cy: 1326.5,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 688.2,
    cy: 1309,
    r: 4.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 694.7,
    cy: 1312.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 692.9,
    cy: 1330.6,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 690.6,
    cy: 1320.1,
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 700.2,
    cy: 1320.9,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 667.5,
    cy: 1321,
    r: 5.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 669,
    cy: 1329,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 699.6,
    cy: 1330,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M668.7,1322c5.6,3.9,13.9,7.7,15,15.1c0.2,8.5,1,18-2.9,25.6c-0.1,0.1,0,0.2,0.1,0.2h11.2 c0.1,0,0.2-0.1,0.1-0.2c-2.5-5.3-2.4-10.7-3.2-16.5l0,0c-1-5-1.3-8.8,2.9-12.5c1.7-1.7,3.4-3.4,5.1-5.2c1.7-1.2,2.8-2.1,3.6-4.4 c0.3-0.8,0.3-1.6,0.3-1.3c-1,4.1-5.4,6.1-8.5,8.6c1.3-3,2.1-7.2,2.2-10.1c-1,3.5-1.2,7.9-3.6,10.8c-1.4,1-3.2,1.6-4.1,3.3 c-4.1-5.3-0.6-12.4-2.5-18.2c-0.6-2.2,0.4,2.5,0,3.7c0,2.9-0.8,5.8-1.3,8.7c-3.9-1.9-6.8-3.9-7.7-8.3l0,0c-0.9-1.5-1.1-3.4-1.8-4.8 c0.7,3.4,1.5,6.8,3.4,9.9c-2-0.8-4.6-2.6-6.3-3.4C670.4,1322.9,664.4,1318.9,668.7,1322z"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 684,
    cy: 778.5,
    r: 13.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 687.4,
    cy: 789.8,
    r: 13.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 695.9,
    cy: 768.5,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 703.8,
    cy: 772.8,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 701.6,
    cy: 794.8,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 698.8,
    cy: 782.1,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 710.5,
    cy: 783.1,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 670.6,
    cy: 783.2,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 672.5,
    cy: 792.9,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 709.8,
    cy: 794.1,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M672.2,784.4c6.8,4.8,17,9.4,18.3,18.5c0.3,10.3,1.2,21.9-3.5,31.3c-0.1,0.1,0,0.3,0.2,0.3h13.7 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.4-2.9-13.1-4-20.1l0,0c-1.2-6.1-1.6-10.8,3.6-15.2c2.1-2.1,4.2-4.2,6.2-6.3c2.1-1.5,3.4-2.6,4.4-5.4 c0.4-1,0.4-1.9,0.3-1.6c-1.2,5-6.6,7.4-10.3,10.5c1.6-3.6,2.5-8.7,2.7-12.3c-1.3,4.2-1.5,9.6-4.4,13.2c-1.8,1.2-3.9,2-5,4 c-5-6.5-0.7-15.2-3-22.2c-0.8-2.7,0.5,3.1,0,4.5c0,3.5-1,7.1-1.6,10.6c-4.7-2.3-8.3-4.7-9.3-10.1l0,0c-1.1-1.8-1.3-4.2-2.2-5.8 c0.9,4.2,1.9,8.3,4.2,12.1c-2.5-1-5.6-3.1-7.7-4.1C674.2,785.5,666.9,780.6,672.2,784.4z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 104.5,
    cy: 689.7,
    r: 13.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 108,
    cy: 701,
    r: 13.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 116.4,
    cy: 679.7,
    r: 5.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.652066e-02 -0.9978 0.9978 6.652066e-02 -566.4886 762.4985)",
    className: "st15",
    cx: 124.3,
    cy: 684,
    rx: 7.9,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 122.1,
    cy: 706,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 119.3,
    cy: 693.3,
    r: 7.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 131,
    cy: 694.3,
    r: 11.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 91.1,
    cy: 694.4,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 93,
    cy: 704.1,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 130.3,
    cy: 705.3,
    r: 4.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M92.7,695.6c6.8,4.8,17,9.4,18.3,18.5c0.3,10.3,1.2,21.9-3.5,31.3c-0.1,0.1,0,0.3,0.2,0.3h13.7 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.4-2.9-13.1-4-20.1l0,0c-1.2-6.1-1.6-10.8,3.6-15.2c2.1-2.1,4.2-4.2,6.2-6.3c2.1-1.5,3.4-2.6,4.4-5.4 c0.4-1,0.4-1.9,0.3-1.6c-1.2,5-6.6,7.4-10.3,10.5c1.6-3.6,2.5-8.7,2.7-12.3c-1.3,4.2-1.5,9.6-4.4,13.2c-1.8,1.2-3.9,2-5,4 c-5-6.5-0.7-15.2-3-22.2c-0.8-2.7,0.5,3.1,0,4.5c0,3.5-1,7.1-1.6,10.6c-4.7-2.3-8.3-4.7-9.3-10.1l0,0c-1.1-1.8-1.3-4.2-2.2-5.8 c0.9,4.2,1.9,8.3,4.2,12.1c-2.5-1-5.6-3.1-7.7-4.1C94.7,696.8,87.4,691.8,92.7,695.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 469.6,
    y: 1712.7,
    width: 109.3,
    height: 72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 511.3,
    cy: 1759,
    r: 18.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 516.1,
    cy: 1774.6,
    r: 18.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 527.6,
    cy: 1745.4,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 538.4,
    cy: 1751.3,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 535.4,
    cy: 1781.4,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 531.6,
    cy: 1764,
    r: 10.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 547.7,
    cy: 1765.4,
    r: 16.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 493,
    cy: 1765.6,
    r: 9.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 495.6,
    cy: 1778.8,
    r: 6.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 546.6,
    cy: 1780.4,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M495.1,1767.1c9.4,6.5,23.2,12.8,25.1,25.3c0.4,14.1,1.7,30-4.8,42.8c-0.1,0.2,0,0.4,0.2,0.4h18.7 c0.2,0,0.3-0.2,0.2-0.4c-4.2-8.8-4-17.9-5.4-27.6l0,0c-1.7-8.4-2.2-14.7,4.9-20.9c2.9-2.8,5.7-5.7,8.5-8.6 c2.9-2.1,4.7-3.6,6-7.4c0.5-1.4,0.6-2.7,0.4-2.2c-1.6,6.8-9,10.2-14.1,14.3c2.1-4.9,3.4-11.9,3.7-16.8c-1.7,5.8-2,13.2-6,18 c-2.4,1.6-5.4,2.7-6.9,5.4c-6.8-8.9-1-20.8-4.1-30.3c-1.1-3.7,0.7,4.2,0,6.1c0,4.9-1.4,9.7-2.2,14.5 c-6.4-3.2-11.3-6.5-12.8-13.8l0,0c-1.5-2.5-1.8-5.8-3-8c1.2,5.7,2.6,11.3,5.7,16.5c-3.4-1.4-7.7-4.3-10.6-5.6 C498,1768.7,487.9,1761.9,495.1,1767.1z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 228.5,
    y: 1729.5,
    width: 128.8,
    height: 55.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 283.2,
    cy: 1776.6,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 286.6,
    cy: 1787.9,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 294.9,
    cy: 1766.8,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 302.7,
    cy: 1771.1,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 300.5,
    cy: 1792.8,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 297.8,
    cy: 1780.2,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 309.3,
    cy: 1781.2,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 270,
    cy: 1781.3,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 271.9,
    cy: 1790.9,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 308.6,
    cy: 1792.1,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M271.5,1782.5c6.7,4.7,16.7,9.2,18.1,18.2c0.3,10.2,1.2,21.6-3.5,30.8c-0.1,0.1,0,0.3,0.2,0.3h13.4 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.3-2.9-12.9-3.9-19.8l0,0c-1.2-6-1.6-10.6,3.5-15c2.1-2,4.1-4.1,6.1-6.2c2.1-1.5,3.3-2.6,4.3-5.3 c0.4-1,0.4-1.9,0.3-1.6c-1.1,4.9-6.5,7.3-10.2,10.3c1.5-3.6,2.5-8.6,2.7-12.1c-1.3,4.2-1.5,9.5-4.3,13c-1.7,1.2-3.9,2-4.9,3.9 c-4.9-6.4-0.7-14.9-3-21.8c-0.8-2.6,0.5,3.1,0,4.4c0,3.5-1,7-1.6,10.4c-4.6-2.3-8.1-4.7-9.2-9.9l0,0c-1.1-1.8-1.3-4.1-2.1-5.7 c0.9,4.1,1.8,8.2,4.1,11.9c-2.4-1-5.5-3.1-7.6-4C273.6,1783.6,266.4,1778.7,271.5,1782.5z"
  })))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "tracteur_00000013905282339801389430000008432207230358831789_",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_155_00000172430055029460052130000005323221825269062314_",
    transform: "translate(40.79 22.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_274_00000156579629709977294380000016406548596781059493_",
    className: "st1",
    d: "M626.9,554.5v-2.9l0.9-0.2 c0.1-0.5,0.2-0.9,0.3-1.4l-0.7-0.5l1.1-2.7l0.9,0.1c0.2-0.4,0.5-0.8,0.8-1.2l-0.5-0.8l2.1-2.1l0.8,0.5c0.4-0.3,0.8-0.5,1.2-0.8 l-0.1-0.9l2.7-1.1l0.5,0.7c0.5-0.1,1-0.2,1.4-0.3l0.2-0.8h2.9l0.2,0.8c0.5,0.1,0.9,0.2,1.4,0.3l0.5-0.7l2.7,1.1l-0.1,0.8 c0.4,0.2,0.8,0.5,1.2,0.8l0.7-0.4l2.1,2.1l-0.4,0.7c0.3,0.4,0.6,0.8,0.8,1.2l0.8-0.1l1.1,2.7l-0.7,0.5c0.1,0.5,0.2,1,0.3,1.5 l0.8,0.2v2.9l-0.8,0.2c-0.1,0.5-0.2,1-0.3,1.4l0.7,0.5l-1.1,2.7l-0.8-0.1c-0.3,0.4-0.5,0.8-0.8,1.2l0.4,0.7l-2.1,2.1l-0.7-0.4 c-0.4,0.3-0.8,0.6-1.2,0.8l0.1,0.8l-2.7,1.1l-0.5-0.7c-0.5,0.1-1,0.2-1.4,0.3l-0.2,0.8h-2.9l-0.2-0.8c-0.5-0.1-0.9-0.2-1.4-0.3 l-0.5,0.7l-2.7-1.1l0.1-0.9c-0.4-0.2-0.8-0.5-1.2-0.8l-0.8,0.5l-2.1-2.1l0.5-0.8c-0.3-0.4-0.5-0.8-0.8-1.2l-0.9,0.1l-1.1-2.7 l0.7-0.5c-0.1-0.5-0.2-0.9-0.3-1.4L626.9,554.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8862_00000174585558982687308350000005577778963527557522_",
    className: "st15",
    cx: 639.8,
    cy: 553.1,
    rx: 5.9,
    ry: 5.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8863_00000006708756581365124620000012776569552660276396_",
    className: "st36",
    cx: 639.8,
    cy: 553.1,
    rx: 2.2,
    ry: 2.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_275_00000097459419019243930820000016655749135141048711_",
    className: "st37",
    d: "M631,559.8l23.5-3.1l10.2-0.5l19.2,1.8 l4.6,4.2v1.3c-6.9-4.3-16-2.3-20.3,4.6c-1.5,2.4-2.3,5.1-2.3,7.9c0,0.4,0,0.8,0.1,1.2h-12.2c-0.7-6.7-6.6-11.6-13.4-11 c-5.8,0.6-10.4,5.2-11,11h-1.7v-13.5C627.8,561.7,629.2,560.1,631,559.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_150_00000011736244458636046370000014785326689059287426_",
    className: "st36",
    d: "M658,540.1h25 c0.5,0,0.9,0.4,0.9,0.9l0,0c0,0.5-0.4,0.9-0.9,0.9h-25c-0.5,0-0.9-0.4-0.9-0.9l0,0C657.1,540.5,657.5,540.1,658,540.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_276_00000013896218267339355740000007876727083725180306_",
    className: "st15",
    d: "M683.9,558l-1.2-16h-24.4l-3.8,14.7 h4.2v9.2h7c0,0,1.8-7.9,8-7.9C679.3,558,683.9,558,683.9,558z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_65_00000171702988886222138680000005441443684681497739_",
    className: "st38",
    x1: 658.3,
    y1: 557.2,
    x2: 660.4,
    y2: 542
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_66_00000013876320344562205930000014422606141543801274_",
    className: "st38",
    x1: 673.8,
    y1: 558,
    x2: 672.8,
    y2: 542
  }), /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M683.9,558L683.9,558c-0.6,0-5,0-10.2,0c-6.2,0-8,7.9-8,7.9h-7v-9.2h-4.2l0,0l-23.5,3.1 c-1.9,0.3-3.3,1.9-3.3,3.7V577h1.7c0.6-5.8,5.2-10.4,11-11c6.7-0.7,12.7,4.3,13.4,11H666c0-0.4-0.1-0.8-0.1-1.2 c0-2.8,0.8-5.5,2.3-7.9c4.3-6.9,13.4-8.9,20.3-4.6V562L683.9,558z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_156_00000109012596821813220070000011269821309969564056_",
    transform: "translate(4.138 27.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_277_00000042716403237714587190000003062077338404334761_",
    className: "st1",
    d: "M626.9,551.9v-2.4l0.7-0.2 c0.1-0.4,0.1-0.7,0.2-1.1l-0.6-0.4l0.9-2.2l0.7,0.1c0.2-0.3,0.4-0.7,0.7-1l-0.4-0.6l1.7-1.7l0.6,0.4c0.3-0.2,0.6-0.4,1-0.6 l-0.1-0.7l2.2-0.9l0.4,0.6c0.4-0.1,0.8-0.2,1.2-0.2l0.2-0.7h2.4l0.2,0.7c0.4,0.1,0.8,0.1,1.1,0.2l0.4-0.6l2.2,0.9l-0.1,0.7 c0.4,0.2,0.7,0.4,1,0.7l0.6-0.4l1.7,1.7l-0.4,0.6c0.2,0.3,0.5,0.6,0.7,1l0.7-0.1l0.9,2.2l-0.5,0.4c0.1,0.4,0.2,0.8,0.2,1.2 l0.7,0.2v2.4l-0.7,0.2c-0.1,0.4-0.1,0.8-0.2,1.2l0.5,0.4l-0.9,2.2l-0.7-0.1c-0.2,0.4-0.4,0.7-0.7,1l0.4,0.6l-1.7,1.7l-0.6-0.4 c-0.3,0.2-0.6,0.5-1,0.7l0.1,0.7l-2.2,0.9l-0.4-0.6c-0.4,0.1-0.8,0.2-1.2,0.2l-0.2,0.7h-2.4l-0.2-0.7c-0.4-0.1-0.8-0.1-1.1-0.2 l-0.4,0.6l-2.2-0.9l0.1-0.7c-0.3-0.2-0.7-0.4-1-0.7l-0.6,0.4l-1.7-1.7l0.4-0.6c-0.2-0.3-0.4-0.6-0.6-0.9l-0.7,0.1l-0.9-2.2 l0.6-0.4c-0.1-0.4-0.2-0.8-0.2-1.2L626.9,551.9z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8864_00000177448765488067773420000011445547080441882294_",
    className: "st15",
    cx: 637.5,
    cy: 550.7,
    rx: 4.8,
    ry: 4.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8865_00000069394120841502570650000001210546169805768374_",
    className: "st36",
    cx: 637.5,
    cy: 550.7,
    rx: 1.8,
    ry: 1.8
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151_00000080201545440012257830000014205417589049539228_",
    x: 626.9,
    y: 569,
    className: "st15",
    width: 1.8,
    height: 6.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_278_00000182505849849134400890000017889398931127157399_",
    className: "st15",
    d: "M627.8,563.1l5.4-0.8 c0,0-0.3,2.9-1.4,3.5c-1.3,0.5-2.6,0.8-4,1.1V563.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_279_00000160898608972146245500000018232382757568112798_",
    className: "st1",
    d: "M647.5,557.6l2.7-0.4V552h-2.7V557.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_280_00000085932448885800382290000005685563927125128347_",
    className: "st1",
    d: "M648,551.3h1.7l0.5,0.7h-2.7L648,551.3z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_281_00000176755825944766708490000002323089201665202611_",
    className: "st1",
    d: "M648.2,551.3h1.4v-2.2 c0-0.4-0.3-0.7-0.7-0.7l0,0H647l0.5,1.4h0.6v1.5H648.2z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M383.1,786.6v-28H309l-18.5,14l18.5,14h27.4v37.7c-0.4-0.6-0.8-1.2-1.3-1.7c-1.2-1.6-2.6-3-4-4.3 c1.1,1.6,2.2,3.2,3.2,4.9c0.8,1.4,1.5,2.9,2.1,4.5c0,0.2-0.1,0.4-0.1,0.5c-0.2,0.7-0.3,1.4-0.4,2.1c-0.4-0.6-0.8-1.1-1.3-1.6 c-1.3-1.5-2.8-2.9-4.3-4.2s-3.2-2.4-4.8-3.4c1.5,1.3,2.9,2.7,4.1,4.1c1.3,1.5,2.4,3,3.4,4.6c0.4,0.8,0.9,1.5,1.2,2.3 c-0.6-0.5-1.2-1-1.9-1.5c-1.3-1-2.7-1.7-4.1-2.4c-1.4-0.6-3-1-4.5-1.2c1.4,0.5,2.8,1.2,4,2c1.2,0.9,2.3,1.8,3.3,3 c1,1.1,1.8,2.3,2.6,3.5c0.2,0.4,0.5,0.8,0.7,1.2c0.1,0.5,0.6,3.9-1.6,3.9h15.8c0,0-1.7-0.8-0.9-3.9l0,0c0.2-0.5,0.5-0.9,0.7-1.3 c0.7-1.2,1.6-2.3,2.6-3.3s2.2-1.8,3.5-2.5s2.8-1,4.3-1.3c-1.5,0-3.1,0-4.6,0.4c-1.5,0.3-3,1-4.4,1.8c-0.9,0.6-1.8,1.2-2.6,1.9 c0.2-0.5,0.4-1,0.7-1.4c0.7-1.3,1.6-2.5,2.6-3.6s2.2-2,3.5-2.9c-1.4,0.5-2.9,1.2-4.1,2.1c-1.3,0.9-2.5,2-3.5,3.2 c-0.5,0.6-0.9,1.1-1.4,1.8v-9.8c0-0.1,0.1-0.3,0.1-0.4c0.4-1.9,1.2-3.6,2-5.4c-0.7,1.1-1.5,2.2-2.1,3.3v-32.8h38.2L383.1,786.6 L383.1,786.6z"
  })), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 40.4,
    y1: 1689.8,
    x2: 40.4,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M40.5,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C48.5,1716.8,45,1711.2,40.5,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.4,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C41.8,1696.5,41.2,1696.7,40.4,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.6,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C35.1,1693.3,34.8,1692.7,34.6,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.4,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C41.8,1701.2,41.2,1701.5,40.4,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.6,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C35.1,1698.1,34.8,1697.5,34.6,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M40.5,1677.1c1.4,2.4,1.4,5.4,0,7.8C39.1,1682.5,39.1,1679.5,40.5,1677.1L40.5,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M37.8,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C38.3,1683.1,37.3,1680.3,37.8,1677.5L37.8,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M35.4,1678.9c2.6,1,4.5,3.3,5,6C37.9,1683.9,35.9,1681.6,35.4,1678.9L35.4,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M33.7,1681c2.8,0,5.4,1.5,6.8,3.9C37.7,1684.9,35.1,1683.4,33.7,1681L33.7,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M32.7,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C37.8,1685.8,34.9,1685.3,32.7,1683.5L32.7,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M32.7,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C38.3,1686.7,35.4,1687.2,32.7,1686.3L32.7,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M33.7,1688.8c1.4-2.4,4-3.9,6.8-3.9C39.1,1687.3,36.4,1688.8,33.7,1688.8L33.7,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M35.4,1690.9c0.5-2.7,2.4-5,5-6C40,1687.6,38,1689.9,35.4,1690.9L35.4,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M37.8,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C40.9,1687.6,39.9,1690.5,37.8,1692.3L37.8,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M40.5,1692.7c-1.4-2.4-1.4-5.4,0-7.8C41.8,1687.3,41.8,1690.3,40.5,1692.7L40.5,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M43.1,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C42.6,1686.7,43.6,1689.5,43.1,1692.3L43.1,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M45.5,1690.9c-2.6-1-4.5-3.3-5-6C43.1,1685.9,45,1688.2,45.5,1690.9L45.5,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M47.2,1688.8c-2.8,0-5.4-1.5-6.8-3.9C43.2,1684.9,45.8,1686.4,47.2,1688.8L47.2,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M48.2,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C43.1,1684,46,1684.5,48.2,1686.3L48.2,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M48.2,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C42.6,1683.1,45.6,1682.6,48.2,1683.5L48.2,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M47.2,1681c-1.4,2.4-4,3.9-6.8,3.9C41.9,1682.5,44.5,1681,47.2,1681L47.2,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M45.5,1678.9c-0.5,2.7-2.4,5-5,6C41,1682.2,42.9,1679.9,45.5,1678.9L45.5,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M43.1,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C40,1682.2,41,1679.4,43.1,1677.5L43.1,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 40.5,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 53.8,
    y1: 1689.8,
    x2: 53.8,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M53.9,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H65c0.4,0,0.6-0.5,0.2-0.7 C61.9,1716.8,58.4,1711.2,53.9,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C55.2,1696.5,54.5,1696.7,53.8,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.9,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C48.5,1693.3,48.2,1692.7,47.9,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.8,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C55.2,1701.2,54.5,1701.5,53.8,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.9,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C48.5,1698.1,48.2,1697.5,47.9,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M53.8,1677.1c1.4,2.4,1.4,5.4,0,7.8C52.5,1682.5,52.5,1679.5,53.8,1677.1L53.8,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M51.2,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C51.7,1683.1,50.7,1680.3,51.2,1677.5L51.2,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M48.8,1678.9c2.6,1,4.5,3.3,5,6C51.2,1683.9,49.3,1681.6,48.8,1678.9L48.8,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M47.1,1681c2.8,0,5.4,1.5,6.8,3.9C51.1,1684.9,48.5,1683.4,47.1,1681L47.1,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M46.1,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C51.2,1685.8,48.3,1685.3,46.1,1683.5L46.1,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M46.1,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C51.7,1686.7,48.7,1687.2,46.1,1686.3L46.1,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M47.1,1688.8c1.4-2.4,4-3.9,6.8-3.9C52.4,1687.3,49.8,1688.8,47.1,1688.8L47.1,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M48.8,1690.9c0.5-2.7,2.4-5,5-6C53.3,1687.6,51.4,1689.9,48.8,1690.9L48.8,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M51.2,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C54.3,1687.6,53.3,1690.5,51.2,1692.3L51.2,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M53.8,1692.7c-1.4-2.4-1.4-5.4,0-7.8C55.2,1687.3,55.2,1690.3,53.8,1692.7L53.8,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M56.5,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C56,1686.7,57,1689.5,56.5,1692.3L56.5,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M58.9,1690.9c-2.6-1-4.5-3.3-5-6C56.4,1685.9,58.4,1688.2,58.9,1690.9L58.9,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M60.6,1688.8c-2.8,0-5.4-1.5-6.8-3.9C56.6,1684.9,59.2,1686.4,60.6,1688.8L60.6,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M61.6,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C56.5,1684,59.4,1684.5,61.6,1686.3L61.6,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M61.6,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C56,1683.1,58.9,1682.6,61.6,1683.5L61.6,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M60.6,1681c-1.4,2.4-4,3.9-6.8,3.9C55.3,1682.5,57.9,1681,60.6,1681L60.6,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M58.9,1678.9c-0.5,2.7-2.4,5-5,6C54.4,1682.2,56.3,1679.9,58.9,1678.9L58.9,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M56.5,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C53.4,1682.2,54.4,1679.4,56.5,1677.5L56.5,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 53.8,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 67.2,
    y1: 1689.8,
    x2: 67.2,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M67.3,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C75.3,1716.8,71.8,1711.2,67.3,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.2,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C68.6,1696.5,67.9,1696.7,67.2,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.3,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C61.9,1693.3,61.6,1692.7,61.3,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.2,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C68.6,1701.2,67.9,1701.5,67.2,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.3,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C61.9,1698.1,61.6,1697.5,61.3,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M67.2,1677.1c1.4,2.4,1.4,5.4,0,7.8C65.9,1682.5,65.9,1679.5,67.2,1677.1L67.2,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M64.6,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C65.1,1683.1,64.1,1680.3,64.6,1677.5L64.6,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M62.2,1678.9c2.6,1,4.5,3.3,5,6C64.6,1683.9,62.7,1681.6,62.2,1678.9L62.2,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M60.4,1681c2.8,0,5.4,1.5,6.8,3.9C64.5,1684.9,61.9,1683.4,60.4,1681L60.4,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M59.5,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C64.6,1685.8,61.7,1685.3,59.5,1683.5L59.5,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M59.5,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C65.1,1686.7,62.1,1687.2,59.5,1686.3L59.5,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M60.4,1688.8c1.4-2.4,4-3.9,6.8-3.9C65.8,1687.3,63.2,1688.8,60.4,1688.8L60.4,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M62.2,1690.9c0.5-2.7,2.4-5,5-6C66.7,1687.6,64.8,1689.9,62.2,1690.9L62.2,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M64.6,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C67.7,1687.6,66.7,1690.5,64.6,1692.3L64.6,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M67.2,1692.7c-1.4-2.4-1.4-5.4,0-7.8C68.6,1687.3,68.6,1690.3,67.2,1692.7L67.2,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M69.9,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C69.3,1686.7,70.4,1689.5,69.9,1692.3L69.9,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M72.3,1690.9c-2.6-1-4.5-3.3-5-6C69.8,1685.9,71.8,1688.2,72.3,1690.9L72.3,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M74,1688.8c-2.8,0-5.4-1.5-6.8-3.9C70,1684.9,72.6,1686.4,74,1688.8L74,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M74.9,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C69.8,1684,72.8,1684.5,74.9,1686.3L74.9,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M74.9,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C69.4,1683.1,72.3,1682.6,74.9,1683.5L74.9,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M74,1681c-1.4,2.4-4,3.9-6.8,3.9C68.6,1682.5,71.2,1681,74,1681L74,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M72.3,1678.9c-0.5,2.7-2.4,5-5,6C67.7,1682.2,69.7,1679.9,72.3,1678.9L72.3,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M69.9,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C66.8,1682.2,67.8,1679.4,69.9,1677.5L69.9,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 67.2,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 80.6,
    y1: 1689.8,
    x2: 80.6,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M80.7,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C88.7,1716.8,85.1,1711.2,80.7,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.6,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C81.9,1696.5,81.3,1696.7,80.6,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.7,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C75.3,1693.3,74.9,1692.7,74.7,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.6,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C81.9,1701.2,81.3,1701.5,80.6,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.7,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C75.3,1698.1,74.9,1697.5,74.7,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M80.6,1677.1c1.4,2.4,1.4,5.4,0,7.8C79.2,1682.5,79.3,1679.5,80.6,1677.1L80.6,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M77.9,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C78.5,1683.1,77.5,1680.3,77.9,1677.5L77.9,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M75.6,1678.9c2.6,1,4.5,3.3,5,6C78,1683.9,76.1,1681.6,75.6,1678.9L75.6,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M73.8,1681c2.8,0,5.4,1.5,6.8,3.9C77.8,1684.9,75.2,1683.4,73.8,1681L73.8,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M72.9,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C78,1685.8,75,1685.3,72.9,1683.5L72.9,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M72.9,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C78.5,1686.7,75.5,1687.2,72.9,1686.3L72.9,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M73.8,1688.8c1.4-2.4,4-3.9,6.8-3.9C79.2,1687.3,76.6,1688.8,73.8,1688.8L73.8,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M75.6,1690.9c0.5-2.7,2.4-5,5-6C80.1,1687.6,78.2,1689.9,75.6,1690.9L75.6,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M77.9,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C81.1,1687.6,80,1690.5,77.9,1692.3L77.9,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M80.6,1692.7c-1.4-2.4-1.4-5.4,0-7.8C82,1687.3,82,1690.3,80.6,1692.7L80.6,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M83.3,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C82.7,1686.7,83.7,1689.5,83.3,1692.3L83.3,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M85.7,1690.9c-2.6-1-4.5-3.3-5-6C83.2,1685.9,85.1,1688.2,85.7,1690.9L85.7,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M87.4,1688.8c-2.8,0-5.4-1.5-6.8-3.9C83.4,1684.9,86,1686.4,87.4,1688.8L87.4,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M88.3,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C83.2,1684,86.2,1684.5,88.3,1686.3L88.3,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M88.3,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C82.8,1683.1,85.7,1682.6,88.3,1683.5L88.3,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M87.4,1681c-1.4,2.4-4,3.9-6.8,3.9C82,1682.5,84.6,1681,87.4,1681L87.4,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M85.7,1678.9c-0.5,2.7-2.4,5-5,6C81.1,1682.2,83.1,1679.9,85.7,1678.9L85.7,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M83.3,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C80.2,1682.2,81.2,1679.4,83.3,1677.5L83.3,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 80.6,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 94,
    y1: 1689.8,
    x2: 94,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M94,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H94h11.1c0.4,0,0.6-0.5,0.2-0.7 C102.1,1716.8,98.5,1711.2,94,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.9,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C95.3,1696.5,94.7,1696.7,93.9,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.1,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S88.3,1692.7,88.1,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.9,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C95.3,1701.2,94.7,1701.5,93.9,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.1,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C88.7,1698.1,88.3,1697.5,88.1,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M94,1677.1c1.4,2.4,1.4,5.4,0,7.8C92.6,1682.5,92.6,1679.5,94,1677.1L94,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M91.3,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C91.9,1683.1,90.9,1680.3,91.3,1677.5L91.3,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89,1678.9c2.6,1,4.5,3.3,5,6C91.4,1683.9,89.5,1681.6,89,1678.9L89,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M87.2,1681c2.8,0,5.4,1.5,6.8,3.9C91.2,1684.9,88.6,1683.4,87.2,1681L87.2,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M86.3,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C91.4,1685.8,88.4,1685.3,86.3,1683.5L86.3,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M86.3,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C91.9,1686.7,88.9,1687.2,86.3,1686.3L86.3,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M87.2,1688.8c1.4-2.4,4-3.9,6.8-3.9C92.6,1687.3,90,1688.8,87.2,1688.8L87.2,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89,1690.9c0.5-2.7,2.4-5,5-6C93.5,1687.6,91.6,1689.9,89,1690.9L89,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M91.3,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C94.5,1687.6,93.4,1690.5,91.3,1692.3L91.3,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M94,1692.7c-1.4-2.4-1.4-5.4,0-7.8C95.4,1687.3,95.4,1690.3,94,1692.7L94,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.7,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C96.1,1686.7,97.1,1689.5,96.7,1692.3L96.7,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M99,1690.9c-2.6-1-4.5-3.3-5-6C96.6,1685.9,98.5,1688.2,99,1690.9L99,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M100.8,1688.8c-2.8,0-5.4-1.5-6.8-3.9C96.8,1684.9,99.4,1686.4,100.8,1688.8L100.8,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M101.7,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C96.6,1684,99.6,1684.5,101.7,1686.3L101.7,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M101.7,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C96.1,1683.1,99.1,1682.6,101.7,1683.5L101.7,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M100.8,1681c-1.4,2.4-4,3.9-6.8,3.9C95.4,1682.5,98,1681,100.8,1681L100.8,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M99,1678.9c-0.5,2.7-2.4,5-5,6C94.5,1682.2,96.4,1679.9,99,1678.9L99,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.7,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C93.5,1682.2,94.6,1679.4,96.7,1677.5L96.7,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 94,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 107.4,
    y1: 1689.8,
    x2: 107.4,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M107.4,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C115.5,1716.8,111.9,1711.2,107.4,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.3,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C108.7,1696.5,108.1,1696.7,107.3,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.5,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S101.7,1692.7,101.5,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.3,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C108.7,1701.2,108.1,1701.5,107.3,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.5,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C102.1,1698.1,101.7,1697.5,101.5,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M107.4,1677.1c1.4,2.4,1.4,5.4,0,7.8C106,1682.5,106,1679.5,107.4,1677.1L107.4,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M104.7,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C105.3,1683.1,104.3,1680.3,104.7,1677.5L104.7,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M102.4,1678.9c2.6,1,4.5,3.3,5,6C104.8,1683.9,102.9,1681.6,102.4,1678.9L102.4,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M100.6,1681c2.8,0,5.4,1.5,6.8,3.9C104.6,1684.9,102,1683.4,100.6,1681L100.6,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M99.7,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C104.8,1685.8,101.8,1685.3,99.7,1683.5L99.7,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M99.7,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C105.3,1686.7,102.3,1687.2,99.7,1686.3L99.7,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M100.6,1688.8c1.4-2.4,4-3.9,6.8-3.9C106,1687.3,103.4,1688.8,100.6,1688.8L100.6,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M102.4,1690.9c0.5-2.7,2.4-5,5-6C106.9,1687.6,104.9,1689.9,102.4,1690.9L102.4,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M104.7,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C107.9,1687.6,106.8,1690.5,104.7,1692.3L104.7,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M107.4,1692.7c-1.4-2.4-1.4-5.4,0-7.8C108.8,1687.3,108.8,1690.3,107.4,1692.7L107.4,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M110.1,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C109.5,1686.7,110.5,1689.5,110.1,1692.3L110.1,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M112.4,1690.9c-2.6-1-4.5-3.3-5-6C110,1685.9,111.9,1688.2,112.4,1690.9L112.4,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M114.2,1688.8c-2.8,0-5.4-1.5-6.8-3.9C110.2,1684.9,112.8,1686.4,114.2,1688.8L114.2,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M115.1,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C110,1684,113,1684.5,115.1,1686.3L115.1,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M115.1,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C109.5,1683.1,112.5,1682.6,115.1,1683.5L115.1,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M114.2,1681c-1.4,2.4-4,3.9-6.8,3.9C108.8,1682.5,111.4,1681,114.2,1681L114.2,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M112.4,1678.9c-0.5,2.7-2.4,5-5,6C107.9,1682.2,109.8,1679.9,112.4,1678.9L112.4,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M110.1,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C106.9,1682.2,108,1679.4,110.1,1677.5L110.1,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 107.4,
    cy: 1684.9,
    r: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 120,
    y1: 1689.8,
    x2: 120,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M120.1,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C128.1,1716.8,124.6,1711.2,120.1,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C121.3,1696.5,120.7,1696.7,120,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.1,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S114.4,1692.7,114.1,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C121.3,1701.2,120.7,1701.5,120,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.1,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C114.7,1698.1,114.4,1697.5,114.1,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M120,1677.1c1.4,2.4,1.4,5.4,0,7.8C118.7,1682.5,118.7,1679.5,120,1677.1L120,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M117.3,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C117.9,1683.1,116.9,1680.3,117.3,1677.5L117.3,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M115,1678.9c2.6,1,4.5,3.3,5,6C117.4,1683.9,115.5,1681.6,115,1678.9L115,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M113.2,1681c2.8,0,5.4,1.5,6.8,3.9C117.3,1684.9,114.7,1683.4,113.2,1681L113.2,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M112.3,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C117.4,1685.8,114.5,1685.3,112.3,1683.5L112.3,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M112.3,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C117.9,1686.7,114.9,1687.2,112.3,1686.3L112.3,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M113.2,1688.8c1.4-2.4,4-3.9,6.8-3.9C118.6,1687.3,116,1688.8,113.2,1688.8L113.2,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M115,1690.9c0.5-2.7,2.4-5,5-6C119.5,1687.6,117.6,1689.9,115,1690.9L115,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M117.3,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C120.5,1687.6,119.5,1690.5,117.3,1692.3L117.3,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M120,1692.7c-1.4-2.4-1.4-5.4,0-7.8C121.4,1687.3,121.4,1690.3,120,1692.7L120,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M122.7,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C122.1,1686.7,123.2,1689.5,122.7,1692.3L122.7,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M125.1,1690.9c-2.6-1-4.5-3.3-5-6C122.6,1685.9,124.6,1688.2,125.1,1690.9L125.1,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M126.8,1688.8c-2.8,0-5.4-1.5-6.8-3.9C122.8,1684.9,125.4,1686.4,126.8,1688.8L126.8,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M127.7,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C122.6,1684,125.6,1684.5,127.7,1686.3L127.7,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M127.7,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C122.2,1683.1,125.1,1682.6,127.7,1683.5L127.7,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M126.8,1681c-1.4,2.4-4,3.9-6.8,3.9C121.4,1682.5,124,1681,126.8,1681L126.8,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M125.1,1678.9c-0.5,2.7-2.4,5-5,6C120.5,1682.2,122.5,1679.9,125.1,1678.9L125.1,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M122.7,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C119.6,1682.2,120.6,1679.4,122.7,1677.5L122.7,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 120,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 133.4,
    y1: 1689.8,
    x2: 133.4,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M133.5,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C141.5,1716.8,137.9,1711.2,133.5,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.4,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C134.7,1696.5,134.1,1696.7,133.4,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.5,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C128.1,1693.3,127.7,1692.7,127.5,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.4,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C134.7,1701.2,134.1,1701.5,133.4,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.5,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C128.1,1698.1,127.7,1697.5,127.5,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M133.4,1677.1c1.4,2.4,1.4,5.4,0,7.8C132,1682.5,132.1,1679.5,133.4,1677.1L133.4,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M130.7,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C131.3,1683.1,130.3,1680.3,130.7,1677.5L130.7,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M128.4,1678.9c2.6,1,4.5,3.3,5,6C130.8,1683.9,128.9,1681.6,128.4,1678.9L128.4,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M126.6,1681c2.8,0,5.4,1.5,6.8,3.9C130.6,1684.9,128,1683.4,126.6,1681L126.6,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M125.7,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C130.8,1685.8,127.8,1685.3,125.7,1683.5L125.7,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M125.7,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C131.3,1686.7,128.3,1687.2,125.7,1686.3L125.7,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M126.6,1688.8c1.4-2.4,4-3.9,6.8-3.9C132,1687.3,129.4,1688.8,126.6,1688.8L126.6,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M128.4,1690.9c0.5-2.7,2.4-5,5-6C132.9,1687.6,131,1689.9,128.4,1690.9L128.4,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M130.7,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C133.9,1687.6,132.8,1690.5,130.7,1692.3L130.7,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M133.4,1692.7c-1.4-2.4-1.4-5.4,0-7.8C134.8,1687.3,134.8,1690.3,133.4,1692.7L133.4,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M136.1,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C135.5,1686.7,136.5,1689.5,136.1,1692.3L136.1,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M138.5,1690.9c-2.6-1-4.5-3.3-5-6C136,1685.9,137.9,1688.2,138.5,1690.9L138.5,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M140.2,1688.8c-2.8,0-5.4-1.5-6.8-3.9C136.2,1684.9,138.8,1686.4,140.2,1688.8L140.2,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M141.1,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C136,1684,139,1684.5,141.1,1686.3L141.1,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M141.1,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C135.6,1683.1,138.5,1682.6,141.1,1683.5L141.1,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M140.2,1681c-1.4,2.4-4,3.9-6.8,3.9C134.8,1682.5,137.4,1681,140.2,1681L140.2,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M138.5,1678.9c-0.5,2.7-2.4,5-5,6C133.9,1682.2,135.9,1679.9,138.5,1678.9L138.5,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M136.1,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C133,1682.2,134,1679.4,136.1,1677.5L136.1,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 133.4,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 146.8,
    y1: 1689.8,
    x2: 146.8,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M146.8,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C154.9,1716.8,151.3,1711.2,146.8,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.7,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C148.1,1696.5,147.5,1696.7,146.7,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.9,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C141.5,1693.3,141.1,1692.7,140.9,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.7,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C148.1,1701.2,147.5,1701.5,146.7,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.9,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C141.5,1698.1,141.1,1697.5,140.9,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M146.8,1677.1c1.4,2.4,1.4,5.4,0,7.8C145.4,1682.5,145.4,1679.5,146.8,1677.1L146.8,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M144.1,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C144.7,1683.1,143.7,1680.3,144.1,1677.5L144.1,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M141.8,1678.9c2.6,1,4.5,3.3,5,6C144.2,1683.9,142.3,1681.6,141.8,1678.9L141.8,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M140,1681c2.8,0,5.4,1.5,6.8,3.9C144,1684.9,141.4,1683.4,140,1681L140,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M139.1,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C144.2,1685.8,141.2,1685.3,139.1,1683.5L139.1,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M139.1,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C144.7,1686.7,141.7,1687.2,139.1,1686.3L139.1,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M140,1688.8c1.4-2.4,4-3.9,6.8-3.9C145.4,1687.3,142.8,1688.8,140,1688.8L140,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M141.8,1690.9c0.5-2.7,2.4-5,5-6C146.3,1687.6,144.4,1689.9,141.8,1690.9L141.8,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M144.1,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C147.3,1687.6,146.2,1690.5,144.1,1692.3L144.1,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M146.8,1692.7c-1.4-2.4-1.4-5.4,0-7.8C148.2,1687.3,148.2,1690.3,146.8,1692.7L146.8,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M149.5,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C148.9,1686.7,149.9,1689.5,149.5,1692.3L149.5,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M151.8,1690.9c-2.6-1-4.5-3.3-5-6C149.4,1685.9,151.3,1688.2,151.8,1690.9L151.8,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M153.6,1688.8c-2.8,0-5.4-1.5-6.8-3.9C149.6,1684.9,152.2,1686.4,153.6,1688.8L153.6,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M154.5,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C149.4,1684,152.4,1684.5,154.5,1686.3L154.5,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M154.5,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C148.9,1683.1,151.9,1682.6,154.5,1683.5L154.5,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M153.6,1681c-1.4,2.4-4,3.9-6.8,3.9C148.2,1682.5,150.8,1681,153.6,1681L153.6,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M151.8,1678.9c-0.5,2.7-2.4,5-5,6C147.3,1682.2,149.2,1679.9,151.8,1678.9L151.8,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M149.5,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C146.3,1682.2,147.4,1679.4,149.5,1677.5L149.5,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 146.8,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 160.2,
    y1: 1689.8,
    x2: 160.2,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M160.2,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C168.3,1716.8,164.7,1711.2,160.2,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C161.5,1696.5,160.9,1696.7,160.1,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.3,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S154.5,1692.7,154.3,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.1,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C161.5,1701.2,160.9,1701.5,160.1,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.3,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C154.9,1698.1,154.5,1697.5,154.3,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160.2,1677.1c1.4,2.4,1.4,5.4,0,7.8C158.8,1682.5,158.8,1679.5,160.2,1677.1L160.2,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M157.5,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C158.1,1683.1,157.1,1680.3,157.5,1677.5L157.5,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M155.2,1678.9c2.6,1,4.5,3.3,5,6C157.6,1683.9,155.7,1681.6,155.2,1678.9L155.2,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M153.4,1681c2.8,0,5.4,1.5,6.8,3.9C157.4,1684.9,154.8,1683.4,153.4,1681L153.4,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M152.5,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C157.6,1685.8,154.6,1685.3,152.5,1683.5L152.5,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M152.5,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C158,1686.7,155.1,1687.2,152.5,1686.3L152.5,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M153.4,1688.8c1.4-2.4,4-3.9,6.8-3.9C158.8,1687.3,156.2,1688.8,153.4,1688.8L153.4,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M155.2,1690.9c0.5-2.7,2.4-5,5-6C159.7,1687.6,157.7,1689.9,155.2,1690.9L155.2,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M157.5,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C160.6,1687.6,159.6,1690.5,157.5,1692.3L157.5,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160.2,1692.7c-1.4-2.4-1.4-5.4,0-7.8C161.6,1687.3,161.5,1690.3,160.2,1692.7L160.2,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M162.9,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C162.3,1686.7,163.3,1689.5,162.9,1692.3L162.9,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M165.2,1690.9c-2.6-1-4.5-3.3-5-6C162.8,1685.9,164.7,1688.2,165.2,1690.9L165.2,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M167,1688.8c-2.8,0-5.4-1.5-6.8-3.9C163,1684.9,165.6,1686.4,167,1688.8L167,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M167.9,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C162.8,1684,165.8,1684.5,167.9,1686.3L167.9,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M167.9,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C162.3,1683.1,165.3,1682.6,167.9,1683.5L167.9,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M167,1681c-1.4,2.4-4,3.9-6.8,3.9C161.6,1682.5,164.2,1681,167,1681L167,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M165.2,1678.9c-0.5,2.7-2.4,5-5,6C160.7,1682.2,162.6,1679.9,165.2,1678.9L165.2,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M162.9,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C159.7,1682.2,160.8,1679.4,162.9,1677.5L162.9,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 160.2,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 173.6,
    y1: 1689.8,
    x2: 173.6,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M173.6,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C181.6,1716.8,178.1,1711.2,173.6,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.5,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C174.9,1696.5,174.3,1696.7,173.5,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.7,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C168.3,1693.3,167.9,1692.7,167.7,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173.5,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C174.9,1701.2,174.3,1701.5,173.5,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.7,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C168.3,1698.1,167.9,1697.5,167.7,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M173.6,1677.1c1.4,2.4,1.4,5.4,0,7.8C172.2,1682.5,172.2,1679.5,173.6,1677.1L173.6,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M170.9,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C171.5,1683.1,170.4,1680.3,170.9,1677.5L170.9,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M168.5,1678.9c2.6,1,4.5,3.3,5,6C171,1683.9,169,1681.6,168.5,1678.9L168.5,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M166.8,1681c2.8,0,5.4,1.5,6.8,3.9C170.8,1684.9,168.2,1683.4,166.8,1681L166.8,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M165.9,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C171,1685.8,168,1685.3,165.9,1683.5L165.9,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M165.9,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C171.4,1686.7,168.5,1687.2,165.9,1686.3L165.9,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M166.8,1688.8c1.4-2.4,4-3.9,6.8-3.9C172.2,1687.3,169.6,1688.8,166.8,1688.8L166.8,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M168.5,1690.9c0.5-2.7,2.4-5,5-6C173.1,1687.6,171.1,1689.9,168.5,1690.9L168.5,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M170.9,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C174,1687.6,173,1690.5,170.9,1692.3L170.9,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M173.6,1692.7c-1.4-2.4-1.4-5.4,0-7.8C174.9,1687.3,174.9,1690.3,173.6,1692.7L173.6,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M176.3,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C175.7,1686.7,176.7,1689.5,176.3,1692.3L176.3,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M178.6,1690.9c-2.6-1-4.5-3.3-5-6C176.2,1685.9,178.1,1688.2,178.6,1690.9L178.6,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M180.4,1688.8c-2.8,0-5.4-1.5-6.8-3.9C176.3,1684.9,178.9,1686.4,180.4,1688.8L180.4,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M181.3,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C176.2,1684,179.1,1684.5,181.3,1686.3L181.3,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M181.3,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C175.7,1683.1,178.7,1682.6,181.3,1683.5L181.3,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M180.4,1681c-1.4,2.4-4,3.9-6.8,3.9C175,1682.5,177.6,1681,180.4,1681L180.4,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M178.6,1678.9c-0.5,2.7-2.4,5-5,6C174.1,1682.2,176,1679.9,178.6,1678.9L178.6,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M176.3,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C173.1,1682.2,174.1,1679.4,176.3,1677.5L176.3,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 173.6,
    cy: 1684.9,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 186.9,
    y1: 1689.8,
    x2: 186.9,
    y2: 1711.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M187,1711.2c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H187h11.1c0.4,0,0.6-0.5,0.2-0.7 C195,1716.8,191.5,1711.2,187,1711.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.9,1696.8c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C188.3,1696.5,187.7,1696.7,186.9,1696.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.1,1692c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C181.6,1693.3,181.3,1692.7,181.1,1692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.9,1701.6c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C188.3,1701.2,187.7,1701.5,186.9,1701.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.1,1696.8c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C181.6,1698.1,181.3,1697.5,181.1,1696.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M187,1677.1c1.4,2.4,1.4,5.4,0,7.8C185.6,1682.5,185.6,1679.5,187,1677.1L187,1677.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M184.3,1677.5c2.1,1.8,3.1,4.6,2.7,7.4C184.8,1683.1,183.8,1680.3,184.3,1677.5L184.3,1677.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M181.9,1678.9c2.6,1,4.5,3.3,5,6C184.4,1683.9,182.4,1681.6,181.9,1678.9L181.9,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M180.2,1681c2.8,0,5.4,1.5,6.8,3.9C184.2,1684.9,181.6,1683.4,180.2,1681L180.2,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M179.2,1683.5c2.6-0.9,5.6-0.4,7.7,1.4C184.3,1685.8,181.4,1685.3,179.2,1683.5L179.2,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M179.2,1686.3c2.1-1.8,5.1-2.3,7.7-1.4C184.8,1686.7,181.9,1687.2,179.2,1686.3L179.2,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M180.2,1688.8c1.4-2.4,4-3.9,6.8-3.9C185.6,1687.3,182.9,1688.8,180.2,1688.8L180.2,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M181.9,1690.9c0.5-2.7,2.4-5,5-6C186.5,1687.6,184.5,1689.9,181.9,1690.9L181.9,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M184.3,1692.3c-0.5-2.7,0.6-5.6,2.7-7.4C187.4,1687.6,186.4,1690.5,184.3,1692.3L184.3,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M187,1692.7c-1.4-2.4-1.4-5.4,0-7.8C188.3,1687.3,188.3,1690.3,187,1692.7L187,1692.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M189.6,1692.3c-2.1-1.8-3.1-4.6-2.7-7.4C189.1,1686.7,190.1,1689.5,189.6,1692.3L189.6,1692.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M192,1690.9c-2.6-1-4.5-3.3-5-6C189.6,1685.9,191.5,1688.2,192,1690.9L192,1690.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M193.7,1688.8c-2.8,0-5.4-1.5-6.8-3.9C189.7,1684.9,192.3,1686.4,193.7,1688.8L193.7,1688.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M194.7,1686.3c-2.6,0.9-5.6,0.4-7.7-1.4C189.6,1684,192.5,1684.5,194.7,1686.3L194.7,1686.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M194.7,1683.5c-2.1,1.8-5.1,2.3-7.7,1.4C189.1,1683.1,192.1,1682.6,194.7,1683.5L194.7,1683.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M193.7,1681c-1.4,2.4-4,3.9-6.8,3.9C188.4,1682.5,191,1681,193.7,1681L193.7,1681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M192,1678.9c-0.5,2.7-2.4,5-5,6C187.5,1682.2,189.4,1679.9,192,1678.9L192,1678.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M189.6,1677.5c0.5,2.7-0.6,5.6-2.7,7.4C186.5,1682.2,187.5,1679.4,189.6,1677.5L189.6,1677.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 187,
    cy: 1684.9,
    r: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 47,
    y1: 1700.6,
    x2: 47,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M47.1,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C55.1,1727.6,51.6,1722,47.1,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C48.4,1707.2,47.8,1707.5,47,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.2,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C41.7,1704,41.4,1703.5,41.2,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C48.4,1712,47.8,1712.2,47,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.2,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C41.7,1708.8,41.4,1708.3,41.2,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M47.1,1687.8c1.4,2.4,1.4,5.4,0,7.8C45.7,1693.2,45.7,1690.2,47.1,1687.8L47.1,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M44.4,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C44.9,1693.9,43.9,1691,44.4,1688.3L44.4,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M42,1689.7c2.6,1,4.5,3.3,5,6C44.5,1694.7,42.5,1692.4,42,1689.7L42,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M40.3,1691.7c2.8,0,5.4,1.5,6.8,3.9C44.3,1695.6,41.7,1694.1,40.3,1691.7L40.3,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M39.3,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C44.4,1696.6,41.5,1696.1,39.3,1694.3L39.3,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M39.3,1697c2.1-1.8,5.1-2.3,7.7-1.4C44.9,1697.4,42,1697.9,39.3,1697L39.3,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M40.3,1699.6c1.4-2.4,4-3.9,6.8-3.9C45.7,1698.1,43,1699.6,40.3,1699.6L40.3,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M42,1701.7c0.5-2.7,2.4-5,5-6C46.6,1698.4,44.6,1700.7,42,1701.7L42,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M44.4,1703c-0.5-2.7,0.6-5.6,2.7-7.4C47.5,1698.4,46.5,1701.2,44.4,1703L44.4,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M47.1,1703.5c-1.4-2.4-1.4-5.4,0-7.8C48.4,1698.1,48.4,1701.1,47.1,1703.5L47.1,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M49.7,1703c-2.1-1.8-3.1-4.6-2.7-7.4C49.2,1697.5,50.2,1700.3,49.7,1703L49.7,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M52.1,1701.7c-2.6-1-4.5-3.3-5-6C49.7,1696.6,51.6,1698.9,52.1,1701.7L52.1,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M53.8,1699.6c-2.8,0-5.4-1.5-6.8-3.9C49.8,1695.7,52.4,1697.2,53.8,1699.6L53.8,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M54.8,1697c-2.6,0.9-5.6,0.4-7.7-1.4C49.7,1694.7,52.6,1695.3,54.8,1697L54.8,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M54.8,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C49.2,1693.9,52.2,1693.4,54.8,1694.3L54.8,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M53.8,1691.7c-1.4,2.4-4,3.9-6.8,3.9C48.5,1693.3,51.1,1691.8,53.8,1691.7L53.8,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M52.1,1689.7c-0.5,2.7-2.4,5-5,6C47.6,1692.9,49.5,1690.6,52.1,1689.7L52.1,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M49.7,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C46.6,1692.9,47.6,1690.1,49.7,1688.3L49.7,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 47.1,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 60.4,
    y1: 1700.6,
    x2: 60.4,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M60.5,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C68.5,1727.6,65,1722,60.5,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1c0.6-0.3,1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1C61.8,1707.2,61.1,1707.5,60.4,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.5,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C55.1,1704,54.8,1703.5,54.5,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1c0.6-0.3,1.2-0.5,2-0.6 c-0.2,0.7-0.6,1.3-1,1.8s-0.8,1-1.3,1.4s-1,0.7-1.6,1C61.8,1712,61.1,1712.2,60.4,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.5,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C55.1,1708.8,54.8,1708.3,54.5,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M60.4,1687.8c1.4,2.4,1.4,5.4,0,7.8C59.1,1693.2,59.1,1690.2,60.4,1687.8L60.4,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M57.8,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C58.3,1693.9,57.3,1691,57.8,1688.3L57.8,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M55.4,1689.7c2.6,1,4.5,3.3,5,6C57.8,1694.7,55.9,1692.4,55.4,1689.7L55.4,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M53.7,1691.7c2.8,0,5.4,1.5,6.8,3.9C57.7,1695.6,55.1,1694.1,53.7,1691.7L53.7,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M52.7,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C57.8,1696.6,54.9,1696.1,52.7,1694.3L52.7,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M52.7,1697c2.1-1.8,5.1-2.3,7.7-1.4C58.3,1697.4,55.3,1697.9,52.7,1697L52.7,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M53.7,1699.6c1.4-2.4,4-3.9,6.8-3.9C59,1698.1,56.4,1699.6,53.7,1699.6L53.7,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M55.4,1701.7c0.5-2.7,2.4-5,5-6C59.9,1698.4,58,1700.7,55.4,1701.7L55.4,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M57.8,1703c-0.5-2.7,0.6-5.6,2.7-7.4C60.9,1698.4,59.9,1701.2,57.8,1703L57.8,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M60.4,1703.5c-1.4-2.4-1.4-5.4,0-7.8C61.8,1698.1,61.8,1701.1,60.4,1703.5L60.4,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M63.1,1703c-2.1-1.8-3.1-4.6-2.7-7.4C62.6,1697.5,63.6,1700.3,63.1,1703L63.1,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M65.5,1701.7c-2.6-1-4.5-3.3-5-6C63,1696.6,65,1698.9,65.5,1701.7L65.5,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M67.2,1699.6c-2.8,0-5.4-1.5-6.8-3.9C63.2,1695.7,65.8,1697.2,67.2,1699.6L67.2,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M68.2,1697c-2.6,0.9-5.6,0.4-7.7-1.4C63.1,1694.7,66,1695.3,68.2,1697L68.2,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M68.2,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C62.6,1693.9,65.5,1693.4,68.2,1694.3L68.2,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M67.2,1691.7c-1.4,2.4-4,3.9-6.8,3.9C61.9,1693.3,64.5,1691.8,67.2,1691.7L67.2,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M65.5,1689.7c-0.5,2.7-2.4,5-5,6C60.9,1692.9,62.9,1690.6,65.5,1689.7L65.5,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M63.1,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C60,1692.9,61,1690.1,63.1,1688.3L63.1,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 60.4,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 73.8,
    y1: 1700.6,
    x2: 73.8,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M73.9,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H85c0.4,0,0.6-0.5,0.2-0.7 C81.9,1727.6,78.4,1722,73.9,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C75.2,1707.2,74.5,1707.5,73.8,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.9,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S68.2,1703.5,67.9,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.8,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C75.2,1712,74.5,1712.2,73.8,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.9,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S68.2,1708.3,67.9,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M73.8,1687.8c1.4,2.4,1.4,5.4,0,7.8C72.5,1693.2,72.5,1690.2,73.8,1687.8L73.8,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M71.2,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C71.7,1693.9,70.7,1691,71.2,1688.3L71.2,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M68.8,1689.7c2.6,1,4.5,3.3,5,6C71.2,1694.7,69.3,1692.4,68.8,1689.7L68.8,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M67,1691.7c2.8,0,5.4,1.5,6.8,3.9C71.1,1695.6,68.5,1694.1,67,1691.7L67,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M66.1,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C71.2,1696.6,68.3,1696.1,66.1,1694.3L66.1,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M66.1,1697c2.1-1.8,5.1-2.3,7.7-1.4C71.7,1697.4,68.7,1697.9,66.1,1697L66.1,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M67,1699.6c1.4-2.4,4-3.9,6.8-3.9C72.4,1698.1,69.8,1699.6,67,1699.6L67,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M68.8,1701.7c0.5-2.7,2.4-5,5-6C73.3,1698.4,71.4,1700.7,68.8,1701.7L68.8,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M71.2,1703c-0.5-2.7,0.6-5.6,2.7-7.4C74.3,1698.4,73.3,1701.2,71.2,1703L71.2,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M73.8,1703.5c-1.4-2.4-1.4-5.4,0-7.8C75.2,1698.1,75.2,1701.1,73.8,1703.5L73.8,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M76.5,1703c-2.1-1.8-3.1-4.6-2.7-7.4C75.9,1697.5,77,1700.3,76.5,1703L76.5,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M78.9,1701.7c-2.6-1-4.5-3.3-5-6C76.4,1696.6,78.4,1698.9,78.9,1701.7L78.9,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M80.6,1699.6c-2.8,0-5.4-1.5-6.8-3.9C76.6,1695.7,79.2,1697.2,80.6,1699.6L80.6,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M81.5,1697c-2.6,0.9-5.6,0.4-7.7-1.4C76.4,1694.7,79.4,1695.3,81.5,1697L81.5,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M81.5,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C76,1693.9,78.9,1693.4,81.5,1694.3L81.5,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M80.6,1691.7c-1.4,2.4-4,3.9-6.8,3.9C75.2,1693.3,77.8,1691.8,80.6,1691.7L80.6,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M78.9,1689.7c-0.5,2.7-2.4,5-5,6C74.3,1692.9,76.3,1690.6,78.9,1689.7L78.9,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M76.5,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C73.4,1692.9,74.4,1690.1,76.5,1688.3L76.5,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 73.8,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 87.2,
    y1: 1700.6,
    x2: 87.2,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M87.3,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C95.3,1727.6,91.7,1722,87.3,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.2,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C88.5,1707.2,87.9,1707.5,87.2,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.3,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S81.5,1703.5,81.3,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.2,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C88.5,1712,87.9,1712.2,87.2,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.3,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S81.5,1708.3,81.3,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M87.2,1687.8c1.4,2.4,1.4,5.4,0,7.8C85.8,1693.2,85.9,1690.2,87.2,1687.8L87.2,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M84.5,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C85.1,1693.9,84.1,1691,84.5,1688.3L84.5,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M82.2,1689.7c2.6,1,4.5,3.3,5,6C84.6,1694.7,82.7,1692.4,82.2,1689.7L82.2,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M80.4,1691.7c2.8,0,5.4,1.5,6.8,3.9C84.4,1695.6,81.8,1694.1,80.4,1691.7L80.4,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M79.5,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C84.6,1696.6,81.6,1696.1,79.5,1694.3L79.5,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M79.5,1697c2.1-1.8,5.1-2.3,7.7-1.4C85.1,1697.4,82.1,1697.9,79.5,1697L79.5,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M80.4,1699.6c1.4-2.4,4-3.9,6.8-3.9C85.8,1698.1,83.2,1699.6,80.4,1699.6L80.4,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M82.2,1701.7c0.5-2.7,2.4-5,5-6C86.7,1698.4,84.8,1700.7,82.2,1701.7L82.2,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M84.5,1703c-0.5-2.7,0.6-5.6,2.7-7.4C87.7,1698.4,86.6,1701.2,84.5,1703L84.5,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M87.2,1703.5c-1.4-2.4-1.4-5.4,0-7.8C88.6,1698.1,88.6,1701.1,87.2,1703.5L87.2,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89.9,1703c-2.1-1.8-3.1-4.6-2.7-7.4C89.3,1697.5,90.3,1700.3,89.9,1703L89.9,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M92.3,1701.7c-2.6-1-4.5-3.3-5-6C89.8,1696.6,91.7,1698.9,92.3,1701.7L92.3,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M94,1699.6c-2.8,0-5.4-1.5-6.8-3.9C90,1695.7,92.6,1697.2,94,1699.6L94,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M94.9,1697c-2.6,0.9-5.6,0.4-7.7-1.4C89.8,1694.7,92.8,1695.3,94.9,1697L94.9,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M94.9,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C89.4,1693.9,92.3,1693.4,94.9,1694.3L94.9,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M94,1691.7c-1.4,2.4-4,3.9-6.8,3.9C88.6,1693.3,91.2,1691.8,94,1691.7L94,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M92.3,1689.7c-0.5,2.7-2.4,5-5,6C87.7,1692.9,89.7,1690.6,92.3,1689.7L92.3,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89.9,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C86.8,1692.9,87.8,1690.1,89.9,1688.3L89.9,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 87.2,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 100.6,
    y1: 1700.6,
    x2: 100.6,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M100.6,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C108.7,1727.6,105.1,1722,100.6,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.5,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C101.9,1707.2,101.3,1707.5,100.5,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.7,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C95.3,1704,94.9,1703.5,94.7,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.5,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C101.9,1712,101.3,1712.2,100.5,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.7,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C95.3,1708.8,94.9,1708.3,94.7,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M100.6,1687.8c1.4,2.4,1.4,5.4,0,7.8C99.2,1693.2,99.2,1690.2,100.6,1687.8L100.6,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M97.9,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C98.5,1693.9,97.5,1691,97.9,1688.3L97.9,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M95.6,1689.7c2.6,1,4.5,3.3,5,6C98,1694.7,96.1,1692.4,95.6,1689.7L95.6,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M93.8,1691.7c2.8,0,5.4,1.5,6.8,3.9C97.8,1695.6,95.2,1694.1,93.8,1691.7L93.8,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M92.9,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C98,1696.6,95,1696.1,92.9,1694.3L92.9,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M92.9,1697c2.1-1.8,5.1-2.3,7.7-1.4C98.5,1697.4,95.5,1697.9,92.9,1697L92.9,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M93.8,1699.6c1.4-2.4,4-3.9,6.8-3.9C99.2,1698.1,96.6,1699.6,93.8,1699.6L93.8,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M95.6,1701.7c0.5-2.7,2.4-5,5-6C100.1,1698.4,98.2,1700.7,95.6,1701.7L95.6,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M97.9,1703c-0.5-2.7,0.6-5.6,2.7-7.4C101.1,1698.4,100,1701.2,97.9,1703L97.9,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M100.6,1703.5c-1.4-2.4-1.4-5.4,0-7.8C102,1698.1,102,1701.1,100.6,1703.5L100.6,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M103.3,1703c-2.1-1.8-3.1-4.6-2.7-7.4C102.7,1697.5,103.7,1700.3,103.3,1703L103.3,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M105.6,1701.7c-2.6-1-4.5-3.3-5-6C103.2,1696.6,105.1,1698.9,105.6,1701.7L105.6,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M107.4,1699.6c-2.8,0-5.4-1.5-6.8-3.9C103.4,1695.7,106,1697.2,107.4,1699.6L107.4,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M108.3,1697c-2.6,0.9-5.6,0.4-7.7-1.4C103.2,1694.7,106.2,1695.3,108.3,1697L108.3,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M108.3,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C102.7,1693.9,105.7,1693.4,108.3,1694.3L108.3,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M107.4,1691.7c-1.4,2.4-4,3.9-6.8,3.9C102,1693.3,104.6,1691.8,107.4,1691.7L107.4,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M105.6,1689.7c-0.5,2.7-2.4,5-5,6C101.1,1692.9,103,1690.6,105.6,1689.7L105.6,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M103.3,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C100.1,1692.9,101.2,1690.1,103.3,1688.3L103.3,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 100.6,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 114,
    y1: 1700.6,
    x2: 114,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M114,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H114h11.1c0.4,0,0.6-0.5,0.2-0.7 C122.1,1727.6,118.5,1722,114,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.9,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C115.3,1707.2,114.7,1707.5,113.9,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.1,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S108.3,1703.5,108.1,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.9,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C115.3,1712,114.7,1712.2,113.9,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.1,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S108.3,1708.3,108.1,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M114,1687.8c1.4,2.4,1.4,5.4,0,7.8C112.6,1693.2,112.6,1690.2,114,1687.8L114,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M111.3,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C111.9,1693.9,110.9,1691,111.3,1688.3L111.3,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M109,1689.7c2.6,1,4.5,3.3,5,6C111.4,1694.7,109.5,1692.4,109,1689.7L109,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M107.2,1691.7c2.8,0,5.4,1.5,6.8,3.9C111.2,1695.6,108.6,1694.1,107.2,1691.7L107.2,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M106.3,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C111.4,1696.6,108.4,1696.1,106.3,1694.3L106.3,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M106.3,1697c2.1-1.8,5.1-2.3,7.7-1.4C111.8,1697.4,108.9,1697.9,106.3,1697L106.3,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M107.2,1699.6c1.4-2.4,4-3.9,6.8-3.9C112.6,1698.1,110,1699.6,107.2,1699.6L107.2,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M109,1701.7c0.5-2.7,2.4-5,5-6C113.5,1698.4,111.5,1700.7,109,1701.7L109,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M111.3,1703c-0.5-2.7,0.6-5.6,2.7-7.4C114.5,1698.4,113.4,1701.2,111.3,1703L111.3,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M114,1703.5c-1.4-2.4-1.4-5.4,0-7.8C115.4,1698.1,115.3,1701.1,114,1703.5L114,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M116.7,1703c-2.1-1.8-3.1-4.6-2.7-7.4C116.1,1697.5,117.1,1700.3,116.7,1703L116.7,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M119,1701.7c-2.6-1-4.5-3.3-5-6C116.6,1696.6,118.5,1698.9,119,1701.7L119,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M120.8,1699.6c-2.8,0-5.4-1.5-6.8-3.9C116.8,1695.7,119.4,1697.2,120.8,1699.6L120.8,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M121.7,1697c-2.6,0.9-5.6,0.4-7.7-1.4C116.6,1694.7,119.6,1695.3,121.7,1697L121.7,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M121.7,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C116.1,1693.9,119.1,1693.4,121.7,1694.3L121.7,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M120.8,1691.7c-1.4,2.4-4,3.9-6.8,3.9C115.4,1693.3,118,1691.8,120.8,1691.7L120.8,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M119,1689.7c-0.5,2.7-2.4,5-5,6C114.5,1692.9,116.4,1690.6,119,1689.7L119,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M116.7,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C113.5,1692.9,114.6,1690.1,116.7,1688.3L116.7,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 114,
    cy: 1695.7,
    r: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 126.6,
    y1: 1700.6,
    x2: 126.6,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M126.7,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C134.7,1727.6,131.2,1722,126.7,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C127.9,1707.2,127.3,1707.5,126.6,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.7,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C121.3,1704,121,1703.5,120.7,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C127.9,1712,127.3,1712.2,126.6,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.7,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C121.3,1708.8,121,1708.3,120.7,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M126.6,1687.8c1.4,2.4,1.4,5.4,0,7.8C125.3,1693.2,125.3,1690.2,126.6,1687.8L126.6,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M123.9,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C124.5,1693.9,123.5,1691,123.9,1688.3L123.9,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M121.6,1689.7c2.6,1,4.5,3.3,5,6C124,1694.7,122.1,1692.4,121.6,1689.7L121.6,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M119.8,1691.7c2.8,0,5.4,1.5,6.8,3.9C123.9,1695.6,121.3,1694.1,119.8,1691.7L119.8,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M118.9,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C124,1696.6,121.1,1696.1,118.9,1694.3L118.9,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M118.9,1697c2.1-1.8,5.1-2.3,7.7-1.4C124.5,1697.4,121.5,1697.9,118.9,1697L118.9,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M119.8,1699.6c1.4-2.4,4-3.9,6.8-3.9C125.2,1698.1,122.6,1699.6,119.8,1699.6L119.8,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M121.6,1701.7c0.5-2.7,2.4-5,5-6C126.1,1698.4,124.2,1700.7,121.6,1701.7L121.6,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M123.9,1703c-0.5-2.7,0.6-5.6,2.7-7.4C127.1,1698.4,126.1,1701.2,123.9,1703L123.9,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M126.6,1703.5c-1.4-2.4-1.4-5.4,0-7.8C128,1698.1,128,1701.1,126.6,1703.5L126.6,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M129.3,1703c-2.1-1.8-3.1-4.6-2.7-7.4C128.7,1697.5,129.8,1700.3,129.3,1703L129.3,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M131.7,1701.7c-2.6-1-4.5-3.3-5-6C129.2,1696.6,131.2,1698.9,131.7,1701.7L131.7,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M133.4,1699.6c-2.8,0-5.4-1.5-6.8-3.9C129.4,1695.7,132,1697.2,133.4,1699.6L133.4,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M134.3,1697c-2.6,0.9-5.6,0.4-7.7-1.4C129.2,1694.7,132.2,1695.3,134.3,1697L134.3,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M134.3,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C128.8,1693.9,131.7,1693.4,134.3,1694.3L134.3,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M133.4,1691.7c-1.4,2.4-4,3.9-6.8,3.9C128,1693.3,130.6,1691.8,133.4,1691.7L133.4,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M131.7,1689.7c-0.5,2.7-2.4,5-5,6C127.1,1692.9,129.1,1690.6,131.7,1689.7L131.7,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M129.3,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C126.2,1692.9,127.2,1690.1,129.3,1688.3L129.3,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 126.6,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 140,
    y1: 1700.6,
    x2: 140,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M140.1,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C148.1,1727.6,144.5,1722,140.1,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C141.3,1707.2,140.7,1707.5,140,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.1,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S134.3,1703.5,134.1,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C141.3,1712,140.7,1712.2,140,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.1,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S134.3,1708.3,134.1,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M140,1687.8c1.4,2.4,1.4,5.4,0,7.8C138.6,1693.2,138.7,1690.2,140,1687.8L140,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M137.3,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C137.9,1693.9,136.9,1691,137.3,1688.3L137.3,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M135,1689.7c2.6,1,4.5,3.3,5,6C137.4,1694.7,135.5,1692.4,135,1689.7L135,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M133.2,1691.7c2.8,0,5.4,1.5,6.8,3.9C137.2,1695.6,134.6,1694.1,133.2,1691.7L133.2,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M132.3,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C137.4,1696.6,134.4,1696.1,132.3,1694.3L132.3,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M132.3,1697c2.1-1.8,5.1-2.3,7.7-1.4C137.9,1697.4,134.9,1697.9,132.3,1697L132.3,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M133.2,1699.6c1.4-2.4,4-3.9,6.8-3.9C138.6,1698.1,136,1699.6,133.2,1699.6L133.2,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M135,1701.7c0.5-2.7,2.4-5,5-6C139.5,1698.4,137.6,1700.7,135,1701.7L135,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M137.3,1703c-0.5-2.7,0.6-5.6,2.7-7.4C140.5,1698.4,139.4,1701.2,137.3,1703L137.3,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M140,1703.5c-1.4-2.4-1.4-5.4,0-7.8C141.4,1698.1,141.4,1701.1,140,1703.5L140,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M142.7,1703c-2.1-1.8-3.1-4.6-2.7-7.4C142.1,1697.5,143.1,1700.3,142.7,1703L142.7,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M145.1,1701.7c-2.6-1-4.5-3.3-5-6C142.6,1696.6,144.5,1698.9,145.1,1701.7L145.1,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M146.8,1699.6c-2.8,0-5.4-1.5-6.8-3.9C142.8,1695.7,145.4,1697.2,146.8,1699.6L146.8,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M147.7,1697c-2.6,0.9-5.6,0.4-7.7-1.4C142.6,1694.7,145.6,1695.3,147.7,1697L147.7,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M147.7,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C142.2,1693.9,145.1,1693.4,147.7,1694.3L147.7,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M146.8,1691.7c-1.4,2.4-4,3.9-6.8,3.9C141.4,1693.3,144,1691.8,146.8,1691.7L146.8,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M145.1,1689.7c-0.5,2.7-2.4,5-5,6C140.5,1692.9,142.5,1690.6,145.1,1689.7L145.1,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M142.7,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C139.6,1692.9,140.6,1690.1,142.7,1688.3L142.7,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 140,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 153.4,
    y1: 1700.6,
    x2: 153.4,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M153.4,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C161.5,1727.6,157.9,1722,153.4,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.3,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C154.7,1707.2,154.1,1707.5,153.3,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.5,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C148.1,1704,147.7,1703.5,147.5,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.3,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C154.7,1712,154.1,1712.2,153.3,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.5,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C148.1,1708.8,147.7,1708.3,147.5,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M153.4,1687.8c1.4,2.4,1.4,5.4,0,7.8C152,1693.2,152,1690.2,153.4,1687.8L153.4,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M150.7,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C151.3,1693.9,150.3,1691,150.7,1688.3L150.7,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M148.4,1689.7c2.6,1,4.5,3.3,5,6C150.8,1694.7,148.9,1692.4,148.4,1689.7L148.4,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M146.6,1691.7c2.8,0,5.4,1.5,6.8,3.9C150.6,1695.6,148,1694.1,146.6,1691.7L146.6,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M145.7,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C150.8,1696.6,147.8,1696.1,145.7,1694.3L145.7,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M145.7,1697c2.1-1.8,5.1-2.3,7.7-1.4C151.3,1697.4,148.3,1697.9,145.7,1697L145.7,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M146.6,1699.6c1.4-2.4,4-3.9,6.8-3.9C152,1698.1,149.4,1699.6,146.6,1699.6L146.6,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M148.4,1701.7c0.5-2.7,2.4-5,5-6C152.9,1698.4,151,1700.7,148.4,1701.7L148.4,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M150.7,1703c-0.5-2.7,0.6-5.6,2.7-7.4C153.9,1698.4,152.8,1701.2,150.7,1703L150.7,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M153.4,1703.5c-1.4-2.4-1.4-5.4,0-7.8C154.8,1698.1,154.8,1701.1,153.4,1703.5L153.4,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M156.1,1703c-2.1-1.8-3.1-4.6-2.7-7.4C155.5,1697.5,156.5,1700.3,156.1,1703L156.1,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M158.4,1701.7c-2.6-1-4.5-3.3-5-6C156,1696.6,157.9,1698.9,158.4,1701.7L158.4,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160.2,1699.6c-2.8,0-5.4-1.5-6.8-3.9C156.2,1695.7,158.8,1697.2,160.2,1699.6L160.2,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M161.1,1697c-2.6,0.9-5.6,0.4-7.7-1.4C156,1694.7,159,1695.3,161.1,1697L161.1,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M161.1,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C155.5,1693.9,158.5,1693.4,161.1,1694.3L161.1,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160.2,1691.7c-1.4,2.4-4,3.9-6.8,3.9C154.8,1693.3,157.4,1691.8,160.2,1691.7L160.2,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M158.4,1689.7c-0.5,2.7-2.4,5-5,6C153.9,1692.9,155.8,1690.6,158.4,1689.7L158.4,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M156.1,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C152.9,1692.9,154,1690.1,156.1,1688.3L156.1,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 153.4,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 166.8,
    y1: 1700.6,
    x2: 166.8,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M166.8,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C174.9,1727.6,171.3,1722,166.8,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.7,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C168.1,1707.2,167.5,1707.5,166.7,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.9,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C161.5,1704,161.1,1703.5,160.9,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.7,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C168.1,1712,167.5,1712.2,166.7,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.9,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C161.5,1708.8,161.1,1708.3,160.9,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M166.8,1687.8c1.4,2.4,1.4,5.4,0,7.8C165.4,1693.2,165.4,1690.2,166.8,1687.8L166.8,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M164.1,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C164.7,1693.9,163.7,1691,164.1,1688.3L164.1,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M161.8,1689.7c2.6,1,4.5,3.3,5,6C164.2,1694.7,162.3,1692.4,161.8,1689.7L161.8,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160,1691.7c2.8,0,5.4,1.5,6.8,3.9C164,1695.6,161.4,1694.1,160,1691.7L160,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M159.1,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C164.2,1696.6,161.2,1696.1,159.1,1694.3L159.1,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M159.1,1697c2.1-1.8,5.1-2.3,7.7-1.4C164.6,1697.4,161.7,1697.9,159.1,1697L159.1,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160,1699.6c1.4-2.4,4-3.9,6.8-3.9C165.4,1698.1,162.8,1699.6,160,1699.6L160,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M161.8,1701.7c0.5-2.7,2.4-5,5-6C166.3,1698.4,164.3,1700.7,161.8,1701.7L161.8,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M164.1,1703c-0.5-2.7,0.6-5.6,2.7-7.4C167.2,1698.4,166.2,1701.2,164.1,1703L164.1,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M166.8,1703.5c-1.4-2.4-1.4-5.4,0-7.8C168.2,1698.1,168.1,1701.1,166.8,1703.5L166.8,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M169.5,1703c-2.1-1.8-3.1-4.6-2.7-7.4C168.9,1697.5,169.9,1700.3,169.5,1703L169.5,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M171.8,1701.7c-2.6-1-4.5-3.3-5-6C169.4,1696.6,171.3,1698.9,171.8,1701.7L171.8,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M173.6,1699.6c-2.8,0-5.4-1.5-6.8-3.9C169.6,1695.7,172.2,1697.2,173.6,1699.6L173.6,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M174.5,1697c-2.6,0.9-5.6,0.4-7.7-1.4C169.4,1694.7,172.4,1695.3,174.5,1697L174.5,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M174.5,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C168.9,1693.9,171.9,1693.4,174.5,1694.3L174.5,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M173.6,1691.7c-1.4,2.4-4,3.9-6.8,3.9C168.2,1693.3,170.8,1691.8,173.6,1691.7L173.6,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M171.8,1689.7c-0.5,2.7-2.4,5-5,6C167.3,1692.9,169.2,1690.6,171.8,1689.7L171.8,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M169.5,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C166.3,1692.9,167.4,1690.1,169.5,1688.3L169.5,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 166.8,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 180.2,
    y1: 1700.6,
    x2: 180.2,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M180.2,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C188.2,1727.6,184.7,1722,180.2,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.1,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C181.5,1707.2,180.9,1707.5,180.1,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.3,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S174.5,1703.5,174.3,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.1,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C181.5,1712,180.9,1712.2,180.1,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.3,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S174.5,1708.3,174.3,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M180.2,1687.8c1.4,2.4,1.4,5.4,0,7.8C178.8,1693.2,178.8,1690.2,180.2,1687.8L180.2,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M177.5,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C178.1,1693.9,177,1691,177.5,1688.3L177.5,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M175.1,1689.7c2.6,1,4.5,3.3,5,6C177.6,1694.7,175.6,1692.4,175.1,1689.7L175.1,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M173.4,1691.7c2.8,0,5.4,1.5,6.8,3.9C177.4,1695.6,174.8,1694.1,173.4,1691.7L173.4,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M172.5,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C177.6,1696.6,174.6,1696.1,172.5,1694.3L172.5,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M172.5,1697c2.1-1.8,5.1-2.3,7.7-1.4C178,1697.4,175.1,1697.9,172.5,1697L172.5,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M173.4,1699.6c1.4-2.4,4-3.9,6.8-3.9C178.8,1698.1,176.2,1699.6,173.4,1699.6L173.4,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M175.1,1701.7c0.5-2.7,2.4-5,5-6C179.7,1698.4,177.7,1700.7,175.1,1701.7L175.1,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M177.5,1703c-0.5-2.7,0.6-5.6,2.7-7.4C180.6,1698.4,179.6,1701.2,177.5,1703L177.5,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M180.2,1703.5c-1.4-2.4-1.4-5.4,0-7.8C181.5,1698.1,181.5,1701.1,180.2,1703.5L180.2,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M182.9,1703c-2.1-1.8-3.1-4.6-2.7-7.4C182.3,1697.5,183.3,1700.3,182.9,1703L182.9,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M185.2,1701.7c-2.6-1-4.5-3.3-5-6C182.8,1696.6,184.7,1698.9,185.2,1701.7L185.2,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M187,1699.6c-2.8,0-5.4-1.5-6.8-3.9C182.9,1695.7,185.5,1697.2,187,1699.6L187,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M187.9,1697c-2.6,0.9-5.6,0.4-7.7-1.4C182.8,1694.7,185.7,1695.3,187.9,1697L187.9,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M187.9,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C182.3,1693.9,185.3,1693.4,187.9,1694.3L187.9,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M187,1691.7c-1.4,2.4-4,3.9-6.8,3.9C181.6,1693.3,184.2,1691.8,187,1691.7L187,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M185.2,1689.7c-0.5,2.7-2.4,5-5,6C180.7,1692.9,182.6,1690.6,185.2,1689.7L185.2,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M182.9,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C179.7,1692.9,180.7,1690.1,182.9,1688.3L182.9,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 180.2,
    cy: 1695.7,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 193.5,
    y1: 1700.6,
    x2: 193.5,
    y2: 1722
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M193.6,1722c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C201.6,1727.6,198.1,1722,193.6,1722z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.5,1707.5c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C194.9,1707.2,194.3,1707.5,193.5,1707.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.7,1702.7c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C188.2,1704,187.9,1703.5,187.7,1702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.5,1712.3c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C194.9,1712,194.3,1712.2,193.5,1712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M187.7,1707.5c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C188.2,1708.8,187.9,1708.3,187.7,1707.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M193.6,1687.8c1.4,2.4,1.4,5.4,0,7.8C192.2,1693.2,192.2,1690.2,193.6,1687.8L193.6,1687.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M190.9,1688.3c2.1,1.8,3.1,4.6,2.7,7.4C191.4,1693.9,190.4,1691,190.9,1688.3L190.9,1688.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M188.5,1689.7c2.6,1,4.5,3.3,5,6C191,1694.7,189,1692.4,188.5,1689.7L188.5,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M186.8,1691.7c2.8,0,5.4,1.5,6.8,3.9C190.8,1695.6,188.2,1694.1,186.8,1691.7L186.8,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M185.8,1694.3c2.6-0.9,5.6-0.4,7.7,1.4C190.9,1696.6,188,1696.1,185.8,1694.3L185.8,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M185.8,1697c2.1-1.8,5.1-2.3,7.7-1.4C191.4,1697.4,188.5,1697.9,185.8,1697L185.8,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M186.8,1699.6c1.4-2.4,4-3.9,6.8-3.9C192.2,1698.1,189.5,1699.6,186.8,1699.6L186.8,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M188.5,1701.7c0.5-2.7,2.4-5,5-6C193.1,1698.4,191.1,1700.7,188.5,1701.7L188.5,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M190.9,1703c-0.5-2.7,0.6-5.6,2.7-7.4C194,1698.4,193,1701.2,190.9,1703L190.9,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M193.6,1703.5c-1.4-2.4-1.4-5.4,0-7.8C194.9,1698.1,194.9,1701.1,193.6,1703.5L193.6,1703.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M196.2,1703c-2.1-1.8-3.1-4.6-2.7-7.4C195.7,1697.5,196.7,1700.3,196.2,1703L196.2,1703z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M198.6,1701.7c-2.6-1-4.5-3.3-5-6C196.2,1696.6,198.1,1698.9,198.6,1701.7L198.6,1701.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M200.3,1699.6c-2.8,0-5.4-1.5-6.8-3.9C196.3,1695.7,198.9,1697.2,200.3,1699.6L200.3,1699.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M201.3,1697c-2.6,0.9-5.6,0.4-7.7-1.4C196.2,1694.7,199.1,1695.3,201.3,1697L201.3,1697z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M201.3,1694.3c-2.1,1.8-5.1,2.3-7.7,1.4C195.7,1693.9,198.7,1693.4,201.3,1694.3L201.3,1694.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M200.3,1691.7c-1.4,2.4-4,3.9-6.8,3.9C195,1693.3,197.6,1691.8,200.3,1691.7L200.3,1691.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M198.6,1689.7c-0.5,2.7-2.4,5-5,6C194.1,1692.9,196,1690.6,198.6,1689.7L198.6,1689.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M196.2,1688.3c0.5,2.7-0.6,5.6-2.7,7.4C193.1,1692.9,194.1,1690.1,196.2,1688.3L196.2,1688.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 193.6,
    cy: 1695.7,
    r: 3.9
  }))))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 76.2,
    y1: 1716.5,
    x2: 76.2,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M76.2,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C84.3,1743.4,80.7,1737.9,76.2,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.1,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C77.5,1723.1,76.9,1723.3,76.1,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S70.5,1719.3,70.3,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.1,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S76.9,1728.1,76.1,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.3,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C70.9,1724.7,70.5,1724.1,70.3,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M76.2,1703.7c1.4,2.4,1.4,5.4,0,7.8C74.8,1709.1,74.8,1706.1,76.2,1703.7L76.2,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M73.5,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C74.1,1709.7,73.1,1706.9,73.5,1704.2L73.5,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M71.2,1705.5c2.6,1,4.5,3.3,5,6C73.6,1710.6,71.7,1708.3,71.2,1705.5L71.2,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M69.4,1707.6c2.8,0,5.4,1.5,6.8,3.9C73.4,1711.5,70.8,1710,69.4,1707.6L69.4,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M68.5,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C73.6,1712.5,70.6,1711.9,68.5,1710.2L68.5,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M68.5,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C74.1,1713.3,71.1,1713.8,68.5,1712.9L68.5,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M69.4,1715.5c1.4-2.4,4-3.9,6.8-3.9C74.8,1713.9,72.2,1715.4,69.4,1715.5L69.4,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M71.2,1717.5c0.5-2.7,2.4-5,5-6C75.7,1714.3,73.8,1716.6,71.2,1717.5L71.2,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M73.5,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C76.7,1714.3,75.6,1717.1,73.5,1718.9L73.5,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M76.2,1719.4c-1.4-2.4-1.4-5.4,0-7.8C77.6,1714,77.6,1717,76.2,1719.4L76.2,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M78.9,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C78.3,1713.3,79.3,1716.2,78.9,1718.9L78.9,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M81.2,1717.5c-2.6-1-4.5-3.3-5-6C78.8,1712.5,80.7,1714.8,81.2,1717.5L81.2,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M83,1715.5c-2.8,0-5.4-1.5-6.8-3.9C79,1711.6,81.6,1713.1,83,1715.5L83,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M83.9,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C78.8,1710.6,81.8,1711.1,83.9,1712.9L83.9,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M83.9,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C78.3,1709.8,81.3,1709.3,83.9,1710.2L83.9,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M83,1707.6c-1.4,2.4-4,3.9-6.8,3.9C77.6,1709.1,80.2,1707.7,83,1707.6L83,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M81.2,1705.5c-0.5,2.7-2.4,5-5,6C76.7,1708.8,78.6,1706.5,81.2,1705.5L81.2,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M78.9,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C75.7,1708.8,76.8,1706,78.9,1704.2L78.9,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 76.2,
    cy: 1711.5,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 89.6,
    y1: 1716.5,
    x2: 89.6,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M89.6,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C97.6,1743.4,94.1,1737.9,89.6,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.5,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C90.9,1723.1,90.3,1723.3,89.5,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.7,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C84.3,1719.9,83.9,1719.3,83.7,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.5,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S90.3,1728.1,89.5,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.7,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C84.3,1724.7,83.9,1724.1,83.7,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89.6,1703.7c1.4,2.4,1.4,5.4,0,7.8C88.2,1709.1,88.2,1706.1,89.6,1703.7L89.6,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M86.9,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C87.5,1709.7,86.5,1706.9,86.9,1704.2L86.9,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M84.5,1705.5c2.6,1,4.5,3.3,5,6C87,1710.6,85.1,1708.3,84.5,1705.5L84.5,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M82.8,1707.6c2.8,0,5.4,1.5,6.8,3.9C86.8,1711.5,84.2,1710,82.8,1707.6L82.8,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M81.9,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C87,1712.5,84,1711.9,81.9,1710.2L81.9,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M81.9,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C87.4,1713.3,84.5,1713.8,81.9,1712.9L81.9,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M82.8,1715.5c1.4-2.4,4-3.9,6.8-3.9C88.2,1713.9,85.6,1715.4,82.8,1715.5L82.8,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M84.5,1717.5c0.5-2.7,2.4-5,5-6C89.1,1714.3,87.1,1716.6,84.5,1717.5L84.5,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M86.9,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C90,1714.3,89,1717.1,86.9,1718.9L86.9,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89.6,1719.4c-1.4-2.4-1.4-5.4,0-7.8C90.9,1714,90.9,1717,89.6,1719.4L89.6,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M92.3,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C91.7,1713.3,92.7,1716.2,92.3,1718.9L92.3,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M94.6,1717.5c-2.6-1-4.5-3.3-5-6C92.2,1712.5,94.1,1714.8,94.6,1717.5L94.6,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.4,1715.5c-2.8,0-5.4-1.5-6.8-3.9C92.4,1711.6,95,1713.1,96.4,1715.5L96.4,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M97.3,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C92.2,1710.6,95.2,1711.1,97.3,1712.9L97.3,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M97.3,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C91.7,1709.8,94.7,1709.3,97.3,1710.2L97.3,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.4,1707.6c-1.4,2.4-4,3.9-6.8,3.9C91,1709.1,93.6,1707.7,96.4,1707.6L96.4,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M94.6,1705.5c-0.5,2.7-2.4,5-5,6C90.1,1708.8,92,1706.5,94.6,1705.5L94.6,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M92.3,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C89.1,1708.8,90.2,1706,92.3,1704.2L92.3,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 89.6,
    cy: 1711.5,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 102.9,
    y1: 1716.5,
    x2: 102.9,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M103,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H103h11.1c0.4,0,0.6-0.5,0.2-0.7 C111,1743.4,107.5,1737.9,103,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.9,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C104.3,1723.1,103.7,1723.3,102.9,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.1,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S97.3,1719.3,97.1,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.9,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S103.7,1728.1,102.9,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.1,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C97.7,1724.7,97.3,1724.1,97.1,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M103,1703.7c1.4,2.4,1.4,5.4,0,7.8C101.6,1709.1,101.6,1706.1,103,1703.7L103,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M100.3,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C100.9,1709.7,99.8,1706.9,100.3,1704.2L100.3,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M97.9,1705.5c2.6,1,4.5,3.3,5,6C100.4,1710.6,98.4,1708.3,97.9,1705.5L97.9,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.2,1707.6c2.8,0,5.4,1.5,6.8,3.9C100.2,1711.5,97.6,1710,96.2,1707.6L96.2,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M95.3,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C100.4,1712.5,97.4,1711.9,95.3,1710.2L95.3,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M95.3,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C100.8,1713.3,97.9,1713.8,95.3,1712.9L95.3,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.2,1715.5c1.4-2.4,4-3.9,6.8-3.9C101.6,1713.9,99,1715.4,96.2,1715.5L96.2,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M97.9,1717.5c0.5-2.7,2.4-5,5-6C102.5,1714.3,100.5,1716.6,97.9,1717.5L97.9,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M100.3,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C103.4,1714.3,102.4,1717.1,100.3,1718.9L100.3,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M103,1719.4c-1.4-2.4-1.4-5.4,0-7.8C104.3,1714,104.3,1717,103,1719.4L103,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M105.6,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C105.1,1713.3,106.1,1716.2,105.6,1718.9L105.6,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M108,1717.5c-2.6-1-4.5-3.3-5-6C105.6,1712.5,107.5,1714.8,108,1717.5L108,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M109.8,1715.5c-2.8,0-5.4-1.5-6.8-3.9C105.7,1711.6,108.3,1713.1,109.8,1715.5L109.8,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M110.7,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C105.6,1710.6,108.5,1711.1,110.7,1712.9L110.7,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M110.7,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C105.1,1709.8,108.1,1709.3,110.7,1710.2L110.7,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M109.8,1707.6c-1.4,2.4-4,3.9-6.8,3.9C104.4,1709.1,107,1707.7,109.8,1707.6L109.8,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M108,1705.5c-0.5,2.7-2.4,5-5,6C103.5,1708.8,105.4,1706.5,108,1705.5L108,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M105.6,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C102.5,1708.8,103.5,1706,105.6,1704.2L105.6,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 103,
    cy: 1711.5,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 116.3,
    y1: 1716.5,
    x2: 116.3,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M116.4,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C124.4,1743.4,120.9,1737.9,116.4,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.3,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C117.7,1723.1,117.1,1723.3,116.3,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.4,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S110.7,1719.3,110.4,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.3,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C117.7,1727.9,117.1,1728.1,116.3,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.4,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C111,1724.7,110.7,1724.1,110.4,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M116.4,1703.7c1.4,2.4,1.4,5.4,0,7.8C115,1709.1,115,1706.1,116.4,1703.7L116.4,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M113.7,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C114.2,1709.7,113.2,1706.9,113.7,1704.2L113.7,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M111.3,1705.5c2.6,1,4.5,3.3,5,6C113.8,1710.6,111.8,1708.3,111.3,1705.5L111.3,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M109.6,1707.6c2.8,0,5.4,1.5,6.8,3.9C113.6,1711.5,111,1710,109.6,1707.6L109.6,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M108.6,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C113.7,1712.5,110.8,1711.9,108.6,1710.2L108.6,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M108.6,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C114.2,1713.3,111.3,1713.8,108.6,1712.9L108.6,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M109.6,1715.5c1.4-2.4,4-3.9,6.8-3.9C114.9,1713.9,112.3,1715.4,109.6,1715.5L109.6,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M111.3,1717.5c0.5-2.7,2.4-5,5-6C115.8,1714.3,113.9,1716.6,111.3,1717.5L111.3,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M113.7,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C116.8,1714.3,115.8,1717.1,113.7,1718.9L113.7,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M116.4,1719.4c-1.4-2.4-1.4-5.4,0-7.8C117.7,1714,117.7,1717,116.4,1719.4L116.4,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M119,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C118.5,1713.3,119.5,1716.2,119,1718.9L119,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M121.4,1717.5c-2.6-1-4.5-3.3-5-6C119,1712.5,120.9,1714.8,121.4,1717.5L121.4,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M123.1,1715.5c-2.8,0-5.4-1.5-6.8-3.9C119.1,1711.6,121.7,1713.1,123.1,1715.5L123.1,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M124.1,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C119,1710.6,121.9,1711.1,124.1,1712.9L124.1,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M124.1,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C118.5,1709.8,121.5,1709.3,124.1,1710.2L124.1,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M123.1,1707.6c-1.4,2.4-4,3.9-6.8,3.9C117.8,1709.1,120.4,1707.7,123.1,1707.6L123.1,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M121.4,1705.5c-0.5,2.7-2.4,5-5,6C116.9,1708.8,118.8,1706.5,121.4,1705.5L121.4,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M119,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C115.9,1708.8,116.9,1706,119,1704.2L119,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 116.4,
    cy: 1711.5,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 129.7,
    y1: 1716.5,
    x2: 129.7,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M129.8,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C137.8,1743.4,134.3,1737.9,129.8,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.7,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C131.1,1723.1,130.4,1723.3,129.7,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.8,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C124.4,1719.9,124.1,1719.3,123.8,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.7,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C131.1,1727.9,130.4,1728.1,129.7,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.8,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C124.4,1724.7,124.1,1724.1,123.8,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M129.7,1703.7c1.4,2.4,1.4,5.4,0,7.8C128.4,1709.1,128.4,1706.1,129.7,1703.7L129.7,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M127.1,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C127.6,1709.7,126.6,1706.9,127.1,1704.2L127.1,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M124.7,1705.5c2.6,1,4.5,3.3,5,6C127.1,1710.6,125.2,1708.3,124.7,1705.5L124.7,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M123,1707.6c2.8,0,5.4,1.5,6.8,3.9C127,1711.5,124.4,1710,123,1707.6L123,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M122,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C127.1,1712.5,124.2,1711.9,122,1710.2L122,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M122,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C127.6,1713.3,124.6,1713.8,122,1712.9L122,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M123,1715.5c1.4-2.4,4-3.9,6.8-3.9C128.3,1713.9,125.7,1715.4,123,1715.5L123,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M124.7,1717.5c0.5-2.7,2.4-5,5-6C129.2,1714.3,127.3,1716.6,124.7,1717.5L124.7,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M127.1,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C130.2,1714.3,129.2,1717.1,127.1,1718.9L127.1,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M129.7,1719.4c-1.4-2.4-1.4-5.4,0-7.8C131.1,1714,131.1,1717,129.7,1719.4L129.7,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M132.4,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C131.9,1713.3,132.9,1716.2,132.4,1718.9L132.4,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M134.8,1717.5c-2.6-1-4.5-3.3-5-6C132.3,1712.5,134.3,1714.8,134.8,1717.5L134.8,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M136.5,1715.5c-2.8,0-5.4-1.5-6.8-3.9C132.5,1711.6,135.1,1713.1,136.5,1715.5L136.5,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M137.5,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C132.4,1710.6,135.3,1711.1,137.5,1712.9L137.5,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M137.5,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C131.9,1709.8,134.8,1709.3,137.5,1710.2L137.5,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M136.5,1707.6c-1.4,2.4-4,3.9-6.8,3.9C131.1,1709.1,133.8,1707.7,136.5,1707.6L136.5,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M134.8,1705.5c-0.5,2.7-2.4,5-5,6C130.2,1708.8,132.2,1706.5,134.8,1705.5L134.8,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M132.4,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C129.3,1708.8,130.3,1706,132.4,1704.2L132.4,1704.2z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(6.652079e-02 -0.9978 0.9978 6.652079e-02 -1586.7164 1726.9893)",
    className: "st40",
    cx: 129.6,
    cy: 1711.5,
    rx: 3.9,
    ry: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 143.1,
    y1: 1716.5,
    x2: 143.1,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M143.2,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C151.2,1743.4,147.7,1737.9,143.2,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.1,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C144.4,1723.1,143.8,1723.3,143.1,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.2,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C137.8,1719.9,137.5,1719.3,137.2,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.1,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C144.4,1727.9,143.8,1728.1,143.1,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.2,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C137.8,1724.7,137.5,1724.1,137.2,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M143.1,1703.7c1.4,2.4,1.4,5.4,0,7.8C141.8,1709.1,141.8,1706.1,143.1,1703.7L143.1,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M140.4,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C141,1709.7,140,1706.9,140.4,1704.2L140.4,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M138.1,1705.5c2.6,1,4.5,3.3,5,6C140.5,1710.6,138.6,1708.3,138.1,1705.5L138.1,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M136.3,1707.6c2.8,0,5.4,1.5,6.8,3.9C140.3,1711.5,137.8,1710,136.3,1707.6L136.3,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M135.4,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C140.5,1712.5,137.6,1711.9,135.4,1710.2L135.4,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M135.4,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C141,1713.3,138,1713.8,135.4,1712.9L135.4,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M136.3,1715.5c1.4-2.4,4-3.9,6.8-3.9C141.7,1713.9,139.1,1715.4,136.3,1715.5L136.3,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M138.1,1717.5c0.5-2.7,2.4-5,5-6C142.6,1714.3,140.7,1716.6,138.1,1717.5L138.1,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M140.4,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C143.6,1714.3,142.5,1717.1,140.4,1718.9L140.4,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M143.1,1719.4c-1.4-2.4-1.4-5.4,0-7.8C144.5,1714,144.5,1717,143.1,1719.4L143.1,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M145.8,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C145.2,1713.3,146.3,1716.2,145.8,1718.9L145.8,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M148.2,1717.5c-2.6-1-4.5-3.3-5-6C145.7,1712.5,147.6,1714.8,148.2,1717.5L148.2,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M149.9,1715.5c-2.8,0-5.4-1.5-6.8-3.9C145.9,1711.6,148.5,1713.1,149.9,1715.5L149.9,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M150.8,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C145.7,1710.6,148.7,1711.1,150.8,1712.9L150.8,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M150.8,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C145.3,1709.8,148.2,1709.3,150.8,1710.2L150.8,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M149.9,1707.6c-1.4,2.4-4,3.9-6.8,3.9C144.5,1709.1,147.1,1707.7,149.9,1707.6L149.9,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M148.2,1705.5c-0.5,2.7-2.4,5-5,6C143.6,1708.8,145.6,1706.5,148.2,1705.5L148.2,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M145.8,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C142.7,1708.8,143.7,1706,145.8,1704.2L145.8,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 143.1,
    cy: 1711.5,
    r: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 155.7,
    y1: 1716.5,
    x2: 155.7,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M155.8,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C163.8,1743.4,160.3,1737.9,155.8,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.7,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C157.1,1723.1,156.5,1723.3,155.7,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.9,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C150.5,1719.9,150.1,1719.3,149.9,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.7,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C157.1,1727.9,156.5,1728.1,155.7,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.9,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C150.5,1724.7,150.1,1724.1,149.9,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M155.8,1703.7c1.4,2.4,1.4,5.4,0,7.8C154.4,1709.1,154.4,1706.1,155.8,1703.7L155.8,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M153.1,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C153.7,1709.7,152.6,1706.9,153.1,1704.2L153.1,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M150.7,1705.5c2.6,1,4.5,3.3,5,6C153.2,1710.6,151.2,1708.3,150.7,1705.5L150.7,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M149,1707.6c2.8,0,5.4,1.5,6.8,3.9C153,1711.5,150.4,1710,149,1707.6L149,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M148,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C153.1,1712.5,150.2,1711.9,148,1710.2L148,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M148,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C153.6,1713.3,150.7,1713.8,148,1712.9L148,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M149,1715.5c1.4-2.4,4-3.9,6.8-3.9C154.4,1713.9,151.8,1715.4,149,1715.5L149,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M150.7,1717.5c0.5-2.7,2.4-5,5-6C155.3,1714.3,153.3,1716.6,150.7,1717.5L150.7,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M153.1,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C156.2,1714.3,155.2,1717.1,153.1,1718.9L153.1,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M155.8,1719.4c-1.4-2.4-1.4-5.4,0-7.8C157.1,1714,157.1,1717,155.8,1719.4L155.8,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M158.4,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C157.9,1713.3,158.9,1716.2,158.4,1718.9L158.4,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160.8,1717.5c-2.6-1-4.5-3.3-5-6C158.4,1712.5,160.3,1714.8,160.8,1717.5L160.8,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M162.5,1715.5c-2.8,0-5.4-1.5-6.8-3.9C158.5,1711.6,161.1,1713.1,162.5,1715.5L162.5,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M163.5,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C158.4,1710.6,161.3,1711.1,163.5,1712.9L163.5,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M163.5,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C157.9,1709.8,160.9,1709.3,163.5,1710.2L163.5,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M162.5,1707.6c-1.4,2.4-4,3.9-6.8,3.9C157.2,1709.1,159.8,1707.7,162.5,1707.6L162.5,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M160.8,1705.5c-0.5,2.7-2.4,5-5,6C156.3,1708.8,158.2,1706.5,160.8,1705.5L160.8,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M158.4,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C155.3,1708.8,156.3,1706,158.4,1704.2L158.4,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 155.8,
    cy: 1711.5,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 169.1,
    y1: 1716.5,
    x2: 169.1,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M169.2,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C177.2,1743.4,173.7,1737.9,169.2,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.1,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C170.5,1723.1,169.8,1723.3,169.1,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.2,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C163.8,1719.9,163.5,1719.3,163.2,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.1,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S169.8,1728.1,169.1,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.2,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C163.8,1724.7,163.5,1724.1,163.2,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M169.1,1703.7c1.4,2.4,1.4,5.4,0,7.8C167.8,1709.1,167.8,1706.1,169.1,1703.7L169.1,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M166.5,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C167,1709.7,166,1706.9,166.5,1704.2L166.5,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M164.1,1705.5c2.6,1,4.5,3.3,5,6C166.5,1710.6,164.6,1708.3,164.1,1705.5L164.1,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M162.4,1707.6c2.8,0,5.4,1.5,6.8,3.9C166.4,1711.5,163.8,1710,162.4,1707.6L162.4,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M161.4,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C166.5,1712.5,163.6,1711.9,161.4,1710.2L161.4,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M161.4,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C167,1713.3,164,1713.8,161.4,1712.9L161.4,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M162.4,1715.5c1.4-2.4,4-3.9,6.8-3.9C167.7,1713.9,165.1,1715.4,162.4,1715.5L162.4,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M164.1,1717.5c0.5-2.7,2.4-5,5-6C168.6,1714.3,166.7,1716.6,164.1,1717.5L164.1,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M166.5,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C169.6,1714.3,168.6,1717.1,166.5,1718.9L166.5,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M169.1,1719.4c-1.4-2.4-1.4-5.4,0-7.8C170.5,1714,170.5,1717,169.1,1719.4L169.1,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M171.8,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C171.3,1713.3,172.3,1716.2,171.8,1718.9L171.8,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M174.2,1717.5c-2.6-1-4.5-3.3-5-6C171.8,1712.5,173.7,1714.8,174.2,1717.5L174.2,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M175.9,1715.5c-2.8,0-5.4-1.5-6.8-3.9C171.9,1711.6,174.5,1713.1,175.9,1715.5L175.9,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M176.9,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C171.8,1710.6,174.7,1711.1,176.9,1712.9L176.9,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M176.9,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C171.3,1709.8,174.2,1709.3,176.9,1710.2L176.9,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M175.9,1707.6c-1.4,2.4-4,3.9-6.8,3.9C170.6,1709.1,173.2,1707.7,175.9,1707.6L175.9,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M174.2,1705.5c-0.5,2.7-2.4,5-5,6C169.7,1708.8,171.6,1706.5,174.2,1705.5L174.2,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M171.8,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C168.7,1708.8,169.7,1706,171.8,1704.2L171.8,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 169.1,
    cy: 1711.5,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 182.5,
    y1: 1716.5,
    x2: 182.5,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M182.6,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C190.6,1743.4,187.1,1737.9,182.6,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.5,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C183.9,1723.1,183.2,1723.3,182.5,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.6,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S176.9,1719.3,176.6,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.5,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S183.2,1728.1,182.5,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.6,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C177.2,1724.7,176.9,1724.1,176.6,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M182.5,1703.7c1.4,2.4,1.4,5.4,0,7.8C181.2,1709.1,181.2,1706.1,182.5,1703.7L182.5,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M179.9,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C180.4,1709.7,179.4,1706.9,179.9,1704.2L179.9,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M177.5,1705.5c2.6,1,4.5,3.3,5,6C179.9,1710.6,178,1708.3,177.5,1705.5L177.5,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M175.7,1707.6c2.8,0,5.4,1.5,6.8,3.9C179.8,1711.5,177.2,1710,175.7,1707.6L175.7,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M174.8,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C179.9,1712.5,177,1711.9,174.8,1710.2L174.8,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M174.8,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C180.4,1713.3,177.4,1713.8,174.8,1712.9L174.8,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M175.7,1715.5c1.4-2.4,4-3.9,6.8-3.9C181.1,1713.9,178.5,1715.4,175.7,1715.5L175.7,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M177.5,1717.5c0.5-2.7,2.4-5,5-6C182,1714.3,180.1,1716.6,177.5,1717.5L177.5,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M179.9,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C183,1714.3,182,1717.1,179.9,1718.9L179.9,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M182.5,1719.4c-1.4-2.4-1.4-5.4,0-7.8C183.9,1714,183.9,1717,182.5,1719.4L182.5,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M185.2,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C184.6,1713.3,185.7,1716.2,185.2,1718.9L185.2,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M187.6,1717.5c-2.6-1-4.5-3.3-5-6C185.1,1712.5,187.1,1714.8,187.6,1717.5L187.6,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M189.3,1715.5c-2.8,0-5.4-1.5-6.8-3.9C185.3,1711.6,187.9,1713.1,189.3,1715.5L189.3,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M190.3,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C185.2,1710.6,188.1,1711.1,190.3,1712.9L190.3,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M190.3,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C184.7,1709.8,187.6,1709.3,190.3,1710.2L190.3,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M189.3,1707.6c-1.4,2.4-4,3.9-6.8,3.9C183.9,1709.1,186.5,1707.7,189.3,1707.6L189.3,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M187.6,1705.5c-0.5,2.7-2.4,5-5,6C183,1708.8,185,1706.5,187.6,1705.5L187.6,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M185.2,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C182.1,1708.8,183.1,1706,185.2,1704.2L185.2,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 182.5,
    cy: 1711.5,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 195.9,
    y1: 1716.5,
    x2: 195.9,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M196,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H196h11c0.4,0,0.6-0.5,0.2-0.7 C204,1743.4,200.4,1737.9,196,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.9,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C197.2,1723.1,196.6,1723.3,195.9,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C190.6,1719.9,190.2,1719.3,190,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.9,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C197.2,1727.9,196.6,1728.1,195.9,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C190.6,1724.7,190.2,1724.1,190,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M195.9,1703.7c1.4,2.4,1.4,5.4,0,7.8C194.6,1709.1,194.6,1706.1,195.9,1703.7L195.9,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M193.2,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C193.8,1709.7,192.8,1706.9,193.2,1704.2L193.2,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M190.9,1705.5c2.6,1,4.5,3.3,5,6C193.3,1710.6,191.4,1708.3,190.9,1705.5L190.9,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M189.1,1707.6c2.8,0,5.4,1.5,6.8,3.9C193.1,1711.5,190.5,1710,189.1,1707.6L189.1,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M188.2,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C193.3,1712.5,190.3,1711.9,188.2,1710.2L188.2,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M188.2,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C193.8,1713.3,190.8,1713.8,188.2,1712.9L188.2,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M189.1,1715.5c1.4-2.4,4-3.9,6.8-3.9C194.5,1713.9,191.9,1715.4,189.1,1715.5L189.1,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M190.9,1717.5c0.5-2.7,2.4-5,5-6C195.4,1714.3,193.5,1716.6,190.9,1717.5L190.9,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M193.2,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C196.4,1714.3,195.3,1717.1,193.2,1718.9L193.2,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M195.9,1719.4c-1.4-2.4-1.4-5.4,0-7.8C197.3,1714,197.3,1717,195.9,1719.4L195.9,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M198.6,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C198,1713.3,199.1,1716.2,198.6,1718.9L198.6,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M201,1717.5c-2.6-1-4.5-3.3-5-6C198.5,1712.5,200.4,1714.8,201,1717.5L201,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M202.7,1715.5c-2.8,0-5.4-1.5-6.8-3.9C198.7,1711.6,201.3,1713.1,202.7,1715.5L202.7,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M203.6,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C198.5,1710.6,201.5,1711.1,203.6,1712.9L203.6,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M203.6,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C198.1,1709.8,201,1709.3,203.6,1710.2L203.6,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M202.7,1707.6c-1.4,2.4-4,3.9-6.8,3.9C197.3,1709.1,199.9,1707.7,202.7,1707.6L202.7,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M201,1705.5c-0.5,2.7-2.4,5-5,6C196.4,1708.8,198.4,1706.5,201,1705.5L201,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M198.6,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C195.5,1708.8,196.5,1706,198.6,1704.2L198.6,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 195.9,
    cy: 1711.5,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 209.3,
    y1: 1716.5,
    x2: 209.3,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M209.3,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C217.4,1743.4,213.8,1737.9,209.3,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.3,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C210.6,1723.1,210,1723.3,209.3,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.4,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C204,1719.9,203.6,1719.3,203.4,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.3,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C210.6,1727.9,210,1728.1,209.3,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.4,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C204,1724.7,203.6,1724.1,203.4,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M209.3,1703.7c1.4,2.4,1.4,5.4,0,7.8C207.9,1709.1,207.9,1706.1,209.3,1703.7L209.3,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M206.6,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C207.2,1709.7,206.2,1706.9,206.6,1704.2L206.6,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M204.3,1705.5c2.6,1,4.5,3.3,5,6C206.7,1710.6,204.8,1708.3,204.3,1705.5L204.3,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M202.5,1707.6c2.8,0,5.4,1.5,6.8,3.9C206.5,1711.5,203.9,1710,202.5,1707.6L202.5,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M201.6,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C206.7,1712.5,203.7,1711.9,201.6,1710.2L201.6,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M201.6,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C207.2,1713.3,204.2,1713.8,201.6,1712.9L201.6,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M202.5,1715.5c1.4-2.4,4-3.9,6.8-3.9C207.9,1713.9,205.3,1715.4,202.5,1715.5L202.5,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M204.3,1717.5c0.5-2.7,2.4-5,5-6C208.8,1714.3,206.9,1716.6,204.3,1717.5L204.3,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M206.6,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C209.8,1714.3,208.7,1717.1,206.6,1718.9L206.6,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M209.3,1719.4c-1.4-2.4-1.4-5.4,0-7.8C210.7,1714,210.7,1717,209.3,1719.4L209.3,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M212,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C211.4,1713.3,212.4,1716.2,212,1718.9L212,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M214.3,1717.5c-2.6-1-4.5-3.3-5-6C211.9,1712.5,213.8,1714.8,214.3,1717.5L214.3,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M216.1,1715.5c-2.8,0-5.4-1.5-6.8-3.9C212.1,1711.6,214.7,1713.1,216.1,1715.5L216.1,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M217,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C211.9,1710.6,214.9,1711.1,217,1712.9L217,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M217,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C211.4,1709.8,214.4,1709.3,217,1710.2L217,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M216.1,1707.6c-1.4,2.4-4,3.9-6.8,3.9C210.7,1709.1,213.3,1707.7,216.1,1707.6L216.1,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M214.3,1705.5c-0.5,2.7-2.4,5-5,6C209.8,1708.8,211.7,1706.5,214.3,1705.5L214.3,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M212,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C208.8,1708.8,209.9,1706,212,1704.2L212,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 209.3,
    cy: 1711.5,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 222.7,
    y1: 1716.5,
    x2: 222.7,
    y2: 1737.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M222.7,1737.9c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C230.8,1743.4,227.2,1737.9,222.7,1737.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.6,1723.4c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C224,1723.1,223.4,1723.3,222.6,1723.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.8,1718.6c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4S217,1719.3,216.8,1718.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.6,1728.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1S223.4,1728.1,222.6,1728.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.8,1723.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C217.4,1724.7,217,1724.1,216.8,1723.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M222.7,1703.7c1.4,2.4,1.4,5.4,0,7.8C221.3,1709.1,221.3,1706.1,222.7,1703.7L222.7,1703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M220,1704.2c2.1,1.8,3.1,4.6,2.7,7.4C220.6,1709.7,219.6,1706.9,220,1704.2L220,1704.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M217.7,1705.5c2.6,1,4.5,3.3,5,6C220.1,1710.6,218.2,1708.3,217.7,1705.5L217.7,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M215.9,1707.6c2.8,0,5.4,1.5,6.8,3.9C219.9,1711.5,217.3,1710,215.9,1707.6L215.9,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M215,1710.2c2.6-0.9,5.6-0.4,7.7,1.4C220.1,1712.5,217.1,1711.9,215,1710.2L215,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M215,1712.9c2.1-1.8,5.1-2.3,7.7-1.4C220.6,1713.3,217.6,1713.8,215,1712.9L215,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M215.9,1715.5c1.4-2.4,4-3.9,6.8-3.9C221.3,1713.9,218.7,1715.4,215.9,1715.5L215.9,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M217.7,1717.5c0.5-2.7,2.4-5,5-6C222.2,1714.3,220.3,1716.6,217.7,1717.5L217.7,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M220,1718.9c-0.5-2.7,0.6-5.6,2.7-7.4C223.2,1714.3,222.1,1717.1,220,1718.9L220,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M222.7,1719.4c-1.4-2.4-1.4-5.4,0-7.8C224.1,1714,224.1,1717,222.7,1719.4L222.7,1719.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M225.4,1718.9c-2.1-1.8-3.1-4.6-2.7-7.4C224.8,1713.3,225.8,1716.2,225.4,1718.9L225.4,1718.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M227.7,1717.5c-2.6-1-4.5-3.3-5-6C225.3,1712.5,227.2,1714.8,227.7,1717.5L227.7,1717.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M229.5,1715.5c-2.8,0-5.4-1.5-6.8-3.9C225.5,1711.6,228.1,1713.1,229.5,1715.5L229.5,1715.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M230.4,1712.9c-2.6,0.9-5.6,0.4-7.7-1.4C225.3,1710.6,228.3,1711.1,230.4,1712.9L230.4,1712.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M230.4,1710.2c-2.1,1.8-5.1,2.3-7.7,1.4C224.8,1709.8,227.8,1709.3,230.4,1710.2L230.4,1710.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M229.5,1707.6c-1.4,2.4-4,3.9-6.8,3.9C224.1,1709.1,226.7,1707.7,229.5,1707.6L229.5,1707.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M227.7,1705.5c-0.5,2.7-2.4,5-5,6C223.2,1708.8,225.1,1706.5,227.7,1705.5L227.7,1705.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M225.4,1704.2c0.5,2.7-0.6,5.6-2.7,7.4C222.2,1708.8,223.3,1706,225.4,1704.2L225.4,1704.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 222.7,
    cy: 1711.5,
    r: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 82.8,
    y1: 1727.2,
    x2: 82.8,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M82.8,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C90.9,1754.2,87.3,1748.6,82.8,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.7,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C84.1,1733.8,83.5,1734.1,82.7,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.9,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C77.5,1730.7,77.1,1730.1,76.9,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.7,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C84.1,1738.6,83.5,1738.9,82.7,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.9,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C77.5,1735.4,77.1,1734.9,76.9,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M82.8,1714.5c1.4,2.4,1.4,5.4,0,7.8C81.4,1719.9,81.4,1716.9,82.8,1714.5L82.8,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M80.1,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C80.7,1720.5,79.7,1717.7,80.1,1714.9L80.1,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M77.8,1716.3c2.6,1,4.5,3.3,5,6C80.2,1721.3,78.3,1719,77.8,1716.3L77.8,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M76,1718.4c2.8,0,5.4,1.5,6.8,3.9C80,1722.3,77.4,1720.8,76,1718.4L76,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M75.1,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C80.2,1723.2,77.2,1722.7,75.1,1720.9L75.1,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M75.1,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C80.7,1724.1,77.7,1724.6,75.1,1723.7L75.1,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M76,1726.2c1.4-2.4,4-3.9,6.8-3.9C81.4,1724.7,78.8,1726.2,76,1726.2L76,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M77.8,1728.3c0.5-2.7,2.4-5,5-6C82.3,1725,80.4,1727.3,77.8,1728.3L77.8,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M80.1,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C83.3,1725,82.2,1727.9,80.1,1729.7L80.1,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M82.8,1730.1c-1.4-2.4-1.4-5.4,0-7.8C84.2,1724.7,84.2,1727.7,82.8,1730.1L82.8,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M85.5,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C84.9,1724.1,85.9,1726.9,85.5,1729.7L85.5,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M87.8,1728.3c-2.6-1-4.5-3.3-5-6C85.4,1723.3,87.3,1725.6,87.8,1728.3L87.8,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89.6,1726.2c-2.8,0-5.4-1.5-6.8-3.9C85.6,1722.3,88.2,1723.8,89.6,1726.2L89.6,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M90.5,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C85.4,1721.4,88.4,1721.9,90.5,1723.7L90.5,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M90.5,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C84.9,1720.5,87.9,1720,90.5,1720.9L90.5,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89.6,1718.4c-1.4,2.4-4,3.9-6.8,3.9C84.2,1719.9,86.8,1718.4,89.6,1718.4L89.6,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M87.8,1716.3c-0.5,2.7-2.4,5-5,6C83.3,1719.6,85.2,1717.3,87.8,1716.3L87.8,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M85.5,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C82.3,1719.6,83.4,1716.7,85.5,1714.9L85.5,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 82.8,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 96.2,
    y1: 1727.2,
    x2: 96.2,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M96.2,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C104.2,1754.2,100.7,1748.6,96.2,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.1,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C97.5,1733.8,96.9,1734.1,96.1,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.3,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C90.9,1730.7,90.5,1730.1,90.3,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.1,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C97.5,1738.6,96.9,1738.9,96.1,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.3,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C90.9,1735.4,90.5,1734.9,90.3,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.2,1714.5c1.4,2.4,1.4,5.4,0,7.8C94.8,1719.9,94.8,1716.9,96.2,1714.5L96.2,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M93.5,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C94.1,1720.5,93,1717.7,93.5,1714.9L93.5,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M91.1,1716.3c2.6,1,4.5,3.3,5,6C93.6,1721.3,91.7,1719,91.1,1716.3L91.1,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89.4,1718.4c2.8,0,5.4,1.5,6.8,3.9C93.4,1722.3,90.8,1720.8,89.4,1718.4L89.4,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M88.5,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C93.6,1723.2,90.6,1722.7,88.5,1720.9L88.5,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M88.5,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C94,1724.1,91.1,1724.6,88.5,1723.7L88.5,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M89.4,1726.2c1.4-2.4,4-3.9,6.8-3.9C94.8,1724.7,92.2,1726.2,89.4,1726.2L89.4,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M91.1,1728.3c0.5-2.7,2.4-5,5-6C95.7,1725,93.7,1727.3,91.1,1728.3L91.1,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M93.5,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C96.6,1725,95.6,1727.9,93.5,1729.7L93.5,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M96.2,1730.1c-1.4-2.4-1.4-5.4,0-7.8C97.5,1724.7,97.5,1727.7,96.2,1730.1L96.2,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M98.9,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C98.3,1724.1,99.3,1726.9,98.9,1729.7L98.9,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M101.2,1728.3c-2.6-1-4.5-3.3-5-6C98.8,1723.3,100.7,1725.6,101.2,1728.3L101.2,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M103,1726.2c-2.8,0-5.4-1.5-6.8-3.9C99,1722.3,101.6,1723.8,103,1726.2L103,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M103.9,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C98.8,1721.4,101.8,1721.9,103.9,1723.7L103.9,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M103.9,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C98.3,1720.5,101.3,1720,103.9,1720.9L103.9,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M103,1718.4c-1.4,2.4-4,3.9-6.8,3.9C97.6,1719.9,100.2,1718.4,103,1718.4L103,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M101.2,1716.3c-0.5,2.7-2.4,5-5,6C96.7,1719.6,98.6,1717.3,101.2,1716.3L101.2,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M98.9,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C95.7,1719.6,96.8,1716.7,98.9,1714.9L98.9,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 96.2,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 109.5,
    y1: 1727.2,
    x2: 109.5,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M109.6,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C117.6,1754.2,114.1,1748.6,109.6,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.5,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C110.9,1733.8,110.3,1734.1,109.5,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.7,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C104.3,1730.7,103.9,1730.1,103.7,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.5,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C110.9,1738.6,110.3,1738.9,109.5,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.7,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C104.3,1735.4,103.9,1734.9,103.7,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M109.6,1714.5c1.4,2.4,1.4,5.4,0,7.8C108.2,1719.9,108.2,1716.9,109.6,1714.5L109.6,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M106.9,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C107.5,1720.5,106.4,1717.7,106.9,1714.9L106.9,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M104.5,1716.3c2.6,1,4.5,3.3,5,6C107,1721.3,105,1719,104.5,1716.3L104.5,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M102.8,1718.4c2.8,0,5.4,1.5,6.8,3.9C106.8,1722.3,104.2,1720.8,102.8,1718.4L102.8,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M101.8,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C106.9,1723.2,104,1722.7,101.8,1720.9L101.8,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M101.8,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C107.4,1724.1,104.5,1724.6,101.8,1723.7L101.8,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M102.8,1726.2c1.4-2.4,4-3.9,6.8-3.9C108.2,1724.7,105.6,1726.2,102.8,1726.2L102.8,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M104.5,1728.3c0.5-2.7,2.4-5,5-6C109.1,1725,107.1,1727.3,104.5,1728.3L104.5,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M106.9,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C110,1725,109,1727.9,106.9,1729.7L106.9,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M109.6,1730.1c-1.4-2.4-1.4-5.4,0-7.8C110.9,1724.7,110.9,1727.7,109.6,1730.1L109.6,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M112.2,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C111.7,1724.1,112.7,1726.9,112.2,1729.7L112.2,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M114.6,1728.3c-2.6-1-4.5-3.3-5-6C112.2,1723.3,114.1,1725.6,114.6,1728.3L114.6,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M116.4,1726.2c-2.8,0-5.4-1.5-6.8-3.9C112.3,1722.3,114.9,1723.8,116.4,1726.2L116.4,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M117.3,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C112.2,1721.4,115.1,1721.9,117.3,1723.7L117.3,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M117.3,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C111.7,1720.5,114.7,1720,117.3,1720.9L117.3,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M116.4,1718.4c-1.4,2.4-4,3.9-6.8,3.9C111,1719.9,113.6,1718.4,116.4,1718.4L116.4,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M114.6,1716.3c-0.5,2.7-2.4,5-5,6C110.1,1719.6,112,1717.3,114.6,1716.3L114.6,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M112.2,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C109.1,1719.6,110.1,1716.7,112.2,1714.9L112.2,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 109.6,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 122.9,
    y1: 1727.2,
    x2: 122.9,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M123,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7H123h11c0.4,0,0.6-0.5,0.2-0.7 C131,1754.2,127.5,1748.6,123,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.9,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 c-0.4,0.5-0.8,1-1.3,1.4s-1,0.7-1.6,1C124.3,1733.8,123.6,1734.1,122.9,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C117.6,1730.7,117.3,1730.1,117,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.9,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 c-0.4,0.5-0.8,1-1.3,1.4s-1,0.7-1.6,1C124.3,1738.6,123.6,1738.9,122.9,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C117.6,1735.4,117.3,1734.9,117,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M123,1714.5c1.4,2.4,1.4,5.4,0,7.8C121.6,1719.9,121.6,1716.9,123,1714.5L123,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M120.3,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C120.8,1720.5,119.8,1717.7,120.3,1714.9L120.3,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M117.9,1716.3c2.6,1,4.5,3.3,5,6C120.4,1721.3,118.4,1719,117.9,1716.3L117.9,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M116.2,1718.4c2.8,0,5.4,1.5,6.8,3.9C120.2,1722.3,117.6,1720.8,116.2,1718.4L116.2,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M115.2,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C120.3,1723.2,117.4,1722.7,115.2,1720.9L115.2,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M115.2,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C120.8,1724.1,117.9,1724.6,115.2,1723.7L115.2,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M116.2,1726.2c1.4-2.4,4-3.9,6.8-3.9C121.5,1724.7,118.9,1726.2,116.2,1726.2L116.2,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M117.9,1728.3c0.5-2.7,2.4-5,5-6C122.4,1725,120.5,1727.3,117.9,1728.3L117.9,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M120.3,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C123.4,1725,122.4,1727.9,120.3,1729.7L120.3,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M123,1730.1c-1.4-2.4-1.4-5.4,0-7.8C124.3,1724.7,124.3,1727.7,123,1730.1L123,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M125.6,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C125.1,1724.1,126.1,1726.9,125.6,1729.7L125.6,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M128,1728.3c-2.6-1-4.5-3.3-5-6C125.6,1723.3,127.5,1725.6,128,1728.3L128,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M129.7,1726.2c-2.8,0-5.4-1.5-6.8-3.9C125.7,1722.3,128.3,1723.8,129.7,1726.2L129.7,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M130.7,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C125.6,1721.4,128.5,1721.9,130.7,1723.7L130.7,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M130.7,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C125.1,1720.5,128.1,1720,130.7,1720.9L130.7,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M129.7,1718.4c-1.4,2.4-4,3.9-6.8,3.9C124.4,1719.9,127,1718.4,129.7,1718.4L129.7,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M128,1716.3c-0.5,2.7-2.4,5-5,6C123.5,1719.6,125.4,1717.3,128,1716.3L128,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M125.6,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C122.5,1719.6,123.5,1716.7,125.6,1714.9L125.6,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 123,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 136.3,
    y1: 1727.2,
    x2: 136.3,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M136.4,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C144.4,1754.2,140.9,1748.6,136.4,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.3,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C137.7,1733.8,137,1734.1,136.3,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.4,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C131,1730.7,130.7,1730.1,130.4,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.3,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C137.7,1738.6,137,1738.9,136.3,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.4,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C131,1735.4,130.7,1734.9,130.4,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M136.3,1714.5c1.4,2.4,1.4,5.4,0,7.8C135,1719.9,135,1716.9,136.3,1714.5L136.3,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M133.7,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C134.2,1720.5,133.2,1717.7,133.7,1714.9L133.7,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M131.3,1716.3c2.6,1,4.5,3.3,5,6C133.7,1721.3,131.8,1719,131.3,1716.3L131.3,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M129.6,1718.4c2.8,0,5.4,1.5,6.8,3.9C133.6,1722.3,131,1720.8,129.6,1718.4L129.6,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M128.6,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C133.7,1723.2,130.8,1722.7,128.6,1720.9L128.6,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M128.6,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C134.2,1724.1,131.2,1724.6,128.6,1723.7L128.6,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M129.6,1726.2c1.4-2.4,4-3.9,6.8-3.9C134.9,1724.7,132.3,1726.2,129.6,1726.2L129.6,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M131.3,1728.3c0.5-2.7,2.4-5,5-6C135.8,1725,133.9,1727.3,131.3,1728.3L131.3,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M133.7,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C136.8,1725,135.8,1727.9,133.7,1729.7L133.7,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M136.3,1730.1c-1.4-2.4-1.4-5.4,0-7.8C137.7,1724.7,137.7,1727.7,136.3,1730.1L136.3,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M139,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C138.4,1724.1,139.5,1726.9,139,1729.7L139,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M141.4,1728.3c-2.6-1-4.5-3.3-5-6C138.9,1723.3,140.9,1725.6,141.4,1728.3L141.4,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M143.1,1726.2c-2.8,0-5.4-1.5-6.8-3.9C139.1,1722.3,141.7,1723.8,143.1,1726.2L143.1,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M144.1,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C139,1721.4,141.9,1721.9,144.1,1723.7L144.1,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M144.1,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C138.5,1720.5,141.4,1720,144.1,1720.9L144.1,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M143.1,1718.4c-1.4,2.4-4,3.9-6.8,3.9C137.7,1719.9,140.4,1718.4,143.1,1718.4L143.1,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M141.4,1716.3c-0.5,2.7-2.4,5-5,6C136.8,1719.6,138.8,1717.3,141.4,1716.3L141.4,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M139,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C135.9,1719.6,136.9,1716.7,139,1714.9L139,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 136.3,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 149.7,
    y1: 1727.2,
    x2: 149.7,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M149.8,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C157.8,1754.2,154.3,1748.6,149.8,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.7,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C151,1733.8,150.4,1734.1,149.7,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.8,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C144.4,1730.7,144,1730.1,143.8,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.7,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C151,1738.6,150.4,1738.9,149.7,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.8,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C144.4,1735.4,144,1734.9,143.8,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M149.7,1714.5c1.4,2.4,1.4,5.4,0,7.8C148.4,1719.9,148.4,1716.9,149.7,1714.5L149.7,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M147,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C147.6,1720.5,146.6,1717.7,147,1714.9L147,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M144.7,1716.3c2.6,1,4.5,3.3,5,6C147.1,1721.3,145.2,1719,144.7,1716.3L144.7,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M142.9,1718.4c2.8,0,5.4,1.5,6.8,3.9C146.9,1722.3,144.4,1720.8,142.9,1718.4L142.9,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M142,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C147.1,1723.2,144.2,1722.7,142,1720.9L142,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M142,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C147.6,1724.1,144.6,1724.6,142,1723.7L142,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M142.9,1726.2c1.4-2.4,4-3.9,6.8-3.9C148.3,1724.7,145.7,1726.2,142.9,1726.2L142.9,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M144.7,1728.3c0.5-2.7,2.4-5,5-6C149.2,1725,147.3,1727.3,144.7,1728.3L144.7,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M147,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C150.2,1725,149.1,1727.9,147,1729.7L147,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M149.7,1730.1c-1.4-2.4-1.4-5.4,0-7.8C151.1,1724.7,151.1,1727.7,149.7,1730.1L149.7,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M152.4,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C151.8,1724.1,152.9,1726.9,152.4,1729.7L152.4,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M154.8,1728.3c-2.6-1-4.5-3.3-5-6C152.3,1723.3,154.2,1725.6,154.8,1728.3L154.8,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M156.5,1726.2c-2.8,0-5.4-1.5-6.8-3.9C152.5,1722.3,155.1,1723.8,156.5,1726.2L156.5,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M157.4,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C152.3,1721.4,155.3,1721.9,157.4,1723.7L157.4,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M157.4,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C151.9,1720.5,154.8,1720,157.4,1720.9L157.4,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M156.5,1718.4c-1.4,2.4-4,3.9-6.8,3.9C151.1,1719.9,153.7,1718.4,156.5,1718.4L156.5,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M154.8,1716.3c-0.5,2.7-2.4,5-5,6C150.2,1719.6,152.2,1717.3,154.8,1716.3L154.8,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M152.4,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C149.3,1719.6,150.3,1716.7,152.4,1714.9L152.4,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 149.7,
    cy: 1722.3,
    r: 3.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 162.3,
    y1: 1727.2,
    x2: 162.3,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M162.4,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C170.4,1754.2,166.9,1748.6,162.4,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.3,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C163.7,1733.8,163.1,1734.1,162.3,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C157,1730.7,156.7,1730.1,156.5,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.3,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C163.7,1738.6,163.1,1738.9,162.3,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C157,1735.4,156.7,1734.9,156.5,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M162.4,1714.5c1.4,2.4,1.4,5.4,0,7.8C161,1719.9,161,1716.9,162.4,1714.5L162.4,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M159.7,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C160.2,1720.5,159.2,1717.7,159.7,1714.9L159.7,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M157.3,1716.3c2.6,1,4.5,3.3,5,6C159.8,1721.3,157.8,1719,157.3,1716.3L157.3,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M155.6,1718.4c2.8,0,5.4,1.5,6.8,3.9C159.6,1722.3,157,1720.8,155.6,1718.4L155.6,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M154.6,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C159.7,1723.2,156.8,1722.7,154.6,1720.9L154.6,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M154.6,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C160.2,1724.1,157.3,1724.6,154.6,1723.7L154.6,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M155.6,1726.2c1.4-2.4,4-3.9,6.8-3.9C161,1724.7,158.3,1726.2,155.6,1726.2L155.6,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M157.3,1728.3c0.5-2.7,2.4-5,5-6C161.9,1725,159.9,1727.3,157.3,1728.3L157.3,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M159.7,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C162.8,1725,161.8,1727.9,159.7,1729.7L159.7,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M162.4,1730.1c-1.4-2.4-1.4-5.4,0-7.8C163.7,1724.7,163.7,1727.7,162.4,1730.1L162.4,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M165,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C164.5,1724.1,165.5,1726.9,165,1729.7L165,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M167.4,1728.3c-2.6-1-4.5-3.3-5-6C165,1723.3,166.9,1725.6,167.4,1728.3L167.4,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M169.1,1726.2c-2.8,0-5.4-1.5-6.8-3.9C165.1,1722.3,167.7,1723.8,169.1,1726.2L169.1,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M170.1,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C165,1721.4,167.9,1721.9,170.1,1723.7L170.1,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M170.1,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C164.5,1720.5,167.5,1720,170.1,1720.9L170.1,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M169.1,1718.4c-1.4,2.4-4,3.9-6.8,3.9C163.8,1719.9,166.4,1718.4,169.1,1718.4L169.1,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M167.4,1716.3c-0.5,2.7-2.4,5-5,6C162.9,1719.6,164.8,1717.3,167.4,1716.3L167.4,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M165,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C161.9,1719.6,162.9,1716.7,165,1714.9L165,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 162.4,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 175.7,
    y1: 1727.2,
    x2: 175.7,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M175.8,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C183.8,1754.2,180.3,1748.6,175.8,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.7,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C177.1,1733.8,176.4,1734.1,175.7,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.8,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C170.4,1730.7,170.1,1730.1,169.8,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175.7,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C177.1,1738.6,176.4,1738.9,175.7,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.8,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C170.4,1735.4,170.1,1734.9,169.8,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M175.7,1714.5c1.4,2.4,1.4,5.4,0,7.8C174.4,1719.9,174.4,1716.9,175.7,1714.5L175.7,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M173.1,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C173.6,1720.5,172.6,1717.7,173.1,1714.9L173.1,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M170.7,1716.3c2.6,1,4.5,3.3,5,6C173.1,1721.3,171.2,1719,170.7,1716.3L170.7,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M169,1718.4c2.8,0,5.4,1.5,6.8,3.9C173,1722.3,170.4,1720.8,169,1718.4L169,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M168,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C173.1,1723.2,170.2,1722.7,168,1720.9L168,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M168,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C173.6,1724.1,170.6,1724.6,168,1723.7L168,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M169,1726.2c1.4-2.4,4-3.9,6.8-3.9C174.3,1724.7,171.7,1726.2,169,1726.2L169,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M170.7,1728.3c0.5-2.7,2.4-5,5-6C175.2,1725,173.3,1727.3,170.7,1728.3L170.7,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M173.1,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C176.2,1725,175.2,1727.9,173.1,1729.7L173.1,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M175.7,1730.1c-1.4-2.4-1.4-5.4,0-7.8C177.1,1724.7,177.1,1727.7,175.7,1730.1L175.7,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M178.4,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C177.9,1724.1,178.9,1726.9,178.4,1729.7L178.4,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M180.8,1728.3c-2.6-1-4.5-3.3-5-6C178.3,1723.3,180.3,1725.6,180.8,1728.3L180.8,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M182.5,1726.2c-2.8,0-5.4-1.5-6.8-3.9C178.5,1722.3,181.1,1723.8,182.5,1726.2L182.5,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M183.5,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C178.4,1721.4,181.3,1721.9,183.5,1723.7L183.5,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M183.5,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C177.9,1720.5,180.8,1720,183.5,1720.9L183.5,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M182.5,1718.4c-1.4,2.4-4,3.9-6.8,3.9C177.2,1719.9,179.8,1718.4,182.5,1718.4L182.5,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M180.8,1716.3c-0.5,2.7-2.4,5-5,6C176.3,1719.6,178.2,1717.3,180.8,1716.3L180.8,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M178.4,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C175.3,1719.6,176.3,1716.7,178.4,1714.9L178.4,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 175.7,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 189.1,
    y1: 1727.2,
    x2: 189.1,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M189.2,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C197.2,1754.2,193.7,1748.6,189.2,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.1,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C190.5,1733.8,189.8,1734.1,189.1,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.2,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C183.8,1730.7,183.5,1730.1,183.2,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.1,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C190.5,1738.6,189.8,1738.9,189.1,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.2,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C183.8,1735.4,183.5,1734.9,183.2,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M189.1,1714.5c1.4,2.4,1.4,5.4,0,7.8C187.8,1719.9,187.8,1716.9,189.1,1714.5L189.1,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M186.5,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C187,1720.5,186,1717.7,186.5,1714.9L186.5,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M184.1,1716.3c2.6,1,4.5,3.3,5,6C186.5,1721.3,184.6,1719,184.1,1716.3L184.1,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M182.3,1718.4c2.8,0,5.4,1.5,6.8,3.9C186.4,1722.3,183.8,1720.8,182.3,1718.4L182.3,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M181.4,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C186.5,1723.2,183.6,1722.7,181.4,1720.9L181.4,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M181.4,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C187,1724.1,184,1724.6,181.4,1723.7L181.4,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M182.3,1726.2c1.4-2.4,4-3.9,6.8-3.9C187.7,1724.7,185.1,1726.2,182.3,1726.2L182.3,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M184.1,1728.3c0.5-2.7,2.4-5,5-6C188.6,1725,186.7,1727.3,184.1,1728.3L184.1,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M186.5,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C189.6,1725,188.6,1727.9,186.5,1729.7L186.5,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M189.1,1730.1c-1.4-2.4-1.4-5.4,0-7.8C190.5,1724.7,190.5,1727.7,189.1,1730.1L189.1,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M191.8,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C191.2,1724.1,192.3,1726.9,191.8,1729.7L191.8,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M194.2,1728.3c-2.6-1-4.5-3.3-5-6C191.7,1723.3,193.7,1725.6,194.2,1728.3L194.2,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M195.9,1726.2c-2.8,0-5.4-1.5-6.8-3.9C191.9,1722.3,194.5,1723.8,195.9,1726.2L195.9,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M196.8,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C191.8,1721.4,194.7,1721.9,196.8,1723.7L196.8,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M196.8,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C191.3,1720.5,194.2,1720,196.8,1720.9L196.8,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M195.9,1718.4c-1.4,2.4-4,3.9-6.8,3.9C190.5,1719.9,193.1,1718.4,195.9,1718.4L195.9,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M194.2,1716.3c-0.5,2.7-2.4,5-5,6C189.6,1719.6,191.6,1717.3,194.2,1716.3L194.2,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M191.8,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C188.7,1719.6,189.7,1716.7,191.8,1714.9L191.8,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 189.1,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 202.5,
    y1: 1727.2,
    x2: 202.5,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M202.6,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C210.6,1754.2,207,1748.6,202.6,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.5,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C203.8,1733.8,203.2,1734.1,202.5,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.6,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C197.2,1730.7,196.8,1730.1,196.6,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.5,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C203.8,1738.6,203.2,1738.9,202.5,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.6,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C197.2,1735.4,196.8,1734.9,196.6,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M202.5,1714.5c1.4,2.4,1.4,5.4,0,7.8C201.2,1719.9,201.2,1716.9,202.5,1714.5L202.5,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M199.8,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C200.4,1720.5,199.4,1717.7,199.8,1714.9L199.8,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M197.5,1716.3c2.6,1,4.5,3.3,5,6C199.9,1721.3,198,1719,197.5,1716.3L197.5,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M195.7,1718.4c2.8,0,5.4,1.5,6.8,3.9C199.7,1722.3,197.1,1720.8,195.7,1718.4L195.7,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M194.8,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C199.9,1723.2,196.9,1722.7,194.8,1720.9L194.8,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M194.8,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C200.4,1724.1,197.4,1724.6,194.8,1723.7L194.8,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M195.7,1726.2c1.4-2.4,4-3.9,6.8-3.9C201.1,1724.7,198.5,1726.2,195.7,1726.2L195.7,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M197.5,1728.3c0.5-2.7,2.4-5,5-6C202,1725,200.1,1727.3,197.5,1728.3L197.5,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M199.8,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C203,1725,201.9,1727.9,199.8,1729.7L199.8,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M202.5,1730.1c-1.4-2.4-1.4-5.4,0-7.8C203.9,1724.7,203.9,1727.7,202.5,1730.1L202.5,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M205.2,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C204.6,1724.1,205.7,1726.9,205.2,1729.7L205.2,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M207.6,1728.3c-2.6-1-4.5-3.3-5-6C205.1,1723.3,207,1725.6,207.6,1728.3L207.6,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M209.3,1726.2c-2.8,0-5.4-1.5-6.8-3.9C205.3,1722.3,207.9,1723.8,209.3,1726.2L209.3,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M210.2,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C205.1,1721.4,208.1,1721.9,210.2,1723.7L210.2,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M210.2,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C204.7,1720.5,207.6,1720,210.2,1720.9L210.2,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M209.3,1718.4c-1.4,2.4-4,3.9-6.8,3.9C203.9,1719.9,206.5,1718.4,209.3,1718.4L209.3,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M207.6,1716.3c-0.5,2.7-2.4,5-5,6C203,1719.6,205,1717.3,207.6,1716.3L207.6,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M205.2,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C202.1,1719.6,203.1,1716.7,205.2,1714.9L205.2,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 202.5,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 215.9,
    y1: 1727.2,
    x2: 215.9,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M215.9,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1H227c0.4,0,0.6-0.5,0.2-0.7 C224,1754.2,220.4,1748.6,215.9,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.8,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C217.2,1733.8,216.6,1734.1,215.8,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C210.6,1730.7,210.2,1730.1,210,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M215.8,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C217.2,1738.6,216.6,1738.9,215.8,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C210.6,1735.4,210.2,1734.9,210,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M215.9,1714.5c1.4,2.4,1.4,5.4,0,7.8C214.5,1719.9,214.5,1716.9,215.9,1714.5L215.9,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M213.2,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C213.8,1720.5,212.8,1717.7,213.2,1714.9L213.2,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M210.9,1716.3c2.6,1,4.5,3.3,5,6C213.3,1721.3,211.4,1719,210.9,1716.3L210.9,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M209.1,1718.4c2.8,0,5.4,1.5,6.8,3.9C213.1,1722.3,210.5,1720.8,209.1,1718.4L209.1,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M208.2,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C213.3,1723.2,210.3,1722.7,208.2,1720.9L208.2,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M208.2,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C213.8,1724.1,210.8,1724.6,208.2,1723.7L208.2,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M209.1,1726.2c1.4-2.4,4-3.9,6.8-3.9C214.5,1724.7,211.9,1726.2,209.1,1726.2L209.1,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M210.9,1728.3c0.5-2.7,2.4-5,5-6C215.4,1725,213.5,1727.3,210.9,1728.3L210.9,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M213.2,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C216.4,1725,215.3,1727.9,213.2,1729.7L213.2,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M215.9,1730.1c-1.4-2.4-1.4-5.4,0-7.8C217.3,1724.7,217.3,1727.7,215.9,1730.1L215.9,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M218.6,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C218,1724.1,219,1726.9,218.6,1729.7L218.6,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M220.9,1728.3c-2.6-1-4.5-3.3-5-6C218.5,1723.3,220.4,1725.6,220.9,1728.3L220.9,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M222.7,1726.2c-2.8,0-5.4-1.5-6.8-3.9C218.7,1722.3,221.3,1723.8,222.7,1726.2L222.7,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M223.6,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C218.5,1721.4,221.5,1721.9,223.6,1723.7L223.6,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M223.6,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C218,1720.5,221,1720,223.6,1720.9L223.6,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M222.7,1718.4c-1.4,2.4-4,3.9-6.8,3.9C217.3,1719.9,219.9,1718.4,222.7,1718.4L222.7,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M220.9,1716.3c-0.5,2.7-2.4,5-5,6C216.4,1719.6,218.3,1717.3,220.9,1716.3L220.9,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M218.6,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C215.4,1719.6,216.5,1716.7,218.6,1714.9L218.6,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 215.9,
    cy: 1722.3,
    r: 3.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st28",
    x1: 229.3,
    y1: 1727.2,
    x2: 229.3,
    y2: 1748.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M229.3,1748.6c-4.5,0-8,5.6-11.3,7.6c-0.3,0.2-0.2,0.7,0.2,0.7h11.1h11.1c0.4,0,0.6-0.5,0.2-0.7 C237.4,1754.2,233.8,1748.6,229.3,1748.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.2,1734.2c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C230.6,1733.8,230,1734.1,229.2,1734.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.4,1729.4c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C224,1730.7,223.6,1730.1,223.4,1729.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.2,1738.9c0.2-0.7,0.6-1.3,1-1.8s0.8-1,1.3-1.4s1-0.7,1.6-1s1.2-0.5,2-0.6c-0.2,0.7-0.6,1.3-1,1.8 s-0.8,1-1.3,1.4s-1,0.7-1.6,1C230.6,1738.6,230,1738.9,229.2,1738.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.4,1734.2c0.8,0.1,1.4,0.3,2,0.6c0.6,0.3,1.1,0.6,1.6,1s0.9,0.8,1.3,1.4c0.4,0.5,0.8,1.1,1,1.8 c-0.8-0.1-1.4-0.3-2-0.6c-0.6-0.3-1.1-0.6-1.6-1s-0.9-0.9-1.3-1.4C224,1735.4,223.6,1734.9,223.4,1734.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M229.3,1714.5c1.4,2.4,1.4,5.4,0,7.8C227.9,1719.9,227.9,1716.9,229.3,1714.5L229.3,1714.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M226.6,1714.9c2.1,1.8,3.1,4.6,2.7,7.4C227.2,1720.5,226.2,1717.7,226.6,1714.9L226.6,1714.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M224.3,1716.3c2.6,1,4.5,3.3,5,6C226.7,1721.3,224.8,1719,224.3,1716.3L224.3,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M222.5,1718.4c2.8,0,5.4,1.5,6.8,3.9C226.5,1722.3,223.9,1720.8,222.5,1718.4L222.5,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M221.6,1720.9c2.6-0.9,5.6-0.4,7.7,1.4C226.7,1723.2,223.7,1722.7,221.6,1720.9L221.6,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M221.6,1723.7c2.1-1.8,5.1-2.3,7.7-1.4C227.2,1724.1,224.2,1724.6,221.6,1723.7L221.6,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M222.5,1726.2c1.4-2.4,4-3.9,6.8-3.9C227.9,1724.7,225.3,1726.2,222.5,1726.2L222.5,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M224.3,1728.3c0.5-2.7,2.4-5,5-6C228.8,1725,226.9,1727.3,224.3,1728.3L224.3,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M226.6,1729.7c-0.5-2.7,0.6-5.6,2.7-7.4C229.8,1725,228.7,1727.9,226.6,1729.7L226.6,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M229.3,1730.1c-1.4-2.4-1.4-5.4,0-7.8C230.7,1724.7,230.7,1727.7,229.3,1730.1L229.3,1730.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M232,1729.7c-2.1-1.8-3.1-4.6-2.7-7.4C231.4,1724.1,232.4,1726.9,232,1729.7L232,1729.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M234.3,1728.3c-2.6-1-4.5-3.3-5-6C231.9,1723.3,233.8,1725.6,234.3,1728.3L234.3,1728.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M236.1,1726.2c-2.8,0-5.4-1.5-6.8-3.9C232.1,1722.3,234.7,1723.8,236.1,1726.2L236.1,1726.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M237,1723.7c-2.6,0.9-5.6,0.4-7.7-1.4C231.9,1721.4,234.9,1721.9,237,1723.7L237,1723.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M237,1720.9c-2.1,1.8-5.1,2.3-7.7,1.4C231.4,1720.5,234.4,1720,237,1720.9L237,1720.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M236.1,1718.4c-1.4,2.4-4,3.9-6.8,3.9C230.7,1719.9,233.3,1718.4,236.1,1718.4L236.1,1718.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M234.3,1716.3c-0.5,2.7-2.4,5-5,6C229.8,1719.6,231.7,1717.3,234.3,1716.3L234.3,1716.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M232,1714.9c0.5,2.7-0.6,5.6-2.7,7.4C228.8,1719.6,229.9,1716.7,232,1714.9L232,1714.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st40",
    cx: 229.3,
    cy: 1722.3,
    r: 3.9
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 670.1,
    y: 1377.8,
    width: 79.9,
    height: 115.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    className: "st41"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 708.3,
    cy: 1410.9,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 712.6,
    cy: 1425.2,
    r: 16.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 723.2,
    cy: 1398.4,
    r: 7.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 733.1,
    cy: 1403.8,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 730.4,
    cy: 1431.5,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 726.9,
    cy: 1415.5,
    r: 9.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 741.6,
    cy: 1416.7,
    r: 14.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 691.5,
    cy: 1416.9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 693.8,
    cy: 1429,
    r: 6.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 740.7,
    cy: 1430.6,
    r: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M693.4,1418.3c8.6,6,21.4,11.8,23.1,23.2c0.4,13,1.6,27.6-4.4,39.3c-0.1,0.2,0,0.3,0.2,0.3h17.2 c0.2,0,0.3-0.2,0.2-0.3c-3.9-8.1-3.6-16.5-5-25.3l0,0c-1.5-7.7-2-13.5,4.5-19.2c2.6-2.6,5.3-5.2,7.8-7.9 c2.6-1.9,4.3-3.3,5.5-6.8c0.5-1.3,0.5-2.4,0.4-2c-1.5,6.2-8.3,9.3-13,13.2c2-4.5,3.2-11,3.4-15.4c-1.6,5.3-1.9,12.1-5.5,16.5 c-2.2,1.5-4.9,2.5-6.3,5c-6.2-8.1-0.9-19.1-3.8-27.9c-1-3.4,0.6,3.9,0,5.6c0,4.5-1.3,8.9-2,13.3c-5.9-2.9-10.4-5.9-11.7-12.7 l0,0c-1.4-2.3-1.6-5.3-2.7-7.3c1.1,5.3,2.4,10.4,5.3,15.2c-3.1-1.3-7.1-4-9.7-5.2C696,1419.8,686.8,1413.6,693.4,1418.3z"
  })))))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M602.3,1335.8c-1.9,2.9-1.9,3.7-1.6,4.2c0.3,0.5,0.7,0.9,0,2.1s-1.3,3.3-1.2,4.2c0.1,0.8,0.1,1.2-0.2,1.2 c0,0,0.1,0.8,0,0.9h-3.1c0,0,0.3-0.7,1.2-1.7c0,0-0.2-2.7,0.3-4.1c0,0-0.5-0.6-1.1-1.4c-0.5-0.6-1-1.4-1.4-2.2l-2.9,0.2h-0.4 c0,0-2,1.1-5.5,1.4c-2.3,0.2-4.9,0.1-6.5-0.1c-0.9-0.1-1.5-0.1-1.5-0.1s-0.6,1.2-1.1,2.5c-0.4,1-0.8,2-0.8,2.6 c0,1.4,0.1,2.4-0.5,2.3l-0.2,0.5h-3.4c0,0,0.3-0.7,1.7-1.7c0,0,0.3-3,0.1-3.6c-0.1-0.6-0.7-2-0.6-2.2c0,0-2.4,0-2.8,0.1 c-0.5,0.2-2.2,0.4-3.4,0c0,0-1.8,0.5-3.7-0.5s-4.1-1-4.2-3.7c0,0,0.1-1,0.7-1c0.6,0,0.4,0.5,1.2,0.4s2.4-1.1,2.7-1.3 c0.3-0.2,0.4-0.6,0.4-0.6s-1.5,0.2-2.9-1.1c-1.4-1.3-2.1-0.7-2.3-1.6c-0.2-0.8,0.1-1,0.4-0.8c0.2,0.2,1.7,0.5,2.3,0.3 s2.7-0.9,4.8-0.3c0,0,4.9-3.5,8.8-5.4c3.9-1.8,11.1-4.2,19.2-2.5c2.3,0.5,4,1.4,5.2,2.2c2,1.4,3.2,3.7,3.3,6.1 C603.4,1332.8,603.2,1334.4,602.3,1335.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M580.3,1346.9l0.2,1h-2.7c0.9-0.6,0.8-1.8,0.7-2.6c-0.1-0.6-1-1.9-1.3-2.3c0.5-1.3,1.1-2.5,1.1-2.5 s0.6,0.1,1.5,0.1l-0.1,3c0,0,0.8,1.6,0.9,2.6C580.8,1347.2,580.3,1346.9,580.3,1346.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M596.6,1341.3c-0.4,0.6-1,1.5-1.3,2c-0.5,0.7-0.6,1.6-0.8,2.6s-1,1-1,1v1h-3.2c0,0,3.9-6.4,3.3-7.6 c-0.3-0.6-0.9-0.9-1.3-1.1l2.9-0.2C595.6,1339.9,596.1,1340.6,596.6,1341.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M601.2,1327.4c0.1-0.6,0.5-1.3,1.2-1.3c0.4,0,0.9,0.4,0.8,0.9c0,0.4-0.3,1-0.8,0.8c-0.4-0.3,0.2-1,0.6-1.1 c0.6-0.3,1.2,0.4,1,1c-0.1,0.2-0.2,0.3-0.3,0.4c0,0-0.1,0.1-0.2,0c-0.1,0-0.1-0.1-0.1-0.1c0-0.3,0.4-0.4,0.7-0.3 c0.2,0.1,0.3,0.2,0.3,0.4c0-0.4-0.5-0.5-0.8-0.3c-0.1,0.1-0.1,0.3,0,0.2c0.2-0.2,0.4-0.6,0.2-0.9c-0.3-0.7-1.1-0.3-1.2,0.3 c0,0,0,0.1,0,0l0,0l0,0c0.3-0.2,0.3-0.8-0.1-1c-0.5-0.2-0.8,0.5-0.8,0.9L601.2,1327.4L601.2,1327.4z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M557.2,1364c1.1,1.8,1.1,2.3,1,2.6c-0.2,0.3-0.5,0.5,0,1.2c0.4,0.7,0.8,2,0.7,2.5s-0.1,0.8,0.2,0.7 c0,0-0.1,0.5,0,0.5h1.9c0,0-0.2-0.4-0.7-1c0,0,0.1-1.6-0.2-2.5c0,0,0.3-0.3,0.6-0.8c0.3-0.4,0.6-0.9,0.8-1.3l1.8,0.1h0.2 c0,0,1.2,0.6,3.4,0.8c1.4,0.1,3,0,3.9,0c0.5,0,0.9-0.1,0.9-0.1s0.4,0.7,0.7,1.5c0.2,0.6,0.5,1.2,0.5,1.6c0,0.8,0,1.4,0.3,1.4 l0.1,0.3h2c0,0-0.2-0.4-1-1c0,0-0.2-1.8-0.1-2.2c0.1-0.3,0.4-1.2,0.4-1.3c0,0,1.4,0,1.7,0.1s1.3,0.2,2,0c0,0,1.1,0.3,2.2-0.3 s2.5-0.6,2.6-2.2c0,0,0-0.6-0.4-0.6s-0.2,0.3-0.7,0.2c-0.5-0.1-1.4-0.6-1.6-0.8c-0.2-0.1-0.3-0.4-0.3-0.4s0.9,0.1,1.8-0.7 c0.8-0.8,1.3-0.5,1.4-1s-0.1-0.6-0.2-0.5c-0.1,0.1-1,0.3-1.4,0.2c-0.4-0.1-1.6-0.5-2.9-0.2c0,0-2.9-2.1-5.3-3.2 c-2.4-1.1-6.7-2.5-11.6-1.5c-1.4,0.3-2.4,0.8-3.2,1.4c-1.2,0.9-1.9,2.2-2,3.7C556.5,1362.2,556.6,1363.2,557.2,1364z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M570.4,1370.7l-0.1,0.6h1.6c-0.6-0.4-0.5-1.1-0.4-1.5c0-0.4,0.6-1.1,0.8-1.4c-0.3-0.8-0.7-1.5-0.7-1.5 s-0.3,0-0.9,0.1v1.8c0,0-0.5,1-0.6,1.6C570.1,1370.9,570.4,1370.7,570.4,1370.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M560.6,1367.3c0.2,0.4,0.6,0.9,0.8,1.2c0.3,0.5,0.3,1,0.5,1.6c0.1,0.6,0.6,0.6,0.6,0.6v0.6h1.9 c0,0-2.3-3.9-2-4.6c0.2-0.3,0.5-0.5,0.8-0.6l-1.8-0.1C561.2,1366.5,560.9,1366.9,560.6,1367.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M557.8,1358.9c-0.1-0.3-0.3-0.8-0.7-0.8c-0.3,0-0.5,0.3-0.5,0.5s0.2,0.6,0.5,0.5c0.2-0.2-0.1-0.6-0.3-0.7 c-0.4-0.2-0.7,0.3-0.6,0.6c0,0.1,0.1,0.2,0.2,0.3h0.1l0.1-0.1c0-0.2-0.3-0.2-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.3c0-0.2,0.3-0.3,0.5-0.2 c0.1,0,0.1,0.2,0,0.1s-0.2-0.4-0.1-0.5c0.2-0.4,0.6-0.2,0.7,0.2l0,0l0,0l0,0c-0.2-0.1-0.2-0.5,0.1-0.6s0.5,0.3,0.5,0.5 L557.8,1358.9L557.8,1358.9z"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "502.7,1661.7 507.8,1654.1 516.9,1654 511.2,1646.8 513.9,1638.1 505.4,1641.3 497.9,1636  498.3,1645.2 491,1650.6 499.8,1653.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "506.5,1627 507.1,1621.2 512.1,1618.4 506.8,1616.1 505.7,1610.5 501.9,1614.8 496.2,1614.1  499.1,1619.1 496.7,1624.3 502.3,1623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "483.2,1620.4 482.2,1616.2 485.1,1613 480.7,1612.6 478.6,1608.9 476.9,1612.9 472.7,1613.8  476,1616.6 475.6,1620.9 479.2,1618.6  "
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "308.4,1661.7 303.4,1654.1 294.2,1654 299.9,1646.8 297.2,1638.1 305.8,1641.3 313.2,1636  312.9,1645.2 320.1,1650.6 311.4,1653.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "304.6,1627 304,1621.2 299,1618.4 304.3,1616.1 305.4,1610.5 309.2,1614.8 314.9,1614.1 312,1619.1  314.4,1624.3 308.8,1623  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "327.9,1620.4 329,1616.2 326.1,1613 330.4,1612.6 332.6,1608.9 334.2,1612.9 338.4,1613.8  335.1,1616.6 335.6,1620.9 331.9,1618.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 0.2,
    y: 105.5,
    width: 56.2,
    height: 110.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    className: "st44"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 8.7,
    cy: 127.4,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 12.1,
    cy: 138.6,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 20.4,
    cy: 117.5,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 28.1,
    cy: 121.8,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 26,
    cy: 143.5,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 23.2,
    cy: 131,
    r: 7.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.8,
    cy: 131.9,
    r: 11.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -4.5,
    cy: 132,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -2.7,
    cy: 141.6,
    r: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 34.1,
    cy: 142.8,
    r: 4.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M-3,133.2c6.7,4.7,16.7,9.2,18.1,18.2c0.3,10.2,1.2,21.6-3.5,30.8c-0.1,0.1,0,0.3,0.2,0.3h13.4 c0.1,0,0.2-0.1,0.2-0.3c-3.1-6.3-2.9-12.9-3.9-19.8l0,0c-1.2-6-1.6-10.6,3.5-15c2.1-2,4.1-4.1,6.1-6.2c2.1-1.5,3.3-2.6,4.3-5.3 c0.4-1,0.4-1.9,0.3-1.6c-1.1,4.9-6.5,7.3-10.2,10.3c1.5-3.6,2.5-8.6,2.7-12.1c-1.3,4.2-1.5,9.5-4.3,13c-1.7,1.2-3.9,2-4.9,3.9 c-4.9-6.4-0.7-14.9-3-21.8c-0.8-2.6,0.5,3.1,0,4.4c0,3.5-1,7-1.6,10.4c-4.6-2.3-8.1-4.7-9.2-9.9l0,0c-1.1-1.8-1.3-4.1-2.1-5.7 c0.9,4.1,1.8,8.2,4.1,11.9c-2.4-1-5.5-3.1-7.6-4C-1,134.3-8.2,129.4-3,133.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 0.2,
    y: 105.5,
    width: 56.2,
    height: 110.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    className: "st45"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 21.9,
    cy: 175.6,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 24.4,
    cy: 183.8,
    r: 9.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 30.4,
    cy: 168.4,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 36.1,
    cy: 171.5,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 34.6,
    cy: 187.4,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 32.5,
    cy: 178.2,
    r: 5.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 41,
    cy: 178.9,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 12.2,
    cy: 179,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 13.6,
    cy: 186,
    r: 3.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 40.5,
    cy: 186.8,
    r: 3.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M13.3,179.8c4.9,3.4,12.2,6.8,13.2,13.3c0.2,7.4,0.9,15.8-2.5,22.5c0,0.1,0,0.2,0.1,0.2H34 c0.1,0,0.2-0.1,0.1-0.2c-2.2-4.6-2.1-9.5-2.9-14.5l0,0c-0.9-4.4-1.2-7.8,2.6-11c1.5-1.5,3-3,4.5-4.5c1.5-1.1,2.5-1.9,3.2-3.9 c0.3-0.7,0.3-1.4,0.2-1.1c-0.8,3.6-4.7,5.4-7.4,7.6c1.1-2.6,1.8-6.3,2-8.8c-0.9,3-1.1,6.9-3.2,9.5c-1.3,0.8-2.8,1.4-3.6,2.9 c-3.6-4.7-0.5-10.9-2.2-16c-0.6-1.9,0.3,2.2,0,3.2c0,2.6-0.7,5.1-1.1,7.6c-3.4-1.7-6-3.4-6.7-7.3l0,0c-0.8-1.3-0.9-3-1.6-4.2 c0.7,3,1.4,6,3,8.7c-1.8-0.7-4.1-2.3-5.6-3C14.8,180.7,9.5,177.1,13.3,179.8z"
  })))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 265.3,
    y: 563.6,
    className: "st1",
    width: 13.1,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 242.7,
    y: 563.6,
    className: "st1",
    width: 13.1,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 218.9,
    y: 563.6,
    className: "st1",
    width: 13.1,
    height: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 563.6,
    className: "st1",
    width: 13.1,
    height: 2
  })), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M298.1,533.7c4.8,0,9.6,0,14.4,0c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.2,0.3-0.4,0.3 c-1,0.1-2,0-3,0.1c-0.5,0-1.1,0.1-1.5,0.4c-0.9,0.6-1.7,1.4-2.1,2.5c-0.1,0.3-0.1,0.7,0.1,0.7c0.3,0,0.6,0,0.8,0 c2.1,0,4.1,0,6.2,0c0.2,0,0.4-0.1,0.6,0c0.6,0.1,1,0.5,1.2,1.1c0.8,2,1.7,4,2.5,6c0.1,0.3,0.2,0.6,0.3,0.9 c0.2,1.1,0.4,2.1,0.7,3.2c0.1,0.3,0.1,0.6,0.2,1c0,3.4,0,6.9,0,10.3c0,0.1-0.1,0.1-0.1,0.2c-0.3,1.9-1.3,3.3-3.2,4 c-1,0.4-2,0.4-3.1,0.4c-12.8,0-25.7,0-38.5,0c-0.1,0-0.3,0-0.4,0c-0.7,0-1.2-0.4-1.2-1.1c0-1.9,0-3.8,0-5.7c0-0.4,0.2-0.6,0.6-0.6 c1.4-0.3,2.9-0.5,4.3-0.8c2-0.5,3.9-1.3,5.7-2.3c0.3-0.1,0.6-0.2,0.9-0.3c0.1,0,0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.5,0.9-0.7 c0.4-0.3,0.8-0.6,1.2-0.9c1.4-1.2,2.7-2.4,4.1-3.6c0.3-0.2,0.5-0.5,0.7-0.8c0.2-0.2,0.2-0.6,0.4-0.8c0.4-0.4,0.6-1.1,1.3-1.3 c0.1,0,0.1-0.3,0.1-0.4c0-0.1,0-0.3,0-0.4c0.4-0.7,0.7-1.4,1.1-2c0.9-1.4,1-3.3,2.2-4.6c0-0.5,0.5-0.6,0.8-0.7 c0.7-0.1,1.5-0.1,2.2-0.1c1.8,0,3.6-0.1,5.4-0.1c0.2,0,0.5,0.1,0.3-0.3c-0.5-1.9-1.9-3.1-3.9-3.3c-0.9-0.1-1.8-0.1-2.7-0.1 c-0.3,0-0.4-0.2-0.5-0.4c0-0.2,0-0.4,0.3-0.4C297.9,533.9,298,533.7,298.1,533.7z M296.6,547.3c0.6,0,1.2,0.2,1.9,0.2 c5.4,0,10.9,0,16.3,0c0.1,0,0.2,0,0.3,0c0.3-0.1,0.7-0.2,0.9-0.4c0.3-0.3,0.4-0.6,0.2-1.1c-0.3-0.8-0.6-1.6-0.9-2.4 c-0.3-0.8-0.8-1.6-1.1-2.4c-0.3-0.7-0.7-1-1.5-1c-1.6,0-3.3,0-4.9,0c-2.7,0-5.4,0-8.1,0c-0.6,0-1,0.2-1.3,0.8 c-0.5,1.2-1,2.4-1.5,3.6C296.6,545.4,296,546.2,296.6,547.3z M292.9,548.8c0,0-0.1,0-0.1,0c-0.3,0.4-0.6,0.8-1,1.1 c-0.6,0.6-1.1,1.1-1.7,1.7c-0.1,0.1-0.2,0.3-0.2,0.5c0,1.9,0,3.7,0,5.6c0,0.1,0,0.2,0,0.4c1-0.5,1.8-1,2.7-1.5 c0.1,0,0.1-0.2,0.1-0.3C292.9,553.9,292.9,551.4,292.9,548.8z M288.4,553.2c-1,0.6-1.9,1.3-2.8,1.9c-0.1,0.1-0.2,0.2-0.2,0.3 c0,1.5,0,3,0,4.6c0.1,0,0.2,0,0.3,0c0.8-0.3,1.7-0.7,2.5-1c0.1,0,0.2-0.2,0.2-0.3C288.4,556.8,288.4,555,288.4,553.2z  M300.6,555.2c-0.2-0.1-0.4-0.2-0.6-0.3c-0.7-0.4-1.4-0.3-2.1,0.2c-0.6,0.5-0.8,1.1-0.7,1.8c0.2,0.7,0.5,1.3,1.3,1.5 c0.8,0.1,1.5,0,2-0.6c0.5-0.6,0.6-1.4,0.2-2.1C300.7,555.5,300.7,555.3,300.6,555.2z M313.2,558.4c1.2,0,2.2-0.9,2.2-1.7 c-0.1-1.2-0.7-2-1.9-2c-1.2,0-1.8,0.7-1.9,1.8c-0.1,0.7,0.4,1.2,0.7,1.7C312.4,558.4,313,558.4,313.2,558.4z M281.5,561.2 c0.8-0.2,1.6-0.5,2.4-0.7c0.1,0,0.2-0.2,0.2-0.2c0-1.4,0-2.9,0-4.3c-0.1,0-0.2,0.1-0.2,0.1c-0.6,0.3-1.2,0.5-1.8,0.8 c-0.3,0.2-0.7,0.4-0.6,0.9c0.1,0.3,0,0.6,0,0.8C281.5,559.4,281.5,560.3,281.5,561.2z M278.1,562c0.7-0.1,1.3-0.3,1.9-0.4 c0.3,0,0.3-0.1,0.3-0.4c0-0.7,0-1.5,0-2.2c0-0.4,0-0.9,0-1.4c-0.7,0.2-1.2,0.4-1.8,0.6c-0.2,0.1-0.4,0.2-0.4,0.3 C278,559.6,278.1,560.8,278.1,562z M277,558.6c-0.3,0.1-0.6,0.1-0.8,0.2c-1,0.1-1,0.1-1,1.2c0,0.2,0,0.4,0,0.7c0,0.6,0,1.2,0,1.8 c0.7-0.1,1.3-0.2,1.9-0.3C277,560.9,277,559.7,277,558.6z M274.3,562.4c0-1.1,0-2.2,0-3.3c-0.5,0.1-1,0.1-1.5,0.2 c0,1.1,0,2.1,0,3.2C273.4,562.5,273.8,562.5,274.3,562.4z M305.2,536.7c0.5-0.6,1.1-1.3,1.7-2c-1.1,0-2.2,0-3.3,0 c0,0,0,0.1-0.1,0.1c0.2,0.1,0.4,0.3,0.5,0.4c0.1,0,0.1,0.1,0.1,0.2C304.5,535.9,304.9,536.3,305.2,536.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteAgrobachelor);
export default __webpack_public_path__ + "static/media/carte-agrobachelor.6e012d449357a53b481a70e2c0b1c1f0.svg";
export { ForwardRef as ReactComponent };